export const kr: { [key: string]: string } = {
  subscribe_with_click: '클릭 한 번으로 구독하기',
  subscribe: '클릭 한 번으로 구독하기',
  minimum_number_characters: '최소 2자 이상 입력해주세요',
  request_details: '요청 세부사항',
  form_title: '곧 연락드리겠습니다',
  form_required: '* 표시된 항목은 필수 입력 사항입니다',
  form_name_placeholder: '이름',
  form_email_placeholder: '이메일',
  form_phone_placeholder: '전화번호',
  form_company_placeholder: '회사명',
  form_submit: '제출하기',
  form_1: '개인정보 처리에 동의합니다',
  form_2: '개인정보 보호정책',
  validation_privacy_policy: '개인정보 보호정책에 동의해주세요',
  validation_phone: '유효한 전화번호가 아닙니다',
  validation_email: '잘못된 이메일 형식입니다',
  validation_required: '필수 항목이 입력되지 않았습니다',
  submit_error: '양식 저장 중 오류가 발생했습니다',
  footer_1: '우리의 파트너:',
  footer_2: '방법',
  footer_3: '제품',
  footer_4: '연락처:',
  footer_5: '법적 고지',
  footer_6: '개인정보 보호정책',
  footer_7: '시장 조사',
  about_us_1: '4Service 기업의 사회적 책임',
  about_us_2:
    '우리 팀 모든 구성원의 마음과 영혼에서 비롯됩니다. 우리는 모든 직원에게 친절함의 불꽃을 유지하고 세상을 조금 더 나은 곳으로 만들기 위해 최선을 다합니다',
  about_us_3: '4Service 기업의 사회적 책임',
  about_us_4:
    '우리 팀 모든 구성원의 마음과 영혼에서 비롯됩니다. 우리는 모든 직원에게 친절함의 불꽃을 유지하고 세상을 조금 더 나은 곳으로 만들기 위해 최선을 다합니다',
  about_us_5: 'Service Mania 비즈니스 게임',
  about_us_6: '어린이와 학생을 위한 사회 공헌 활동',
  about_us_7: '자선 / 자원봉사',
  about_us_8:
    '고아원, 노인 요양원, 우크라이나 군대를 위한 자원봉사. 우리가 하는 일 중 가장 감동적인 부분입니다',
  about_us_9: '동물 복지',
  about_us_10:
    '누구나 반려동물과 함께 우리 사무실을 방문할 수 있습니다. 우리는 보호소를 지원하고, 사료를 위한 기금을 모으며, 때때로 유기동물에게 새로운 집을 찾아줍니다',
  about_us_11: '4Service 그룹',
  about_us_12: '고객 경험을 관리하는 국제 조사 회사입니다.',
  about_us_13:
    '우리는 고객 중심 회사의 매출 증대와 비즈니스 개발을 위한 복합 프로젝트를 실행합니다.',
  about_us_14:
    '본사는 오스트리아 빈에 위치한 국제 리서치 홀딩입니다. 2001년에 설립되어 고객과 비즈니스, 서비스, 제품과 상호작용하는 사람들의 삶의 질을 향상시키기 위한 목적을 가지고 있습니다. 그래서 고객 서비스를 대표하는 회사로서 "Forservice"라는 이름이 선택되었습니다.',
  about_us_15:
    '우크라이나 키예프에서 4Service의 역사가 시작되었습니다. 미스터리 쇼핑 서비스의 선두 제공업체로 출발한 우리는 현재 52개국에서 고객 경험 전반을 분석하고 개선하기 위한 새로운 기회를 발굴하며 성공적으로 운영 중입니다.',
  about_us_16: '서비스라는 이름에서 태어나다',
  about_us_17: '우크라이나 외 첫 번째 사무실 설립',
  about_us_18: '본사 빈으로 이전',
  about_us_19: 'MSPA 엘리트 회원, 유럽 톱 10 에이전시',
  about_us_20: '9개국에 사무소 설립',
  about_us_21: '첫 디지털 프로젝트, Voicer',
  about_us_22: 'DesignThinkers Academy의 파트너',
  about_us_23: '첫 글로벌 CX 프로젝트',
  about_us_24: '미션',
  about_us_25:
    '우리는 전 세계의 고객 서비스를 향상시키는 것을 사명으로 합니다! 우리는 우리가 협업하는 사람들과 회사에서 일어나는 질적 변화에서 영감을 얻습니다.',
  about_us_26: '20년 이상의 고객 경험',
  about_us_27: '95개국',
  about_us_28: '우리는 전 세계 최고의 업계 경험을 수집하고 공유합니다',
  about_us_29: '본사는 빈에 위치',
  about_us_30: '국가들. 우리는 전 세계 최고의 업계 경험을 수집하고 공유합니다',
  about_us_31: '서비스 품질 등급',
  about_us_32: '유럽 톱 10 CX 에이전시 중 하나입니다',
  about_us_33: '오스트리아 내 대표 사무소 / 본사',
  about_us_34: '진행 중인 프로젝트',
  about_us_35: '당신의 미래 직장',
  about_us_36: '우리의 사무실',
  about_us_37:
    '4Service ™는 직원들을 위한 쾌적한 업무 환경 조성을 위해 노력합니다. 직원들은 현장, 재택 또는 하이브리드 방식으로 가장 편리하고 생산적인 방식으로 근무합니다. 휴식 공간, 무료 심리상담, 따뜻한 분위기를 제공합니다. 사람과 동물 모두 환영합니다.',
  about_us_38: '열정을 불어넣는 팀',
  about_us_39:
    '우리의 다국적 팀은 고객의 목소리에 귀 기울이며, 피드백을 반영하고 상호 성장을 위해 헌신합니다. 고객의 여정 맵은 신제품 출시나 목표 달성만큼 중요합니다. 우리는 지역 사회에 긍정적인 영향을 주고, 혁신적이고 사람 중심적인 솔루션을 제공하고자 합니다.',
  about_us_40: '전체',
  about_us_41: '경영진',
  about_us_42: '글로벌 팀',
  about_us_43: '제품 책임자',
  about_us_44: '우리의 파트너들',
  about_us_45:
    '고객 중심 기업의 판매 증대 및 비즈니스 개발을 위한 복잡한 프로젝트를 구현합니다',
  about_us_46:
    '25개국에 진출해 있으며 긍정적인 변화를 주도하는 창의적인 다학제 팀과 커뮤니티를 교육, 개발 및 촉진하는 것을 목표로 하는 선도적인 ‘디자인 주도’ 전문 교육 기관 중 하나입니다. 디자인 씽킹은 복잡한 문제에 대한 혁신적인 아이디어, 변화 및 솔루션을 개발하고 제공할 수 있게 해줍니다.',
  about_us_47:
    '이들의 미션은 팀과 개인에게 영감과 도전을 받을 수 있는 공간과 시간을 제공하고, ‘실천을 통해 학습’하며 창의적인 문제 해결 능력을 강화하고, 조직이 대담한 혁신을 시작할 수 있는 환경과 사고방식을 구축하도록 돕는 것입니다.',
  about_us_48:
    '미스터리 쇼핑 산업에 종사하는 기업들을 위한 대표 무역 협회입니다. 이 협회는 전 세계적으로 지역 기반으로 운영되며, 아메리카, 유럽/아프리카 및 아시아/태평양 지역에 지부가 있습니다. 회원사들은 미스터리 쇼핑 산업을 강화하기 위해 공동의 노력과 행동을 통해 하나로 뭉칩니다.',
  about_us_49:
    '비영리 회원 조직입니다. 회원들은 데이터 분석, 연구 및 인사이트가 사회, 조직 및 모든 사람의 삶을 개선할 수 있는 잠재력을 가지고 있다고 확신하는 커뮤니티를 형성합니다.',
  about_us_50:
    'ESOMAR의 본사는 네덜란드 암스테르담에 있습니다. ESOMAR는 1947년부터 회원을 통해 130개국 이상에 존재하고 있습니다.',
  about_us_51:
    '(UCCA)는 컨택 센터 및 고객 서비스 분야의 발전과 상호작용을 목표로 하는 민간 전문가 및 기업의 전문 커뮤니티입니다. UCCA의 철학은 최신 기술과 높은 기준을 기반으로 컨택 센터 산업의 문화를 높이는 것입니다.',
  about_us_52: '우크라이나 컨택 센터 협회는 2010년에 설립되었습니다',
  about_us_53:
    '세계 최고의 교육 경험을 연구하여 우크라이나 시장에 적응 및 활용합니다. 따라서 Academy DTEK는 INSEAD, IE 비즈니스 스쿨 및 스탠퍼드 대학교와 같은 세계적인 비즈니스 스쿨과 협력하고 있습니다.',
  about_us_54:
    'Academy DTEK는 D.Client School, ID School, Executive Education: Energy of Innovation, Power of Communications, DX School 디지털 프로그램, Effective Leader: Pre-MBA, Change Energy와 같은 고객 중심 및 혁신적인 문화를 개발하는 데 집중하고 있습니다.',
  about_us_55: '세르게이 파쉬코프스키',
  about_us_56: '빅토리아 스코르보타',
  about_us_57: '아르템 포민',
  about_us_58: '맥스 파프카',
  about_us_59: '국제 영업 관리자',
  bht_1: '브랜드 건강',
  bht_2: '트래킹',
  bht_3: '브랜드는 엄청난 힘을 가지고 있습니다',
  bht_4: '브랜드의 전반적인 성과를 확인하세요',
  bht_5: '소개',
  bht_6: '브랜드 헬스 트래킹이란?',
  bht_7:
    '시장 내 브랜드 상태에 대한 정보를 얻기 위해 일정한 주기로(2주마다, 매달 등) 수행되는 일종의 시장 조사입니다',
  bht_8:
    '인지도, 수요, 이미지, 소비자 특성, 브랜드 건강 등 지표를 기반으로 브랜드의 시장 상태를 평가합니다.',
  bht_9: '브랜드를 가장 자주 구매함',
  bht_10: '충성도 높은 고객',
  bht_11: '3개월간 브랜드를 구매함',
  bht_12: '레퍼토리 / 정기 고객',
  bht_13: '6개월간 브랜드를 구매함',
  bht_14: '단기 고객',
  bht_15: '1년간 브랜드를 구매함',
  bht_16: '장기 고객',
  bht_17: '브랜드를 알고 있으나 사용하거나 구매한 적 없음',
  bht_18: '인지하지만 고객 아님',
  bht_19: '브랜드에 대해 들어본 적 없음',
  bht_20: '비인지자',
  bht_21: '브랜드 구매자 프로필',
  bht_22: '브랜드 구축을 위한 장기적인 노력의 일관성 평가',
  bht_23: '브랜드에 대한 고객 인식 수준 측정',
  bht_24: '광고 및 정보 캠페인의 효과성 표시',
  bht_25: '광고 집중 기간이 경쟁사의 판매/마케팅 활동에 미치는 영향 평가',
  bht_26: '시장 변화가 지속되는 시기에 사업주에게 지속적인 통제 제공',
  bht_27: 'BHT로 해결할 수 있는 과제:',
  bht_28: '조사 요청',
  bht_29: '해결할 과제',
  bht_30: '예를 들어,',
  bht_31:
    '시장 점유율 측정을 위해 분기당 한 번의 BHT 세션만 필요하다면, 광고로 인한 브랜드 인식 측정을 위해서는 응답자 조사를 더 자주 수행해야 합니다.',
  bht_32: 'CATI',
  bht_33: '대면 인터뷰',
  bht_53: '인터뷰',
  bht_34: 'CAWI',
  bht_35: '해결할 과제',
  bht_36: '정보를 수집함으로써',
  bht_37:
    '대상 고객과 도달 난이도에 따라 브랜드 트래킹은 일반적으로 세 단계로 나뉩니다:',
  bht_38: '전통적인 방법과 현대적인 방법을 모두 사용하여 데이터를 수집합니다:',
  bht_39:
    '우리는 두 가지 모델을 사용합니다: 하나는 단순한 지표 세트, 다른 하나는 음식 및 서비스 산업과 같은 복잡한 산업을 대상으로 한 복잡한 모델입니다. 더 복잡한 모델은 최대 10개의 평가 지표를 포함한 심층 연구를 포함합니다.',
  bht_40: '우리는 다음을 제공합니다',
  bht_41: '초기 데이터의 통제',
  bht_42: '우리는 다음을 커버합니다',
  bht_43: '전국',
  bht_44: '해결책을 제공합니다',
  bht_45:
    '변화가 없는 시장/플레이어 수가 제한된 시장을 위한 (Brand Point Analyze)',
  bht_46: '왜 우리인가요?',
  bht_47: '왜 우리를 선택해야 하나요?',
  bht_50: '좋지 않은 결과',
  bht_51: '좋은 결과',
  bht_52: '보통 결과',
  cases_1:
    '도전 과제: 현대 전시장에서 고객의 전기차 구매 경험을 어떻게 향상시킬 수 있을까?',
  cases_2: '고객 여정 맵핑',
  cases_3: '아이디어 도출',
  cases_4: '정성적 조사',
  cases_5:
    '도전 과제: 매장에서 무엇을 바꿔야 고객들이 Oppo 브랜드에 관심을 가질 수 있을까요? (서비스 프로세스, 인테리어, 브랜드 인식 포함)',
  cases_6: '온라인 CJM',
  cases_7: 'UI 테스트',
  cases_8: '인터뷰',
  cases_9:
    '도전 과제: 매장에서 무엇을 바꿔야 고객들이 Oppo 브랜드에 관심을 가질 수 있을까요?',
  cases_10: '정성적 부분',
  cases_11: '아이디어 도출',
  cases_12: '정량적 부분',
  cases_13: '고객 여정 맵',
  cases_14: '사례들',
  cases_15: '전체',
  cases_16: '함께 멋진 사례를 만들어 봅시다',
  csi_1: '고객',
  csi_2: '만족 지수',
  csi_3: '소비자의',
  csi_4: '만족 및 불만족 이유 파악',
  csi_5: '고객 만족도에 대한 연구는',
  csi_6:
    '구매 결정 및 타겟 오디언스의 행동에 영향을 주는 요인, 원인 및 동기를 파악하는 것입니다.',
  csi_7: '고객 만족도 설문조사는',
  csi_8:
    '특정 서비스나 제품 전반에 대해 고객이 얼마나 만족 또는 불만족했는지를 보여줍니다.',
  csi_9: '만족도 조사는',
  csi_10: '회사 기존 고객 및 특정 제품/서비스 사용자들을 대상으로 진행됩니다.',
  csi_11: 'CSI란 무엇인가요?',
  csi_12:
    '고객 만족도는 귀사의 제품이나 서비스 구매에 있어 고객의 기대가 얼마나 충족되었는지를 측정합니다.',
  csi_13: '행복한 남자',
  csi_14: '소개',
  csi_15: '숨겨진 요인을 식별하세요',
  csi_16: '고객 만족도에 영향을 줄 수 있는',
  csi_17: '이유를 밝혀보세요',
  csi_18: '제품 및 서비스 수요의 증감 이유를 규명',
  csi_19: '회사의',
  csi_20: '비즈니스 프로세스 최적화',
  csi_21: '현대 소비자의 요구에 맞게',
  csi_22: '적용하기',
  csi_23: '효과적인 광고 메시지 형성',
  csi_24: '및 고객 요청에 맞는 제품 포지셔닝',
  csi_25: '해결할 과제들',
  csi_26: '고객 만족도 조사를 통해 해결할 수 있는 과제들',
  csi_27: '휴대폰을 든 남자',
  csi_28: '수학적 모델을 구축합니다',
  csi_29: '고객 만족도/충성도에 영향을 줄 수 있는 요인에 대한 (회귀 분석)',
  csi_30: '다음 항목을 최적화합니다',
  csi_31: '회사의 비즈니스 프로세스',
  csi_32: '계산된 고객 만족 지수(CSI)를 구축하고',
  csi_33: '선언적 지수와 비교합니다',
  csi_34: '우리는 다음과 같은 조사를 수행합니다',
  csi_35: 'B2B 및 B2C 세그먼트를 모두 대상으로.',
  csi_36: '설문지는 분석가 팀이 개발합니다',
  csi_37: '고객 개별 프로젝트에 맞춰 특별히 설계됨',
  csi_38: '왜 저희를 선택해야 하나요',
  csi_39: '왜 저희인가요?',
  csi_40: '정보 수집 방법:',
  main_1: '고객의 경험으로부터 배워 재무 성과를 개선한 고객들의 비율',
  main_2: 'CX 리서치 및 컨설팅 서비스: 귀사의 비즈니스를 360°로 조망합니다',
  main_3: '귀사의 비즈니스를 지원하는 다양한 솔루션 및 도구를 확인해보세요',
  main_4: '제품',
  main_5:
    '정성적 리서치는 개념, 의견 또는 경험을 이해하기 위한 비수치적 데이터의 수집 및 분석입니다',
  main_6:
    '정량적 리서치 방법은 설문조사, 설문지, 여론조사를 통해 수집된 데이터의 객관적 측정 및 수치 분석입니다',
  main_7:
    '미스터리 쇼핑은 고객과 회사 또는 조직 간의 상호작용을 사전에 정의된 시나리오에 따라 측정 및 모니터링하는 시장 조사 기법입니다',
  main_8:
    '피드백 관리 시스템. 고객의 목소리를 하나의 시스템에 담은 고객 피드백 관리 시스템',
  main_9:
    'AI 기반 콘텐츠 인텔리전스 플랫폼으로 오디언스로부터 통찰력을 제공합니다',
  main_10: '성과 관리 소프트웨어. 판매 증가를 위한 게임화된 애플리케이션',
  main_11: '가격 모니터링은 경쟁사의 가격을 수집, 처리 및 분석하는 과정입니다',
  main_12:
    '고객 중심의 서비스 및 제품을 설계하는 것입니다. 이 프로세스는 고객의 니즈와 기대에서 출발하여 작동 방식으로의 균형 잡힌 전환을 포함합니다',
  main_13:
    '우리의 분석 팀은 여러 고객을 통해 입증된 가장 최신의 근본적인 접근 방식을 적용합니다',
  main_14: '방법론',
  main_15: '고객 여정 맵',
  main_16:
    '고객 여정 맵핑(CJM)은 타겟 오디언스를 정의하고 그들의 니즈와 환경을 이해한 후, 몰입감 있는 경험을 제공하기 위한 계획을 수립하는 것입니다',
  main_17: 'CJM',
  main_18: '순추천지수',
  main_19:
    '순추천지수(NPS)는 고객 경험 지표의 골드 스탠다드로, 한 가지 질문을 기반으로 합니다: "이 조직/제품/서비스를 추천할 가능성은 얼마나 되십니까?"',
  main_20: 'NPS',
  main_21: '브랜드 건강 추적',
  main_22:
    '브랜드 건강 추적(BHT) 조사는 브랜드 인지도 및 사용, 브랜드 포지셔닝, 브랜드 성과를 측정할 수 있습니다',
  main_23: 'BHT',
  main_24: '인사 연구',
  main_25:
    '인사 연구는 인사 관행과 성과를 평가하고 현재의 개발 및 관리에 대한 상세한 분석을 제공합니다',
  main_26: 'HR 연구',
  main_27: '고객 만족도 지수',
  main_28:
    '고객 만족도 지수(CSI)는 귀사의 제품/서비스에 대해 고객이 얼마나 만족하고 있는지를 나타내는 점수입니다.',
  main_29: 'CSI',
  main_30: 'UX 테스트',
  main_31:
    '사용성(UX) 테스트는 실제 사람들이 웹사이트, 앱 또는 다른 제품과 상호작용하고 그 행동과 반응을 관찰하는 방법입니다',
  main_32: '왜 우리인가',
  main_33:
    '우리의 사명은 기업이 효과적인 고객 경험을 제공할 수 있도록 돕는 것입니다',
  main_34: '품질에 집중',
  main_35: '우리는 품질을 통제합니다',
  main_36: '연구 데이터에 관해서는. 모든 데이터 세트를 고객에게 제공합니다',
  main_37: '비용 효율적',
  main_38: '우리의 경험, 자원 및 간소화된',
  main_39: '비즈니스 프로세스를 통해 시간과 비용을 절약할 수 있습니다',
  main_40: '스마트 솔루션',
  main_41: '우리는 다양한 기술',
  main_42: '및 도구를 사용하여 귀하의 특정 문제를 해결합니다',
  main_43: '품질에 집중',
  main_44: '우리는 품질을 통제합니다',
  main_45: '연구 데이터에 관해서는. 모든 데이터 세트를 고객에게 제공합니다',
  main_46: '비용 효율적',
  main_47: '우리의 경험, 자원 및 간소화된',
  main_48: '비즈니스 프로세스를 통해 시간과 비용을 절약할 수 있습니다',
  main_49: '스마트 솔루션',
  main_50: '우리는 다양한 기술',
  main_51: '및 도구를 사용하여 귀하의 특정 문제를 해결합니다',
  main_52: '현금 & 캐리',
  main_53: '전자 제품',
  main_54: '럭셔리/프리미엄',
  main_55: '외식 및 환대',
  main_56: '소매',
  main_57: '자동차',
  main_58: '패션',
  main_59: '은행',
  main_60: '여행 및 레저',
  main_61: '시계 및 보석',
  main_62: '가전 및 생활용품',
  main_63: '블로그',
  main_64: '더 흥미로운 게시물을 읽으려면 블로그로 이동하세요',
  main_65: '소매 감사',
  main_66:
    '매장 또는 브랜드에 대한 자세한 데이터를 수집하고, 성장 장벽을 분석하며, 이를 극복하기 위한 효과적인 전략을 수립합니다',
  main_73: '일지 연구',
  main_74:
    '일지 연구는 장기적인 경험과 반복 활동을 탐색하는 데 유용합니다. 시간이 지남에 따라 사용자의 변화하는 경험과 라이프스타일을 추적하고 통찰력을 얻을 수 있습니다.',
  main_75: '직원 경험(EX)',
  main_76:
    '직원 경험(EX) 방법론은 조직이 직원의 기대와 비즈니스 목표에 부합하는 더 나은 프로세스, 문화 및 환경을 설계하도록 돕는 전략적 접근 방식으로, 궁극적으로 직원의 복지와 회사 성과를 향상시킵니다',
  main_77: 'CATI',
  main_78: '컴퓨터 지원 전화 인터뷰(CATI)',
  main_79:
    'CATI는 고객 만족도, 직원 몰입도, 시장 및 사회 조사 등 다양한 비즈니스 요구에 맞춰 고품질 데이터를 수집할 수 있는 유연하고 효율적인 조사 방법으로, 정확하고 시의적절하며 실행 가능한 인사이트를 보장합니다',
  cjm_1: '고객',
  cjm_2: '여정 지도',
  cjm_3: '고객의 세계에 들어가 그들의 경험을 공유하세요',
  cjm_4: '고객 여정 지도란?',
  cjm_5:
    'CJM은 다양한 채널을 통해 일정 기간 동안 제품, 서비스, 회사 또는 브랜드와의 소비자 상호작용의 시각화된 이력을 제공합니다.',
  cjm_6:
    '이를 통해 기업은 고객 상호작용의 경험을 객관적으로 분석하고, 발생하는 장벽을 수정 및 제거하며, 제품 개선을 위한 권장 사항을 제안할 수 있습니다.',
  cjm_7: '타겟 고객 설정, 세분화',
  cjm_8: '고객 상호작용 단계 식별',
  cjm_9: '주요 고객 상호작용 채널 식별',
  cjm_10: '고객 경험 조사',
  cjm_11: '장벽 분석 및 최적화 가설 수립',
  cjm_12: '가설 실행 및 테스트',
  cjm_13: '고객 여정 지도 설계는 다음 단계로 구성됩니다:',
  cjm_14: '고객 여정 지도는 다음을 보여줍니다:',
  cjm_15:
    'CJM은 다양한 채널을 통해 일정 기간 동안 제품, 서비스, 회사 또는 브랜드와의 소비자 상호작용의 시각화된 이력을 제공합니다.',
  cjm_16: '우리는 팀워크를 보장합니다',
  cjm_17: '분석가와 디자이너 간의 협업',
  cjm_18: '우리는 개별적인',
  cjm_19: '고객 맞춤형 접근 방식을 제공합니다',
  cjm_20: '전체적으로 늘릴 수 있어요',
  cjm_21:
    '서비스/제품에 대한 고객 만족도와 궁극적으로 회사에 대한 충성도를 높입니다',
  cjm_22: '우리는 보장합니다',
  cjm_23:
    '소비자의 여정 최적화를 보장하고 회사의 비즈니스 프로세스를 고려합니다',
  cjm_24: '우리는 고객에게 제공합니다',
  cjm_25:
    'CATI, CAWI, 포커스 그룹, 심층 인터뷰, 전문가 인터뷰, 민족지학 등 결합된 접근 방식을 사용할 수 있는 기회를 제공합니다',
  cjm_26: '왜 우리를 선택해야 할까요?',
  methods_hr_1: '인사(HR) 연구',
  methods_hr_2:
    '팀에 대한 객관적인 통찰을 얻고 HR 성과를 개선할 방법을 찾습니다',
  methods_hr_3: 'HR 연구가 필요한 몇 가지 이유',
  methods_hr_4: '면접을 받은 직원 중',
  methods_hr_5: '실행된 HR 프로젝트',
  methods_hr_6: '실시된 직원 교육 세션',
  methods_hr_7: '고객 경험 및 직원 연구를 위한 유럽 선도 기업',
  methods_hr_8: '숫자로 본 4service HR 연구',
  methods_hr_9:
    '직원 생애 주기의 각 단계에서 문제 및 약점을 식별: 검색/채용/온보딩/경력 개발/재인증',
  methods_hr_10:
    '어떤 상황에서 급여 인상 및 보너스를 제공해야 하는지 알기 위해',
  methods_hr_11: '직원 불만족을 예측하거나 해결책을 제공해야 할 때',
  methods_hr_12:
    'HR 정책, 프로그램 및 관행의 새로운 평가 방법을 통해 HR 연구가 가능합니다',
  methods_hr_13: '회사 직원의 정신 건강을 향상시키기 위해',
  methods_hr_14: '목표 지향적 접근 방식을 통해 생산성을 향상시키고자 할 때',
  methods_hr_15: '국제적 및/또는 원격 팀이 있는 경우 이를 관리하기 위해',
  methods_hr_16:
    '잠재적인 직원에게 귀사의 고용주 브랜드가 얼마나 매력적인지 이해하기 위해',
  methods_hr_17: '직원 만족도',
  methods_hr_18: 'HR 브랜딩 연구',
  methods_hr_19: '문화적 다양성',
  methods_hr_20: '보상 및 급여 계획',
  methods_hr_21: '팀 참여도 및 충성도',
  methods_hr_22: '보호 계층 직원',
  methods_hr_23: '연구 분야',
  methods_hr_24: '솔루션 1',
  methods_hr_25: 'eNPS, 직원 만족도, 직원 충성도',
  methods_hr_26: '우리가 측정하는 항목:',
  methods_hr_27: '충성도:',
  methods_hr_28:
    '직원 충성도, 미래 행동 예측, 충성도에 영향을 미치는 요인의 가중치 결정',
  methods_hr_29: '몰입도:',
  methods_hr_30: '업무에 대한 직원의 몰입, 결과 및 성과에 대한 관심',
  methods_hr_31: '참여도:',
  methods_hr_32: '직원 가치와 회사 가치의 일치 여부 식별',
  methods_hr_33: '신뢰 360:',
  methods_hr_34:
    '경영진, 동료, 부하직원에 대한 신뢰, 고용주 전략 및 정책에 대한 신뢰',
  methods_hr_35: '만족도:',
  methods_hr_36:
    '각 회사 고유의 요인 정의, 충성도에 영향을 미치는 주요 요인별 만족도 평가',
  methods_hr_37: '솔루션 2',
  methods_hr_38: '고용주 브랜딩',
  methods_hr_39: '내부 고용주',
  methods_hr_40:
    '브랜드 분석 (직원, 이해관계자, 내부 채용 담당자 및 HR 전문가 설문조사)',
  methods_hr_41: '외부 고용주 분석',
  methods_hr_42:
    '(경쟁사 EVP 분석, 외부 채용 담당자 설문조사, 구직자 설문조사)',
  methods_hr_43: '브랜드 인지도 및 평판',
  methods_hr_44: '분석',
  methods_hr_45: '고용주의 존재감',
  methods_hr_47: '고용주 추천',
  methods_hr_48: '수집',
  methods_hr_49: '경쟁 벤치마킹',
  methods_hr_50: '다음과 같은 주요 요인을 기준으로',
  methods_hr_51: '급여,',
  methods_hr_52: '작업 환경, 분위기, 업무 특성',
  methods_hr_53: '필요 및 기대 분석',
  methods_hr_54: '구직자의',
  methods_hr_55: '심층 인터뷰,',
  methods_hr_56: '데스크 리서치 및 정량적 조사가 사용됩니다',
  methods_hr_57: '솔루션 3',
  methods_hr_58: '직원 여정 맵/미스터리 직원',
  methods_hr_59: '구직자 여정을 구축하고 다음을 식별',
  methods_hr_60:
    '검색의 주요 단계, 커뮤니케이션 채널, 선택 기준 및 구직자 평가',
  methods_hr_61: '모든 단계를 모니터링',
  methods_hr_62:
    '미스터리 구직자와의 커뮤니케이션 채널 (면접 예약, 면접 진행, 회사 인턴십 포함)',
  methods_hr_63: '식별',
  methods_hr_64: '채용 및 온보딩 프로세스의 약점',
  methods_hr_65: '개선을 위한 권장 사항,',
  methods_hr_66: '업계 리더와의 벤치마킹',
  mystery_shopping_1: '미스터리',
  mystery_shopping_2: '쇼핑',
  mystery_shopping_3: '실제 고객을 통해 귀하의 서비스를 평가하세요',
  mystery_shopping_4: '기준을 확인하고 직원을 평가하며 고객과 더 가까워지세요',
  mystery_shopping_5:
    '우리는 MSPA 유럽의 전문 미스터리 쇼핑 제공자 협회의 엘리트 회원입니다',
  mystery_shopping_6: '경험',
  mystery_shopping_7: '월간 방문 수',
  mystery_shopping_8: '전 세계 미스터리 쇼퍼',
  mystery_shopping_9: '진행 중인 프로젝트',
  mystery_shopping_10: '오스트리아 본사 사무소',
  mystery_shopping_11: '유럽 미스터리 쇼핑 제공자',
  mystery_shopping_12: '서비스 품질 등급',
  mystery_shopping_13: '설문지',
  mystery_shopping_14: '소프트웨어',
  mystery_shopping_15: '쇼퍼 프로필',
  mystery_shopping_16: '검증 및 이의 제기',
  mystery_shopping_17: '분석',
  mystery_shopping_18:
    '이 5단계를 통해 4Service는 미스터리 쇼핑 서비스의 품질을 보장합니다',
  mystery_shopping_19: '프로그램',
  mystery_shopping_20: '4Service의 미스터리 쇼핑 프로그램의 5가지 요소',
  mystery_shopping_21: '설문지:',
  mystery_shopping_22: '귀하의 프로그램의 핵심',
  mystery_shopping_23: '이 프로그램 부분은 모든 이해 관계자가 볼 수 있습니다',
  mystery_shopping_24: '최고 경영진용.',
  mystery_shopping_25: '프로세스의 모든 주요 단계와 세부사항을 보여줍니다',
  mystery_shopping_26: '직원용.',
  mystery_shopping_27: '고용주가 직원에게 기대하는 바를 반영합니다',
  mystery_shopping_28: '미스터리 쇼퍼용.',
  mystery_shopping_29: '혼란과 편향을 피하기 위해 명확하고 구조화되어 있음',
  mystery_shopping_30: 'Shopmetrics 소프트웨어:',
  mystery_shopping_31: '사용자 친화적이고 혁신적임',
  mystery_shopping_32: '장점:',
  mystery_shopping_33: '비즈니스 프로세스 및 소프트웨어와',
  mystery_shopping_34: '통합됨',
  mystery_shopping_35: 'GDPR 기반',
  mystery_shopping_36: '개인정보 보호 관리 도구 키트',
  mystery_shopping_37: '상세한',
  mystery_shopping_38: '법적 준수 패키지',
  mystery_shopping_39: '보고서',
  mystery_shopping_40: '작성 도구',
  mystery_shopping_41: '관리',
  mystery_shopping_42: '접근 수준의',
  mystery_shopping_43: '대부분의 설문지는',
  mystery_shopping_44: '1시간 이내에 완료됩니다',
  mystery_shopping_45: '쇼퍼 프로필:',
  mystery_shopping_46: '전 세계 200,000명 이상의 미스터리 쇼퍼',
  mystery_shopping_47:
    '주요 기준: 귀하의 타깃 고객과 최대한 유사하며 귀하 또는 경쟁사와의 이전 경험이 있음',
  mystery_shopping_48: '쇼퍼 교육:',
  mystery_shopping_49: '도입 교육 테스트',
  mystery_shopping_50: 'Skype/전화 통화',
  mystery_shopping_51: '평가 테스트(선택 사항)',
  mystery_shopping_52: '검증 및 이의 제기',
  mystery_shopping_53: '검증',
  mystery_shopping_54: '시스템',
  mystery_shopping_55: '100% 보고서는',
  mystery_shopping_56: '검증 팀에 의해 검토됩니다',
  mystery_shopping_57: '추가 전화',
  mystery_shopping_58: '설명 요청을 위해',
  mystery_shopping_59: '오디오 기록',
  mystery_shopping_60: '방문 후 가장 중요한 문제를 기록하기 위해',
  mystery_shopping_61: '직원 사기',
  mystery_shopping_62: '예방 시스템',
  mystery_shopping_63: '이의 제기',
  mystery_shopping_64: '시스템',
  mystery_shopping_65: '어떤 쇼퍼 평가든',
  mystery_shopping_66: '직원이 웹사이트에서 직접 이의 제기할 수 있습니다',
  mystery_shopping_67: '각 이의 제기는',
  mystery_shopping_68: '현지 검증 팀에 의해 고려되고 응답됩니다',
  mystery_shopping_69: '이의 제기 통계를',
  mystery_shopping_70: '확인할 수 있습니다',
  mystery_shopping_71: '분석.',
  mystery_shopping_72: '보고서는 직접 제공되며 다음을 포함합니다:',
  mystery_shopping_73: '회사의',
  mystery_shopping_74: '문제 지점과 우려사항',
  mystery_shopping_75: '동태',
  mystery_shopping_76: '부서 및 섹션별',
  mystery_shopping_77: '상관관계',
  mystery_shopping_78: '기준 충족과 고객 만족도 간의',
  mystery_shopping_79: '벤치마킹',
  mystery_shopping_80: '경쟁사와 비교하여',
  mystery_shopping_81: '실용적인',
  mystery_shopping_82: '서비스 개선에 대한 권장 사항',
  mystery_shopping_83: '우리가 다른 점은 무엇입니까?',
  mystery_shopping_84: '우리는 아이디어 발상 세션을 수행합니다',
  mystery_shopping_85:
    '우리는 무엇을 해야 할지 추천할 뿐만 아니라, 여러분과 함께 서비스 문제를 해결할 실용적인 방법을 모색합니다.',
  mystery_shopping_86:
    '아이디어 발상 세션은 다음을 가능하게 하는 강력한 도구입니다:',
  mystery_shopping_87: '제품 또는 서비스 개선 방향을 개발하기 위해',
  mystery_shopping_88: '새로운 수익 기회 및 비즈니스 전략을 탐색하기 위해',
  mystery_shopping_89: '복잡한 고객 중심 과제에 대한 해결책을 찾기 위해',
  mystery_shopping_90: '고객의 고충을 기쁨으로 전환하기 위해',
  mystery_shopping_91: '우리는 영상 인터뷰를 수행합니다',
  mystery_shopping_92:
    '우리는 단순히 설문지를 수집하는 것이 아니라, 쇼퍼들로부터 실시간 코멘트를 받습니다',
  mystery_shopping_93: '우리는 다음을 위해 이렇게 합니다:',
  mystery_shopping_94:
    '우리의 퍼실리테이터가 심층 인터뷰를 수행하고 효과적인 피드백을 제공합니다',
  mystery_shopping_95: '고객의 관점에서 경험을 확인합니다',
  mystery_shopping_96: '콘텐츠 마케팅 전략을 강화합니다',
  mystery_shopping_97: '고객 행동을 예측합니다',
  mystery_shopping_98: '고객 여정 지도를 설계합니다',
  mystery_shopping_99:
    '고객 여정 매핑은 고객의 입장에서 필요와 문제를 이해할 수 있도록 도와줍니다.',
  mystery_shopping_100:
    '고객 여정을 만드는 것은 다음을 위한 최고의 방법입니다:',
  mystery_shopping_101: '고객의 관점에서 경험을 확인합니다',
  mystery_shopping_102: '콘텐츠 마케팅 전략을 강화합니다',
  mystery_shopping_103: '고객 행동을 예측합니다',
  mystery_shopping_104: '서비스 또는 커뮤니케이션의 간극을 식별합니다',
  mystery_shopping_105: '우리는 다양한 유형의 미스터리 쇼핑을 제공합니다',
  mystery_shopping_106: '미스터리 쇼핑의 유형',
  mystery_shopping_107: '미스터리 콜러',
  mystery_shopping_108:
    '전화상 서비스 품질을 판단하기 위해 귀사의 매니저 또는 콜센터에 전화를 겁니다',
  mystery_shopping_109: '럭셔리 미스터리 쇼핑',
  mystery_shopping_110: '특별한 쇼퍼들이 고급 매장에서 서비스를 확인합니다',
  mystery_shopping_111: '경쟁사 방문',
  mystery_shopping_112: '경쟁사의 운영 방식을 이해하는 가장 쉬운 방법',
  mystery_shopping_113: '미스터리 직원',
  mystery_shopping_114:
    '직원의 전체 여정(채용, 적응, 사무 프로세스 등)을 이해하는 데 도움이 됩니다',
  mystery_shopping_115: '동기 부여 방문',
  mystery_shopping_116:
    '추가 서비스 및/또는 제품 제공, 특정 제품 판매를 자극하는 데 유용한 도구',
  mystery_shopping_117: '온라인 미스터리 쇼퍼',
  mystery_shopping_118:
    '온라인 쇼핑몰, 웹사이트 또는 앱에서 고객 경험을 시뮬레이션하고 측정합니다',
  mystery_shopping_119: '판매 및 프로모션 확인',
  mystery_shopping_120:
    '모든 매장에서 프로모션이 어떻게 표시되는지 및 얼마나 효과적인지 파악하는 데 도움이 됩니다',
  mystery_shopping_121: '구매 및 반품 방문',
  mystery_shopping_122:
    '구매부터 반품까지의 전체 과정을 반영하여 고객 경험을 개선하는 데 도움이 됩니다',
  mystery_shopping_123: '> 20년',
  nps_1: '순추천',
  nps_2: '지수',
  nps_3: '고객 충성도를 측정하고 추적하며 향상시킵니다',
  nps_4: '그들은 0에서 6점 사이로 응답합니다.',
  nps_5:
    '그들은 나쁜 경험을 했을 수 있으며, 다시 구매하지 않을 가능성이 높고, 다른 사람들에게도 구매하지 말라고 할 수 있습니다.',
  nps_6: '7점에서 8점 사이로 평가한 응답자입니다.',
  nps_7: '서비스에 만족하지만 홍보자로 간주할 만큼은 아닙니다.',
  nps_8: '귀사의 비즈니스를 9 또는 10으로 평가한 응답자입니다.',
  nps_9:
    '이것은 그들이 친구나 동료에게 귀사를 추천할 가능성이 높다는 것을 의미하며, 따라서 귀사를 대변하여 옹호하는 것입니다.',
  nps_10: 'NPS란 무엇입니까?',
  nps_11: '고객 인식을 단 하나의 간단한 질문으로 측정합니다:',
  nps_12: '[조직/제품/서비스]를 친구나 동료에게 추천할 가능성은 얼마나 됩니까?',
  nps_13: '우리 회사에 필요한가요?',
  nps_14: 'NPS는 귀하의 지속 가능한 성장입니다',
  nps_15: '고객 충성도의 역학을 이해합니다',
  nps_16: '직원을 동기 부여합니다',
  nps_17: '제품별 관계를 이해합니다',
  nps_18: '고객이 귀사와 경쟁사를 어떻게 대하는지 비교합니다',
  nps_19: 'NPS로 무엇을 할 수 있습니까?',
  nps_20: 'NPS가 관련 있는 비즈니스 유형은 무엇입니까?',
  nps_21: '정보 수집 방법:',
  nps_22: 'NPS와 함께 작업할 때 우리의 권장 사항',
  nps_23:
    '이는 비추천자를 홍보자로 전환하는 데 도움이 되는 지침을 개발한다는 의미입니다',
  nps_24: '"폐쇄 루프" 방식으로 작업합니다',
  nps_25: 'NPS는 고객 충성도의 변화를 추적하는 추적 조사입니다',
  nps_26: '우리는 역학을 모니터링합니다',
  nps_27:
    '보다 심층적인 분석을 위해 항상 귀하의 분야에서 경쟁사를 평가할 것을 제안합니다',
  nps_28: '경쟁사 평가',
  price_monitoring_1: '가격 모니터링',
  price_monitoring_2: '소매 모니터링',
  price_monitoring_3:
    '경쟁사의 가격 모니터링을 통해 판매 잠재력을 높이고 가격 정책을 최적화하세요',
  price_monitoring_4:
    '4Service는 20년 이상 전 세계적으로 가격 모니터링 서비스를 제공하고 있습니다',
  price_monitoring_5:
    '자격을 갖춘 내부 감사팀이 짧은 시간 내에 가격을 모니터링하여 경쟁사 가격 변화에 신속하게 대응할 수 있습니다',
  price_monitoring_6: '가격 모니터링을 통해 당사가 도와드릴 수 있는 과제',
  price_monitoring_7: '경쟁사의 가격',
  price_monitoring_8: '및 제품 정책 평가',
  price_monitoring_9: '프로모션 모니터링',
  price_monitoring_10: '및 특별 제안',
  price_monitoring_11: '시장 상황 모니터링',
  price_monitoring_12: '및 시장 환경',
  price_monitoring_13: '판매 매장 점검 및 통제',
  price_monitoring_14: '특수 장비 및 상품용',
  price_monitoring_15: '제품',
  price_monitoring_16: '유통 내 흐름 관리',
  price_monitoring_17: '조건 최적화',
  price_monitoring_18: '공급업체, 딜러와의 협업 향상을 위해',
  price_monitoring_19: '매대 공간 측정,',
  price_monitoring_20: '상품 배치 평가, 재고 가용성',
  price_monitoring_21: '핵심 지표 및 모니터링 기준',
  price_monitoring_22:
    '모든 데이터는 다음을 포함한 하나의 인터페이스에 통합됩니다:',
  price_monitoring_23: '이름',
  price_monitoring_24: '제품 및 브랜드 카테고리',
  price_monitoring_25: '가용성',
  price_monitoring_26: '판촉 자료',
  price_monitoring_27: '가격',
  price_monitoring_28: '및 프로모션 제공 여부',
  price_monitoring_29: '선반',
  price_monitoring_30: '크기',
  price_monitoring_31: '제품',
  price_monitoring_32: '디스플레이',
  price_monitoring_33: 'SKU',
  price_monitoring_34: '진열면',
  price_monitoring_35: '유형',
  price_monitoring_36: '포장 형태',
  price_monitoring_37: '기타',
  price_monitoring_38: '일반 정보',
  price_monitoring_39: '프로젝트 전 분석:',
  price_monitoring_40: '우리는 조사합니다',
  price_monitoring_41: '귀사의 가격 및 제품 정책, 비즈니스 및 업계 관행',
  price_monitoring_42: '우리는 제공합니다',
  price_monitoring_43: '감사자에 대한 신속한 교육, 테스트 및 인증',
  price_monitoring_44: '우리는 맞춤화합니다',
  price_monitoring_45: '그리고 소프트웨어를 설정합니다',
  price_monitoring_46: '현장 작업:',
  price_monitoring_47: '소매점 방문',
  price_monitoring_48: '판매점',
  price_monitoring_49: '보고서 작성:',
  price_monitoring_50: '우리 분석 팀은',
  price_monitoring_51: '회사 계정에서 온라인 보고서를 준비합니다',
  price_monitoring_52: '우리는 제공합니다',
  price_monitoring_53:
    '지역 유형, 체인 이름, 매장 주소에 따른 전체 사진 보고서, PPT 보고서, Excel 보고서',
  price_monitoring_54: '작동',
  price_monitoring_55: '방식',
  price_monitoring_56: '개별 할인 규모',
  price_monitoring_57: '비용 계산',
  price_monitoring_58: '개별 보너스 규모',
  price_monitoring_59: '로열티 프로그램',
  price_monitoring_60: '등등.',
  price_monitoring_61: '우리는 전문 소프트웨어를 사용합니다:',
  price_monitoring_62: 'PRADATA, Shopmetrics 및 종합 기술 지원 제공',
  price_monitoring_63: '신속한 배포',
  price_monitoring_64: '및 확장 (1일차부터)',
  price_monitoring_65: '모든 데이터는 확인됨',
  price_monitoring_66: '사진 및 GPS 태그를 통해',
  price_monitoring_67: '우리는 필요한 수의',
  price_monitoring_68: '현장 요원을 모든 국가에서 보유하고 있습니다',
  price_monitoring_69: '우리는 대량의',
  price_monitoring_70: '데이터 작업이 가능합니다',
  price_monitoring_71: '개별 가격 모니터링',
  price_monitoring_72: '복잡한 제품이 있다면 - 가격 전략 수립을 도와드립니다',
  price_monitoring_73: '경쟁사의 개별 가격을 모니터링할 수 있습니다. 예:',
  price_monitoring_74: '저렴한',
  price_monitoring_75: '비용',
  price_monitoring_76: '높은',
  price_monitoring_77: '효율성',
  price_monitoring_78: 'Excel 보고서',
  price_monitoring_79: 'PPT 보고서',
  price_monitoring_80: 'BI 보고서',
  price_monitoring_81:
    '경쟁사 가격 데이터는 최적의 가격 결정을 내리는 데 도움이 됩니다',
  price_monitoring_82:
    '우리는 지역 유형에 따른 전체 사진 보고서, PPT 보고서, Excel 보고서를 제공합니다',
  qualitative_research_1: '정성적',
  qualitative_research_2: '연구',
  qualitative_research_3:
    '고객의 행동과 언어를 관찰하여 데이터를 수집, 분석 및 해석합니다',
  qualitative_research_4: '가치관',
  qualitative_research_5: '행동',
  qualitative_research_6: '배경',
  qualitative_research_7: '기대',
  qualitative_research_8: '환경',
  qualitative_research_9: '두려움/장벽',
  qualitative_research_10: '고객의 선택 목적은 무엇인가요?',
  qualitative_research_11: '휴대폰을 든 남성',
  qualitative_research_12: '브랜드',
  qualitative_research_13: '카테고리',
  qualitative_research_14: '광고',
  qualitative_research_15: '제품',
  qualitative_research_16:
    '정성적 방법의 독특함은 소비자 행동의 원인과 동기를 이해할 수 있다는 점입니다',
  qualitative_research_17: '특정 현상에 대한 소비자의 태도 분석',
  qualitative_research_18: '개인적 관점과 경험',
  qualitative_research_19: '설문조사로는 조사할 수 없는 주제',
  qualitative_research_20: '민감한 주제',
  qualitative_research_21: '접근하기 어려운 대상',
  qualitative_research_22: '복잡한 지리적 환경',
  qualitative_research_23: '심층 인터뷰가 유용한 경우:',
  qualitative_research_24: '심층 인터뷰',
  qualitative_research_25:
    '심층 인터뷰는 응답자의 특정 아이디어, 프로그램 또는 상황에 대한 관점을 탐구하기 위해 개별 인터뷰를 수행하는 정성적 연구 기법입니다. 심층 인터뷰는 개인의 경험 / 인식 / 실천을 풍부하게 탐색합니다.',
  qualitative_research_26: '목표:',
  qualitative_research_27: '사회적 및 문화적 규범 특성화',
  qualitative_research_28: '접근하기 어려운 대상',
  qualitative_research_29: '공유 및 비교 (Morgan) - 설문조사를 통한 분석',
  qualitative_research_30: '설문조사로는 조사할 수 없는 주제',
  qualitative_research_31: '심층 포커스 그룹이 유용한 경우:',
  qualitative_research_32: '포커스 그룹',
  qualitative_research_33:
    '개별 만남에 대한 심층 탐구, 새로운 논의 발생, 그룹 진행자의 영향 아래 논의',
  qualitative_research_34:
    '집단 토론을 통해 공유된 경험과 사회적 규범에 대한 통찰력 생성, 서사적 데이터 기반의 집중 토론',
  qualitative_research_36: '장점:',
  qualitative_research_37:
    '소비자의 생활 방식 및 행동을 다양한 실제 조건(가정, 판매점, 직장 등)에서 연구',
  qualitative_research_38:
    '신제품 개발, 포장, 서비스 개선 등을 위한 인사이트 탐색',
  qualitative_research_39: '심층 민족지학 연구가 유용한 경우:',
  qualitative_research_40: '민족지학 연구',
  qualitative_research_41:
    '민족지학은 특정 커뮤니티나 조직에 몰입하여 행동과 상호작용을 가까이에서 관찰하는 정성적 연구의 일종입니다',
  qualitative_research_42:
    '민족지학은 집단의 공유된 문화, 관습, 사회 역학에 대한 깊은 이해를 가능하게 하는 유연한 연구 방법입니다. 그러나 몇 가지 실용적 및 윤리적 과제도 수반됩니다.',
  qualitative_research_43: '방법:',
  qualitative_research_44:
    '민족지학은 실제 생활 조건에서 소비자와 제품/서비스의 상호작용을 연구하는 것입니다',
  qualitative_research_45: '저희와 함께 일할 때의 이점',
  qualitative_research_46:
    '어떤 대상 그룹이든 응답자를 찾을 수 있습니다. 또한 리크루팅 품질을 관리합니다',
  qualitative_research_47: '어떠한 복잡도의 리크루팅도 가능',
  qualitative_research_48:
    '저희 진행자들은 다국어 구사 및 퍼실리테이션 능력을 갖추고 있습니다',
  qualitative_research_49: '전문 진행자',
  qualitative_research_50: '온라인/오프라인 진행',
  qualitative_research_51: '오디오/비디오',
  qualitative_research_52: '녹화 제공',
  qualitative_research_53: '어느 지역이든 정성적 조사를 수행할 수 있습니다',
  quantitative_research_1:
    '특정 제품 또는 서비스(SCI, NPS)에 대한 고객 만족도 조사',
  quantitative_research_2: '고객 만족도 조사',
  quantitative_research_3: '시장 세분화 조사 수행',
  quantitative_research_4: '다양한 시장에 대한 설문조사',
  quantitative_research_5: '시장 조사',
  quantitative_research_6: 'NPS 관리',
  quantitative_research_7: '경쟁사 분석',
  quantitative_research_8: '정량적',
  quantitative_research_9: '연구',
  quantitative_research_10:
    '객관적, 수치적, 통계적 데이터를 기반으로 사람들의 태도와 행동에 대한 이론을 검증하는 연구 방법론',
  quantitative_research_11: '년',
  quantitative_research_12: '전 세계 CX 경험',
  quantitative_research_13: '패널',
  quantitative_research_14: '응답자',
  quantitative_research_15: '국가들',
  quantitative_research_16: '우리는 전 세계에서 프로젝트를 수행합니다',
  quantitative_research_17: '우리는 누구인가',
  quantitative_research_18:
    '4Service는 글로벌 마케팅 조사 및 CX 홀딩입니다. 우리는 다양한 비즈니스를 위한 전문 데이터 수집 서비스를 제공합니다',
  quantitative_research_19: '숫자로 본 4Service',
  quantitative_research_20: '컴퓨터 지원',
  quantitative_research_21: '웹 인터뷰',
  quantitative_research_22:
    '인터넷 기반 설문조사 기법입니다. 응답자는 인터뷰어의 도움 없이 전자 설문지를 작성합니다. 설문지는 전자적으로 전송되거나 웹사이트에 게시될 수 있습니다.',
  quantitative_research_23: '컴퓨터 지원 웹 인터뷰',
  quantitative_research_24: '대부분의 경우',
  quantitative_research_25:
    '이 방법은 비용과 시간 측면에서 가장 비용 효율적입니다',
  quantitative_research_26: '이 조사는 제공합니다',
  quantitative_research_27: '접근하기 어려운 청중을 인터뷰할 수 있는 기회를',
  quantitative_research_28: '광범위한 가능성을 제공합니다',
  quantitative_research_29: '비디오 및 오디오 자료 시연과 이미지 제공 등',
  quantitative_research_30: '응답자는',
  quantitative_research_31: '전 세계 어디에나 있을 수 있습니다',
  quantitative_research_32: '이를 통해 조사할 수 있습니다',
  quantitative_research_33:
    '인터넷 사용자들의 특정 행동. 주요 결과는 웹 인터페이스를 통해 실시간으로 클라이언트가 액세스할 수 있습니다',
  quantitative_research_34: '모든 비밀스러운,',
  quantitative_research_35:
    '민감하고 개인적인 주제 또는 문제에 적합하며, 응답자가 인터뷰어와 이야기할 때 대답을 꺼릴 수 있는 경우에 적절합니다',
  quantitative_research_36: '150 000+ 패널',
  quantitative_research_37:
    '우리는 전 세계적으로 자체 응답자 패널을 보유하고 있습니다',
  quantitative_research_38: '우리는 도전적인 요청도 처리합니다',
  quantitative_research_39:
    '보완 도구(소셜 미디어, 광고)를 사용하여 특정 청중 및 정교한 응답자 프로필을 찾을 수 있습니다',
  quantitative_research_40: '우리는 응답자에게 동기를 부여합니다',
  quantitative_research_41:
    '우리는 물질적 인센티브를 제공하여 긴 설문조사의 완료를 장려하는 프레임워크를 설계했습니다',
  quantitative_research_42: '대면 인터뷰',
  quantitative_research_43: '태블릿을 사용하여 수행',
  quantitative_research_44:
    '이것은 정형화된 설문지를 기반으로 인터뷰어가 응답자와 직접 소통하면서 양적 데이터를 수집하는 주요 방법 중 하나입니다.',
  quantitative_research_45:
    '대면 인터뷰는 응답자의 직장 또는 거주지, 거리, 또는 지정된 판매 장소에서 태블릿을 사용하여 수행할 수 있습니다',
  quantitative_research_46: '태블릿을 사용하여 수행되는 대면 인터뷰',
  quantitative_research_47: '인기 수준 결정',
  quantitative_research_48: '브랜드 인지도',
  quantitative_research_49: '소비자 세분화',
  quantitative_research_50: '구매 행동을 기반으로',
  quantitative_research_51: '광고 캠페인',
  quantitative_research_52: '효과 분석',
  quantitative_research_53: '고객 만족도',
  quantitative_research_54: '측정',
  quantitative_research_55: '최적 가격 결정',
  quantitative_research_56: '제품 또는 서비스에 대한',
  quantitative_research_57: '분석',
  quantitative_research_58: '소비자 선호도에 대한',
  quantitative_research_59: '연구',
  quantitative_research_60: '소비자의 구매 방식에 대한',
  quantitative_research_61: '평가',
  quantitative_research_62: '시장 규모에 대한',
  quantitative_research_63: 'DigSee 소프트웨어',
  quantitative_research_64:
    '우리는 오디오 녹음 및 GPS 기능이 포함된 특수 소프트웨어를 사용합니다',
  quantitative_research_65: '인터뷰어 및 감독자',
  quantitative_research_66:
    '우리는 어떤 언어로든 인터뷰를 수행하고 클라이언트가 원하는 언어로 번역할 수 있습니다',
  quantitative_research_67: '샘플링',
  quantitative_research_68:
    '분석 부서는 최고의 결과를 얻기 위해 응답자 모집 시스템을 개발합니다',
  quantitative_research_69: '컴퓨터 지원',
  quantitative_research_70: '전화 인터뷰',
  quantitative_research_71:
    '명확하게 구조화된 설문지를 사용하여 전화 인터뷰를 통해 양적 정보를 수집하는 방법론입니다.',
  quantitative_research_72: '컴퓨터 지원 전화 인터뷰',
  quantitative_research_73: '우리는 자체 콜센터를 보유하고 있습니다',
  quantitative_research_74:
    '우리는 오디오 녹음 및 GPS 기능이 포함된 특수 소프트웨어를 사용합니다',
  quantitative_research_75: '자격을 갖춘 운영자',
  quantitative_research_76:
    '우리의 운영자들은 다양한 언어를 구사하며, 훈련을 받고 철저하게 테스트되며 지속적으로 역량을 향상시킵니다',
  quantitative_research_77: '데이터베이스',
  quantitative_research_78:
    '우리는 자체 데이터베이스뿐만 아니라 귀하의 고객 데이터베이스와도 함께 작업합니다',
  quantitative_research_79: 'SLA',
  quantitative_research_80:
    '우리는 품질을 보장하며 SLA(서비스 수준 계약)를 체결합니다',
  quantitative_research_81: '목표 설정',
  quantitative_research_82: '방법론 결정',
  quantitative_research_83: '세분화 및 샘플링',
  quantitative_research_84: '데이터 수집 채널 정의',
  quantitative_research_85: '응답자에게 논리적인 설문지 작성',
  quantitative_research_86: '데이터 수집 과정',
  quantitative_research_87: '품질 보증',
  quantitative_research_88: '분석 기술',
  quantitative_research_89: '데이터 처리',
  quantitative_research_90: '설문조사 설계',
  quantitative_research_91: '인터뷰어의 GPS 위치 추적',
  quantitative_research_92: '데이터 검증',
  quantitative_research_93: '설문지 프로그래밍 및 테스트',
  quantitative_research_94: '데이터 유효성 검사',
  quantitative_research_95: 'GDPR 요구 사항을 준수한 오디오 녹음',
  quantitative_research_96: '조사 직원의 교육 및 역량',
  quantitative_research_97: '품질 보증',
  quantitative_research_98: '요인 분석',
  quantitative_research_99: '세분화',
  quantitative_research_100: '지각 매핑',
  quantitative_research_101: '상관관계',
  quantitative_research_102: '전환 모델',
  quantitative_research_103: '자카드',
  quantitative_research_104: '군집 분석',
  quantitative_research_105: '기타',
  quantitative_research_106: '분석 보고서',
  quantitative_research_107:
    '우리는 다양한 방법론을 사용하여 SPSS® 및 기타 도구를 활용한 분석 보고서를 작성합니다',
  quantitative_research_108: '해결할 수 있는 비즈니스 과제:',
  quantitative_research_109: '해결할 수 있는 비즈니스 과제:',
  social_responsibility_1: '4Service 기업의 사회적 책임',
  social_responsibility_2:
    '우리 팀의 모든 구성원의 마음과 영혼에서 비롯됩니다. 우리는 각 직원에게 친절의 불꽃을 유지하려고 노력하며, 주변 세계를 조금 더 나은 곳으로 만들고자 합니다',
  social_responsibility_3: '교육 활동 / 청소년 지원',
  social_responsibility_4: '어린이와 학생들을 위한 우리의 홍보 이니셔티브',
  social_responsibility_5: '서비스 매니아 비즈니스 게임',
  social_responsibility_6:
    '우리의 교육 활동의 중요한 부분 중 하나는 비즈니스 게임인 서비스 매니아입니다.',
  social_responsibility_7:
    '서비스 매니아는 비정상적인 상황을 전략적으로 처리하는 방법에 대해 생각하도록 도전합니다.',
  social_responsibility_8: '연구 발표 / 디야. 비즈니스',
  social_responsibility_9:
    '서비스 상황에 대한 비즈니스 및 고객 관점: 4Service 우크라이나 개발 책임자인 Victoria Skorbota의 4Service 연구 결과 발표',
  social_responsibility_10: '서비스 디자인 세션',
  social_responsibility_11:
    '서비스 디자인 방법론은 4Service의 중요한 부분입니다. 몇 년 전 우리는 DesignThinkers Academy의 파트너가 되었으며, 우리는 우리의 작업에서 모범 사례를 사용할 뿐만 아니라 최고의 기업에 대한 교육도 적극적으로 제공합니다',
  social_responsibility_12: '자선 / 자원봉사',
  social_responsibility_13:
    '고아원, 노인 요양원 및 우크라이나 군대를 위한 자원봉사. 우리의 활동 중 가장 감동적인 부분입니다',
  social_responsibility_14: '#4ServiceGroup으로쉽게도와주세요',
  social_responsibility_15:
    '우리는 블라고마이 자선 기금과 협력하여 축하를 전하고 절실히 필요한 사람들을 돕기 위해 노력합니다',
  social_responsibility_16: '고아원 및 요양원을 위한 기금 모금',
  social_responsibility_17:
    '4Service에서 우리는 기본 필수품을 구입하기 위해 요양원과 고아원을 위한 여러 기금 모금 행사를 시작했습니다',
  social_responsibility_18: '#저장우크라이나',
  social_responsibility_19:
    '전쟁은 우리 직원과 가까운 친구들에게 많은 영향을 미쳤습니다. 우리 각자는 가능한 한 많이 돕고 있습니다',
  social_responsibility_20: '동물 복지',
  social_responsibility_21:
    '누구나 애완동물과 함께 우리 사무실에 올 수 있습니다. 우리는 보호소를 돕고, 사료를 위한 기금을 모으며, 때로는 유기 동물을 위한 집을 찾기도 합니다',
  social_responsibility_22: '동물 보호소 지원',
  social_responsibility_23:
    '유기 동물은 우리 사회의 모든 취약한 구성원들만큼이나 도움이 필요합니다.',
  social_responsibility_24:
    '우리 회사는 시리우스 유기 동물 보호소(우크라이나 키예프 지역)를 돌보고 있습니다.',
  social_responsibility_25: '유기 동물을 돕기 위한 창의적인 이니셔티브',
  social_responsibility_26:
    '동물 보호소의 긴급한 문제를 고객과 파트너에게 어떻게 알릴 수 있을까요?',
  social_responsibility_27: '반려동물 친화적인 사무실',
  social_responsibility_28:
    '우리 팀의 많은 구성원들이 반려동물을 키우고 있습니다. 우리는 모두가 반려동물과 함께 사무실에 와서 편안함을 느낄 수 있는 건강한 환경을 만들었습니다',
  ux_testing_1: 'UX 테스트',
  ux_testing_1_1: 'UX 테스트',
  ux_testing_2:
    '사람과 AI 기반 접근 방식을 통해 웹사이트 및 애플리케이션을 테스트하고 개선합니다',
  ux_testing_3: 'UX 테스트란 무엇인가요',
  ux_testing_4:
    'UX 테스트는 사람들이 제품, 앱 또는 웹사이트와 어떻게 상호 작용하는지 이해하는 데 도움이 됩니다',
  ux_testing_5: '내비게이션이 명확하지 않습니다',
  ux_testing_6: '주문하는 방법을 전혀 모르겠습니다',
  ux_testing_7: '카탈로그에 사진이 충분하지 않습니다',
  ux_testing_8: '당신은:',
  ux_testing_9: '개선 기회를 발견합니다',
  ux_testing_10: '디자인 및 고객 상호 작용의 문제를 식별합니다',
  ux_testing_11: '사용자가 사이트와 상호 작용할 때 겪는 어려움을 파악합니다',
  ux_testing_12: '고객 여정을 관찰합니다',
  ux_testing_13: '대상 고객이 사이트를 떠나는 시점과 이유를 인식합니다',
  ux_testing_14:
    '가장 적은 관심과 가장 큰 관심 및 감정을 불러일으키는 섹션을 정의합니다',
  ux_testing_15: '사용자 기반 UX 테스트',
  ux_testing_16:
    '4Service는 정성적 및 정량적 방법을 사용하여 고객 중심의 웹사이트 및 앱을 만들기 위해 필요한 실제 인간 통찰력을 제공합니다',
  ux_testing_17:
    '사이트를 어떻게 사용하는지 이해하지 못하겠습니다. 메뉴가 어디에 숨겨져 있나요?',
  ux_testing_18: '글자 사이의 간격이 너무 넓어서 텍스트를 읽을 수 없습니다',
  ux_testing_19: '사진이 서로 겹칩니다. 원래 이렇게 되어 있는 건가요?',
  ux_testing_20:
    'UX 테스트는 사람들이 제품, 앱 또는 웹사이트와 어떻게 상호 작용하는지 이해하는 데 도움이 됩니다',
  ux_testing_21: '사용자 기반 UX 테스트 연구 설계:',
  ux_testing_22: '개선 기회를 발견합니다',
  ux_testing_23: '테스트의 유형 및 방법(정성/정량) 결정',
  ux_testing_24: '가설 및 사용자 시나리오 작성',
  ux_testing_25: '테스트 결과 분석 및 보고',
  ux_testing_26: '두 가지 솔루션',
  ux_testing_27:
    '우리는 성공적인 UX 테스트를 위한 두 가지 접근 방식을 제공합니다',
  ux_testing_28: '사용자 기반 UX 테스트',
  ux_testing_29: 'AI + 인간 기반 UX 테스트',
  ux_testing_30: '우리의 강점:',
  ux_testing_31: '경쟁 환경을 분석할 수 있습니다',
  ux_testing_32:
    '인터뷰를 수행하고 참여할 수 있는 전문 전문가를 참여시킬 수 있습니다',
  ux_testing_33:
    '다양한 언어로 인터뷰를 수행하고 필요한 언어로 번역할 수 있습니다',
  ux_testing_34: '기존 사용성',
  ux_testing_35: '지표 또는 표준과 함께',
  ux_testing_36: '귀하의 성과',
  ux_testing_37: '경쟁자의',
  ux_testing_38: '버전',
  ux_testing_39: '동일한 제품의',
  ux_testing_40: '만족도 평가',
  ux_testing_41: 'NPS',
  ux_testing_42: '성공률',
  ux_testing_43: '오류율',
  ux_testing_44: '작업 완료 시간',
  ux_testing_45: '사용자 기반 UX 테스트',
  ux_testing_46: '정량적 방법',
  ux_testing_47: '이 단계의 UX 테스트에 최소 100명의 참여자를 사용합니다',
  ux_testing_48: '웹사이트나 앱의 비교가 필요할 때 관련됩니다:',
  ux_testing_49: '정량적 방법 측정:',
  ux_testing_50: '관찰',
  ux_testing_51:
    '사용자 또는 사용자 그룹과 시간을 보내고 일상 생활에서 제품을 사용하는 동안 행동을 관찰합니다',
  ux_testing_52: '심층 인터뷰',
  ux_testing_53:
    '사이트에 방문한 사용자의 태도, 신념, 욕구, 경험을 알 수 있게 해줍니다. 15~20건의 인터뷰를 권장합니다',
  ux_testing_54: '민족지학적 조사',
  ux_testing_55:
    '응답자가 제품을 사용할 환경에서 수행됩니다. 관찰을 통해 사용자의 심리와 감정적 도전 과제를 잘 이해할 수 있습니다.',
  ux_testing_56: '사용자 기반 UX 테스트',
  ux_testing_57: '정성적 방법',
  ux_testing_58:
    '이 방법은 사용자의 행동 동기와 논리를 이해하는 데 도움이 됩니다',
  ux_testing_59: '우리는 다음을 사용합니다:',
  ux_testing_60: '조사 결과를 시각화하기 위해 고객 여정 지도를 개발 중입니다',
  ux_testing_61: '참여자 30명 (남성/여성)',
  ux_testing_62: '응답자를 사전 선별하고 설문 조사에 초대합니다',
  ux_testing_63: 'Wantent 플랫폼에서 원격 온라인 인터뷰 진행',
  ux_testing_64: 'AI + 사람 기반',
  ux_testing_65: 'AI + 사람 기반 UX 테스트',
  ux_testing_66: 'Wantent의 독창적인 인공지능 기술과 실제 사용자들의 결합',
  ux_testing_67: '큰 글꼴의 제목이 주목을 끌었습니다',
  ux_testing_68:
    "사용자들은 '강조된' 숫자를 보지만 그 옆의 정보는 읽지 않습니다",
  ux_testing_69:
    'UX 테스트는 사람들이 제품, 앱 또는 웹사이트와 어떻게 상호 작용하는지를 이해하는 데 도움이 됩니다',
  ux_testing_70: 'AI + 사람 기반 테스트 연구 설계',
  ux_testing_71: '작동 방식',
  ux_testing_72: 'Wantent는 AI 기반 콘텐츠-시장 적합성 솔루션입니다.',
  ux_testing_73:
    'Wantent는 ML 기술을 사용하여 감정 반응과 참여도를 분석함으로써 웹사이트와 앱의 효율성을 평가합니다.',
  ux_testing_74:
    '우리는 스토리텔링 기술, 다양성, 공감을 사용하여 성과와 성장을 주도합니다.',
  ux_testing_75: '섹션 간 전환 중 사용자의 주의와 감정',
  ux_testing_76: '참여자 그룹별 통계 (세션 전체의 주의력 및 집중도)',
  ux_testing_77: '페이지 전환 분석',
  ux_testing_78: '작업 수행 중 주의력과 감정',
  ux_testing_79: '인지에 대한 발견',
  ux_testing_80: '다양한 참가자 그룹에 의한 웹사이트 인식',
  ux_testing_81: '사용 편의성 분석',
  ux_testing_82: '페이지 탐색의 용이성과 중요한 요소 찾기의 용이성',
  ux_testing_83: '인지 분석',
  ux_testing_84: '웹사이트에 제공된 정보에 대한',
  ux_testing_85: '개선이 필요한 영역',
  ux_testing_86: '개별 페이지 내 (탐색, 정보 블록 등)',
  ux_testing_87: '우리는 세부적으로 분석합니다',
  ux_testing_88: '연구의 주요 결과',
  ux_testing_89: '웹사이트 구조 및 개별 페이지 개선을 위한 권장 사항',
  ux_testing_90: '유용성 테스트을 위한 타겟 오디언스를 신중하게 선택합니다.',
  ux_testing_91:
    '우리는 다양한 국가, 언어 및 사용자 그룹을 대상으로 조사를 수행합니다',
  ux_testing_92: '앱에서도 테스트할 수 있습니다',
  ux_testing_93: '경쟁사의 웹사이트에서 테스트하고 비교 분석을 제공합니다',
  ux_testing_94: '우리는 다양한 조사 방법을 결합합니다.',
  ux_testing_95: '자격을 갖춘 진행자가 참가자를 테스트 과정으로 안내합니다.',
  ux_testing_96: '우리는 테스트를 수행합니다',
  ux_testing_97: '다양한 기기 및 소프트웨어 버전에서',
  ux_testing_98: '왜 우리를 선택해야 할까요?',
  wantent_1: '4Service x',
  wantent_2: 'Wantent',
  wantent_3:
    '4Service와 Wantent의 독특한 파트너 프로젝트 © 콘텐츠 분석을 위한 인공지능과 사람 중심 접근 방식의 결합',
  wantent_4: '콘텐츠가 방영되기 전에 성공 측정',
  wantent_5: '다양성 문제의 리스크 완화',
  wantent_6: '콘텐츠 개선을 위한 깊이 있는 통찰력과 권장 사항',
  wantent_7: '콘텐츠 및 마케팅 전략에 대한 객관적인 결정',
  wantent_8: 'Wantent는 AI 기반 콘텐츠-시장 적합성 솔루션입니다.',
  wantent_9:
    'Wantent는 감정 반응과 참여도를 분석하기 위해 ML 기술을 적용하여 비디오 콘텐츠의 효율성을 평가하는 인공지능 기반 솔루션입니다.',
  wantent_10:
    'Wantent는 콘텐츠-시장 적합성을 정의하고 콘텐츠 효율성을 극대화하는 데 도움을 줍니다',
  wantent_11: '시나리오 설정 및 참여자 모집',
  wantent_12: '맞춤형 프로젝트 설계 및 전 세계 오디언스',
  wantent_13: '시청자의 반응 수집',
  wantent_14: '청중으로부터의 상세하고 명확한 피드백',
  wantent_15: '콘텐츠 인식 분석',
  wantent_16: 'AI에 의한 행동 및 감정 반응 분석',
  wantent_17: '최종 요약을 위한 인사이트 제공',
  wantent_18: '개선 권장 사항',
  wantent_19: 'Wantent는 콘텐츠 효율성을 극대화합니다',
  wantent_20: '광고 콘셉트 사전 테스트',
  wantent_21: '크리에이티브 콘셉트 테스트',
  wantent_22:
    '미래의 크리에이티브가 개발된 전략과 일관성을 유지하는지 확인하고, 타겟 오디언스의 반응을 이해하여 콘셉트/메시지를 조정합니다',
  wantent_23: '브랜드 요소의 가시성 테스트 (포스트 프로덕션)',
  wantent_24: '광고/후원 투자 효과의 확인',
  wantent_25: '광고 테스트',
  wantent_26: 'A/B 테스트',
  wantent_27:
    '크리에이티브의 효과 비교 및 제작 단계에서 참여도와 주의 집중도 향상',
  wantent_28: '광고 테스트 시작',
  wantent_29: '메시지 성과 정의 및 오디오 및 비주얼 향상을 위한 권장 사항 작성',
  wantent_30: 'TV용 솔루션',
  wantent_31: '파일럿, 프로모션, 새로운 포맷, TV 진행자 테스트',
  wantent_32: '가장 매력적인 요소를 식별하고 강화하기 위한 비교 분석 수행',
  wantent_33: 'TV 프로그램 및 장편 영화 테스트',
  wantent_34:
    '자연스러운 조건에서 장시간 콘텐츠 시청 중 시청자의 몰입도, 주의 수준, 감정 반응 분석. 관객 이탈의 정점과 주의 산만한 순간을 자동으로 찾아 비디오 편집을 평가하고 개선함',
  wantent_35: 'UI/UX 테스트',
  wantent_36: '웹사이트 프로토타입 및 모바일 애플리케이션 테스트',
  wantent_37: 'Wantent 기술을 활용한 사용자 반응 및 감정 분석:',
  wantent_38: '주의 수준',
  wantent_39: '감정 반응',
  wantent_40: '참가자의 시선 방향 히트맵',
  wantent_41: '참가자 피드백 기반의 웹사이트 및 애플리케이션 사용성 분석:',
  wantent_42: '시스템 사용성 척도 (SUS)',
  wantent_43: '고객 노력 점수 (상호작용 용이성)',
  wantent_44: '순추천지수 (NPS)',
  wantent_45: 'GDPR 준수 및 사용자 프라이버시',
  wantent_46:
    'Wantent는 GDPR 및 CCPA 정책을 완전히 준수하며, 참가자의 개인 데이터 수집, 저장, 처리 및 보호 원칙을 충족합니다',
  wantent_47: 'Nikita Lobyntsev',
  wantent_48: 'CDO, Reface (미디어 및 엔터테인먼트)',
  wantent_49:
    '우리는 매일 기계 학습 기술로 수많은 새로운 콘텐츠 아이디어를 실험합니다. Wantent는 위험과 이점을 이해하고 평가하며, 사용자 피드백, 행동 및 인식을 파악하여 우리 솔루션의 다양한 측면의 인과관계를 파악하는 데 도움을 줍니다.',
  wantent_50: 'Alexander Smirnov',
  wantent_51: 'TABASCO 공동 소유자 (광고)',
  wantent_52:
    'Wantent는 소비자가 좋아하고 싫어하는 아주 사소한 세부 사항까지 알려주는 진정으로 독특한 서비스를 제공합니다. 속일 수도, 거짓말할 수도 없습니다 - Wantent는 항상 진실을 알고 있으며, 그 덕분에 우리는 마케팅 전문가로서 커뮤니케이션을 개선하기 위한 매우 소중한 (하하하 - 우리는 정확한 가격을 알고 있으며 접근 가능합니다) 가이드라인을 얻게 됩니다.',
  wantent_53: '리뷰',
  terms_1: '이용 약관',
  terms_2: '이용 계약',
  terms_3:
    '본 웹사이트를 사용하기 전에 본 이용 계약(“이용 약관”, “계약”)을 주의 깊게 읽어주시기 바랍니다',
  terms_4:
    '(“웹사이트”)는 4Service Holdings GmbH(“4Service”, “당사”, ‘우리’, “당사의”)가 운영합니다.',
  terms_5:
    '이용 조건이 웹사이트를 이용함으로써 귀하는 본 계약을 읽고 검토하였으며 그 조건에 따를 것임을 인증합니다. 본 계약 조건에 구속되기를 원하지 않으시면, 해당 웹사이트를 떠나시기 바랍니다. 4Service는 본 조건에 동의한 사람에게만 본 웹사이트, 제품 및 서비스 사용과 접근을 허용합니다.',
  terms_6: '개인정보 보호정책',
  terms_7:
    '당사 웹사이트를 계속 사용하시기 전에 사용자 데이터 수집과 관련한 당사의 개인정보 보호정책을 읽어보시기 바랍니다. 이는 당사의 관행을 더 잘 이해하는 데 도움이 됩니다.',
  terms_8: '연령 제한',
  terms_9:
    '본 웹사이트를 사용하기 위해서는 최소 16세 이상이어야 합니다. 웹사이트를 사용함으로써 귀하는 자신이 최소 16세 이상이며 본 계약을 법적으로 준수할 수 있음을 보증합니다. 4Service는 연령 허위 표시와 관련된 책임을 지지 않습니다.',
  terms_10: '지적 재산권',
  terms_11:
    '귀하는 본 웹사이트에 제공된 모든 자료, 제품 및 서비스가 4Service, 그 계열사, 이사, 임원, 직원, 대리인, 공급업체 또는 라이선스 제공자의 재산이며, 모든 저작권, 영업 비밀, 상표, 특허 및 기타 지적 재산권이 포함됨을 인정하고 동의합니다. 또한 귀하는 전자적, 디지털 방식 또는 신규 상표 등록을 포함하여 어떠한 방식으로도 4Service의 지적 재산권을 복제하거나 재배포하지 않을 것에 동의합니다.',
  terms_12: '웹사이트 접근',
  terms_13:
    '당사 웹사이트는 일시적으로 접근이 허용되며, 당사는 사전 통지 없이 사이트에서 제공하는 서비스를 철회하거나 수정할 권리를 보유합니다. 어떠한 이유로든 당사 사이트가 언제든지 또는 일정 기간 동안 이용할 수 없는 경우, 당사는 이에 대해 책임지지 않습니다. 때때로, 당사는 일부 사이트 영역 또는 전체 사이트에 대해 등록 사용자에게만 접근을 제한할 수 있습니다. 귀하는 당사 사이트에 접근하기 위해 필요한 모든 장비와 설정을 직접 마련해야 하며, 귀하의 인터넷 연결을 통해 접근하는 모든 사람이 본 조건을 인지하고 준수하도록 책임을 져야 합니다.',
  terms_14: '적용 법률',
  terms_15:
    '웹사이트를 방문함으로써 귀하는 오스트리아 공화국의 법률이 법률 충돌 원칙과 관계없이 본 약관 또는 4Service와 귀하 간의 모든 분쟁을 관할함에 동의합니다.',
  terms_16: '분쟁',
  terms_17:
    '웹사이트 방문과 관련된 모든 분쟁은 비엔나 상업 법원에서 중재됩니다.',
  terms_18: '면책',
  terms_19:
    '귀하는 웹사이트 사용 또는 오용으로 인해 발생할 수 있는 법적 청구 및 요구로부터 4Service 및 그 계열사를 면책하고 보호하는 데 동의합니다. 당사는 자체 법률 자문을 선택할 권리를 보유합니다.',
  terms_20: '보관 기간',
  terms_21:
    '처리 목적을 고려할 때, 사용자의 개인 데이터 보관 기간은 동의가 적법하게 얻어진 날짜로부터 24개월입니다.',
  terms_22: '책임의 제한',
  terms_23:
    '귀하가 당사 웹사이트를 잘못 사용함으로 인해 발생할 수 있는 모든 손해에 대해 4Service는 책임을 지지 않습니다. 당사는 본 게시물을 업데이트함으로써 사전 통지 없이 본 계약을 수정, 변경할 권리를 보유합니다. 귀하가 웹사이트를 계속 사용하는 경우 또는 변경사항 게시 이후 계속 사용하는 경우, 귀하는 해당 변경 사항을 수락한 것으로 간주됩니다. 본 계약의 일부가 불법, 무효 또는 집행 불가능한 것으로 선언되는 경우, 해당 부분은 분리 가능한 것으로 간주되며 나머지 조항의 유효성과 집행 가능성에 영향을 미치지 않습니다. 불법 목적으로 웹사이트를 사용하는 증거가 있을 경우 법 집행 기관에 제공됩니다. 본 계약은 4Service와 사용자 간의 합의입니다.',
  terms_24: '프라이버시/사용 관련 문의 사항은 다음 주소로 보내주시기 바랍니다:',
  terms_25: '4Service Holdings GmbH',
  terms_26: 'Tegetthoffstrasse 7',
  terms_27: '1010 Vienna',
  terms_28: '오스트리아',
  terms_29: '검토',
  terms_30:
    '귀하가 제공한 개인 데이터가 부정확한 경우, 귀하는 당사에 수정을 요청할 권리가 있습니다 (GDPR 제16조).',
  thank_you_1: '감사합니다!',
  thank_you_2: '24시간 이내에 연락드리겠습니다',
  thank_you_3:
    '추신: 저희 매니저가 귀하의 요청을 검토 중이며 더 나은 제안을 준비하고 있습니다',
  thank_you_4: '메뉴',
  thank_you_5: '타이핑하는 여성',
  contacts_1: '고객을 위한',
  contacts_2:
    '모든 종류의 비즈니스, 시장 조사 기관 및 대기업, 비즈니스 파트너 및 미디어를 위한 것입니다.',
  contacts_3: 'Tegetthoffstrasse 7, 비엔나, 오스트리아',
  contacts_4: '쇼퍼를 위한',
  contacts_5:
    '지역 주민과 여행자, 운전자와 학생, 전문 미스터리 쇼퍼와 집순이/집돌이.',
  contacts_6: '귀하의 국가에서 저희에게 연락하세요:',
  contacts_7: '이탈리아',
  contacts_8: '미국',
  contacts_9: '영국',
  contacts_10: '스위스',
  contacts_11: '네덜란드',
  contacts_12: '슬로바키아',
  contacts_13: '슬로베니아',
  contacts_14: '루마니아',
  contacts_15: '아제르바이잔',
  contacts_16: '우크라이나',
  contacts_17: '카자흐스탄',
  contacts_18: '기타 국가',
  menu_1: '고객 여정 지도 (CJM)',
  menu_2: '순추천지수 (NPS)',
  menu_3: '고객 만족 지수 (CSI)',
  menu_4: 'BHT',
  menu_5: 'UX 테스트',
  menu_6: '인사 조사',
  menu_7: '정성적 연구',
  menu_8: '정량적 연구',
  menu_9: '미스터리 쇼핑',
  menu_10: '보이서',
  menu_11: 'Play4Sales',
  menu_12: 'Wantent',
  menu_13: '가격 모니터링',
  menu_14: '회사 소개',
  menu_15: '연락처',
  menu_16: '블로그',
  menu_17: '방법론',
  menu_18: '제품',
  menu_19: '쇼퍼 \n 플랫폼',
  menu_20: 'CSR',
  menu_21: '자동차 가격 분석',
  menu_22: '시설 점검 감사',
  menu_23: '서비스 디자인',
  menu_24: 'CX',
  nps_passives: '중립자',
  nps_detractors: '비추천자',
  nps_promoters: '추천자',
  nps_a_score: '점수',
  area: '지역',
  products_tabs_1: '최대 효율을 달성하기 위해 다음을 종합적으로 수행합니다:',
  products_tabs_2: '제품',
  products_tabs_3:
    '정성적 연구는 개념, 의견 또는 경험을 이해하기 위해 비수치 데이터를 수집하고 분석하는 것입니다.',
  products_tabs_4:
    '정량적 연구 방법은 설문조사, 질문지 및 조사 등을 통해 수집된 데이터를 객관적으로 측정하고 수치 분석하는 것입니다.',
  our_clients_1: '저희 고객사',
  preview_cases_section_1: '사례',
  preview_cases_section_2: '더 흥미로운 게시물을 읽으려면 사례로 이동하세요',
  blog_1: '흥미로운 콘텐츠 블로그',
  blog_2: '요청하신 항목에 대한 게시물이 없습니다',
  about: '소개',
  why_us: '왜 저희인가요',
  about_us: '회사 소개',
  key_features: '핵심 기능',
  solutions: '솔루션',
  monitoring: '모니터링',
  how: '방법',
  how_it_works: '작동 원리',
  when_to_use: '사용 시기',
  mystery_shopping: '미스터리 쇼핑',
  voicer: '고객의 소리',
  wantent: '비디오 콘텐츠 테스트',
  play4sales: 'Play4Sales',
  price_monitoring: '가격 모니터링',
  service_design: '서비스 디자인',
  qualitative_research: '정성적 연구',
  quantitative_research: '정량적 연구',
  cawi: 'CAWI',
  f2f: 'F2F',
  cati: 'CATI',
  hashtag_automotive: '#자동차',
  hashtag_retayl: '#소매업',
  hashtag_all_posts: '#모든_게시물',
  hashtag_feedback: '#피드백',
  hashtag_4Service_csr: '#4Service_CSR',
  hashtag_cases: '#사례',
  hashtag_market_research: '#시장_조사',
  more: '더 보기',
  speak_to_an_expert: '전문가에게 문의하기',
  book_consultancy: '상담 예약하기',
  read_all: '모두 읽기',
  find_out_more: '자세히 알아보기',
  address: '주소',
  mon_fri: '월-금',
  phone_number: '전화번호',
  flag: '국기',
  scroll_to_left: '왼쪽으로 스크롤',
  online: '온라인',
  tel: '전화',
  email: '이메일',
  light_it_up: '불을 밝혀라',
  about_us_60: '알리나 안드레이에바',
  about_us_61: '사업 개발 이사',
  about_us_62: '율리아 크라브첸코',
  about_us_63: '수석 프로젝트 매니저',
  about_us_64: '올가 악소노바',
  about_us_65: '사업 개발 매니저',
  about_us_66: '젤렙스키 드미트리',
  about_us_67: '운영 이사',
  about_us_roles_1: '경영진',
  about_us_roles_2: '글로벌 팀',
  about_us_roles_3: '제품 책임자',
  ad_testing_1: '광고 테스트',
  ad_testing_2:
    '광고 캠페인은 막대한 투자입니다. 광고가 강력하며 최대 ROI를 제공하는지 확인하세요.',
  ad_testing_3: '잠금',
  ad_testing_4: '우리가 서비스하는 산업',
  ad_testing_5: '4Service는 글로벌 고객 경험 조사 그룹입니다',
  ad_testing_6:
    '4Service는 글로벌 마케팅 리서치 및 CX 그룹입니다. 다양한 기업에 전문가 데이터 수집 서비스를 제공합니다',
  ad_testing_7: '캐시 앤 캐리',
  ad_testing_8: '소매업',
  ad_testing_9: '전자제품',
  ad_testing_10: '럭셔리/프리미엄',
  ad_testing_11: '외식 및 접객업',
  ad_testing_12: '자동차',
  ad_testing_13: '여행 및 레저',
  ad_testing_14: '패션',
  ad_testing_15: '은행',
  ad_testing_16: '시계 및 보석',
  ad_testing_17: '가정용품 및 가전',
  ad_testing_18: 'Esomar 회원',
  ad_testing_19:
    '우리는 다양한 분야의 비즈니스를 대상으로 광고 테스트 조사를 수행했습니다',
  ad_testing_20: '광고 테스트가 필요한 경우는 다음과 같습니다',
  ad_testing_21: '신제품 또는 서비스를 홍보할 때',
  ad_testing_22: '민감한 주제를 다룰 때',
  ad_testing_23: '새로운 타깃 고객층이나 시장에 도달하려 할 때',
  ad_testing_24: '여러 디자인 옵션을 논의할 때',
  ad_testing_25: '경영진이나 투자자에게 개념 증명이 필요할 때',
  ad_testing_26: '다음과 같은 질문에 대한 답변을 얻을 수 있습니다',
  ad_testing_27: '이 광고에 가장 적합한 광고 채널은 무엇입니까?',
  ad_testing_28:
    '메시지를 효과적으로 전달하기 위한 적절한 시각 자료를 사용하고 있습니까?',
  ad_testing_29: '광고 문구와 메시지가 공감을 얻고 있습니까?',
  ad_testing_30: '이 광고에 가장 적합한 광고 채널은 무엇입니까?',
  ad_testing_31: '무엇이 사람들의 관심을 가장 먼저 끌까요?',
  ad_testing_32: '광고의 배치와 레이아웃은 이해하기 쉬운가요?',
  ad_testing_33: '우리는 다음을 평가합니다',
  ad_testing_34: '브랜딩',
  ad_testing_35: '브랜드가 광고와 어떻게 연결되고 얼마나 기억될 수 있는지',
  ad_testing_36: '핵심 지표',
  ad_testing_37: '통합성',
  ad_testing_38: '인지도',
  ad_testing_39: '적합성',
  ad_testing_40: '창의성',
  ad_testing_41: '광고가 어떻게 눈에 띄고 사람들의 관심을 끄는지',
  ad_testing_42: '핵심 지표',
  ad_testing_43: '인지도 (RECOGNITION)',
  ad_testing_44: '호감도 (LIKING)',
  ad_testing_45: 'MTO',
  ad_testing_46: '동기 부여 (MOTIVATION)',
  ad_testing_47: '고객 경험, 감정적 몰입',
  ad_testing_48:
    'AI 기술과 전문가 분석을 통해 실제 감정을 분석하고 광고에 대한 인식을 파악합니다',
  ad_testing_49: '평가',
  ad_testing_50: '남성',
  ad_testing_51: '여성',
  ad_testing_52: '높은 몰입도',
  ad_testing_53: '주의 집중도',
  ad_testing_54: '청중이 좋아하고 기억한 것은 무엇입니까?',
  ad_testing_55: '여배우',
  ad_testing_56: '평등',
  ad_testing_57: '음악 배경',
  ad_testing_58: '긍정적인 감정',
  ad_testing_59: '다양한 인종과 외모의 사람들',
  ad_testing_60: '야외 장면',
  ad_testing_61: '청중이 좋아하지 않거나 기억하지 못한 것은 무엇입니까?',
  ad_testing_62: '화면에서 일어나는 일과 발표자의 목소리가 어울리지 않았습니다',
  ad_testing_63: '제품에 대한 낮은 주의 집중',
  ad_testing_64: '너무 역동적임',
  ad_testing_65: '이해하기 어려움',
  ad_testing_66: 'TRP',
  ad_testing_67: '노출',
  ad_testing_68: '프로그램 수',
  ad_testing_69: '전환율',
  ad_testing_70: '미디어',
  ad_testing_71:
    '우리는 광고 캠페인의 효과를 미디어 활동과 함께 측정하고, 다양한 채널에서 미디어 투자 효과가 결과에 미치는 영향을 계산합니다.',
  ad_testing_72: '우리는 어떤 형식, 플랫폼, 채널에서도 광고 조사를 수행합니다',
  ad_testing_73: '영상 콘텐츠',
  ad_testing_74: '옥외 광고',
  ad_testing_75: 'TV 광고',
  ad_testing_76: '인쇄물',
  ad_testing_77: '디지털',
  ad_testing_78: '광고 캠페인',
  ad_testing_79: 'POS 디스플레이 및 광고',
  ad_testing_80: '애니매틱',
  ad_testing_81: '우리를 통해 어떤 단계에서든 광고를 테스트할 수 있습니다',
  ad_testing_82: '컨셉',
  ad_testing_83: '어떤 아이디어가 더 강력한 잠재력을 가지고 있습니까?',
  ad_testing_84: '초기 제작 단계',
  ad_testing_85: '어떤 애니매틱이 제작으로 이어질까요?',
  ad_testing_86: '제작',
  ad_testing_87: '어떻게 편집해야 시청자의 주의를 끌 수 있을까요?',
  ad_testing_88: '미디어 이전 단계',
  ad_testing_89: '어떤 커뮤니케이션 채널이 효과적이며 어떤 결과가 예상됩니까?',
  ad_testing_90: '광고 사후 테스트',
  ad_testing_91: '제작',
  ad_testing_92:
    '내 광고가 매력적인가요? 창의성의 효과가 시간이 지남에 따라 줄어들고 있나요?',
  ad_testing_93: '미디어 이전 단계',
  ad_testing_94:
    '내 광고의 수치상 효과는 어느 정도입니까? 경쟁사와 비교하면 어떻습니까?',
  ad_testing_95: '광고 사전 테스트',
  ad_testing_96: '고품질 데이터를 제공하기 위해 우리는 다음을 사용합니다',
  ad_testing_97: '정량적 조사 방법론',
  ad_testing_98: 'CAWI',
  ad_testing_99: '정성적 조사 방법론',
  ad_testing_100: '포커스 그룹',
  ad_testing_101: 'AI',
  ad_testing_102: 'Wantent',
  ad_testing_103: '귀하가 받게 될 분석 보고서',
  ad_testing_104:
    '우리의 분석가, 미디어 전문가, 마케터 팀이 맞춤형 보고서를 작성하고 상세한 권장사항과 함께 제공합니다',
  ad_testing_age: '연령',
  ad_testing_ad: '광고',
  automotive_industry_price_analysis_1: '자동차 산업 가격 분석',
  automotive_industry_price_analysis_2:
    '경쟁 가격 분석은 이익 손실을 방지하고, 시장 점유율을 높이며, 시장 내 위치를 모니터링하는 데 도움이 됩니다. 성공적인 경쟁 전략을 선택할 수 있도록 도와드리겠습니다!',
  automotive_industry_price_analysis_3: '견적 요청',
  automotive_industry_price_analysis_4: '우리의 방법론',
  automotive_industry_price_analysis_5:
    '세련되고 우아한 사람들이 있는 자동차 전시장',
  automotive_industry_price_analysis_6:
    '미스터리 쇼핑 방법은 실제 고객 경험을 정확하게 반영하고 신뢰할 수 있는 개요를 제공하는 유일한 접근 방식입니다.',
  automotive_industry_price_analysis_7:
    '우리는 정확한 수치와 신뢰할 수 있는 다각적 데이터를 제공합니다',
  automotive_industry_price_analysis_8:
    '우리는 전 세계 모든 국가를 아우르는 글로벌 커버리지를 보유하고 있습니다',
  automotive_industry_price_analysis_9:
    '우리는 자체적으로 미스터리 쇼퍼 및 감사자를 보유하고 있습니다',
  automotive_industry_price_analysis_10: '우리는 데이터의 품질을 검증합니다',
  automotive_industry_price_analysis_11: '우리의 강점:',
  automotive_industry_price_analysis_12:
    '특정 경쟁 모델(B2B 및 B2C)의 가격 모니터링',
  automotive_industry_price_analysis_13: '할인 수준 모니터링',
  automotive_industry_price_analysis_14:
    '귀사의 브랜드 및 경쟁사의 소매업체 재고 모니터링',
  automotive_industry_price_analysis_15: '전자상거래 자동차 가격 모니터링',
  automotive_industry_price_analysis_16: '가격 커뮤니케이션 분석',
  automotive_industry_price_analysis_17: '소매업체 배송 요금 추적',
  automotive_industry_price_analysis_18: '소매점 프로모션 및 세일 모니터링',
  automotive_industry_price_analysis_19: '월별 납부 금액 결정',
  automotive_industry_price_analysis_20: '리스 지불금 계산',
  automotive_industry_price_analysis_21:
    '전기차(EV)에 대한 특정 가격 고려사항 분석',
  automotive_industry_price_analysis_22:
    '소비자 직판과 소매업체 가격 비교 수행',
  automotive_industry_price_analysis_23: '구독 가격 모델 개발',
  automotive_industry_price_analysis_24:
    '4Service는 20년 이상의 경험을 가진 글로벌 고객 경험(CX) 기업입니다',
  automotive_industry_price_analysis_25:
    '소비자가 다양한 기능에 대해 지불할 의향이 있는 데이터를 활용하여 제안을 최적화하고 목표 고객에게 가장 중요한 기능을 식별할 수 있습니다.',
  automotive_industry_price_analysis_26:
    '4Service의 자동차 산업 가격 분석에는 다음이 포함됩니다:',
  automotive_industry_price_analysis_27:
    '최저가가 항상 자동차 브랜드의 경쟁력을 의미하는 것은 아닙니다. 장기적인 가격 전략 수립을 도와드리겠습니다',
  automotive_industry_price_analysis_28:
    '고객들은 모든 브랜드의 가격이 상승하고 있음을 이해하고 있습니다',
  automotive_industry_price_analysis_29: '29',
  automotive_industry_price_analysis_30:
    '브랜드가 가격 인상을 예고하더라도 마음에 드는 자동차라면 여전히 구매하겠다고 말한 고객의 비율',
  automotive_industry_price_analysis_31: '31',
  automotive_industry_price_analysis_32:
    '사람들은 자동차 구매 방식으로 리스 및 월납을 가장 선호하는 모델로 간주합니다',
  automotive_industry_price_analysis_33: '48',
  automotive_industry_price_analysis_34:
    '딜러의 47.6%가 판매 과정 중 가격 인상 가능성을 언급함',
  automotive_industry_price_analysis_35: '47.6',
  automotive_industry_price_analysis_36: '주요 수치',
  automotive_industry_price_analysis_37:
    '귀하는 라인업 내 다른 차량과 비교하여 제품의 가격을 결정하는 방법을 파악하게 됩니다.',
  automotive_industry_price_analysis_38:
    '소비자의 지불 의향 데이터를 활용하여 제안을 최적화하고 목표 고객에게 가장 중요한 기능을 식별할 수 있습니다.',
  automotive_industry_price_analysis_39:
    '브랜드가 가격 인상을 알렸음에도 불구하고 여전히 원하는 차량을 구매하겠다고 답한 고객의 비율',
  automotive_industry_price_analysis_40:
    '적절한 월 납부금과 리스 요율을 결정할 수 있습니다.',
  automotive_industry_price_analysis_41:
    '귀하의 브랜드 또는 딜러가 얻게 될 이점:',
  automotive_industry_price_analysis_42: '신청서를 제출합니다',
  automotive_industry_price_analysis_43:
    '담당 매니저가 연락하여 주요 목표를 확인합니다',
  automotive_industry_price_analysis_44: '우리는 마케팅 조사를 실시합니다',
  automotive_industry_price_analysis_45:
    '우리는 정기적으로 온라인 형식으로 보고서와 권장 사항을 제공합니다',
  automotive_industry_price_analysis_46: '세일 스티커가 붙은 자동차',
  automotive_industry_price_analysis_47:
    '우리는 프로젝트를 하루 만에 시작합니다!',
  automotive_industry_price_analysis_48:
    '사진 보고서, PPT 보고서, 엑셀 보고서를 포함한 종합 보고서를 제공하며 지역 유형별로 세분화되어 있습니다',
  retail_audit_1: '현장 마케팅 감사/소매 감사',
  retail_audit_2:
    '매장 또는 브랜드에 대한 세부 데이터를 수집하고, 성장 장벽을 분석하며, 이를 극복하기 위한 효과적인 전략을 수립하세요',
  retail_audit_3: '견적 요청하기',
  retail_audit_4:
    '4Service는 브랜드를 대신하여 현장 매장 감사를 수행하여 판촉 전략, 현장 실행 팀, 마케팅 전술이 목표 시장에 얼마나 효과적으로 도달하고 있는지를 평가합니다.',
  retail_audit_5:
    '우리는 판촉 캠페인의 실행을 세심하게 관찰하고 판촉 지침 준수를 보장합니다.',
  retail_audit_6: '상위 10개',
  retail_audit_7: '유럽 내 CX 에이전시',
  retail_audit_8: '년간 경험',
  retail_audit_9: '국가 범위',
  retail_audit_10: '160만',
  retail_audit_11: '연간 평가 건수',
  retail_audit_12: '무엇을 추적하나요?',
  retail_audit_13: '판매 시점(Point-of-Sale, POS) 자료의 존재 여부',
  retail_audit_14:
    '브랜드 홍보대사의 존재 및 활성화 여부, 계획된 일정 준수 여부 확인',
  retail_audit_15: '브랜드 홍보대사의 캠페인 참여도 평가',
  retail_audit_16:
    '소비자와의 상호작용 평가, 판촉 지침 및 브랜드 메시지 준수 여부 확인',
  retail_audit_17: '사기 방지 조치',
  retail_audit_18:
    '현장 마케팅 감사 결과를 활용하여 비즈니스에 다음과 같은 이점을 제공합니다:',
  retail_audit_19: '예산 및 프로세스 준수 평가',
  retail_audit_20: '실제 결과와 목표 비교',
  retail_audit_21: '마케팅 캠페인 성과 향상',
  retail_audit_22: '전략적 미래 계획 수립',
  retail_audit_23: '비용 절감 기회 식별',
  retail_audit_24: '매출 및 전환율 개선',
  retail_audit_25: '투자 수익률(ROI) 최적화',
  retail_audit_26: '그들은 4Service를 무역 투자 파트너로 선택했습니다',
  retail_audit_27:
    '세계적인 담배 제조업체는 브랜드 강화 및 매장 내 성과 향상을 위해 4Service와 파트너십을 체결했습니다. 당사의 팀은 현장 마케팅 감사 및 소비자 경험 실시간 보고를 제공했습니다.',
  retail_audit_28: '현장 마케팅 에이전시의 계획 정확도 증가',
  retail_audit_29: '브랜드 메시지 전달률 향상',
  retail_audit_30: '브랜드 홍보대사의 참여도 증가(소비자 활성화)',
  retail_audit_31: '데이터 수집 정확도 및 GDPR 준수 향상',
  retail_audit_32: '우리가 자주 발견하는 귀중한 인사이트:',
  retail_audit_33:
    '서비스 수준 계약(SLA)의 조건 간 불일치 또는 충돌로 인해 고객에게 승인되지 않은 비용이 청구됨',
  retail_audit_34: '제공 서비스 유형을 혼동하여 잘못된 수수료 청구',
  retail_audit_35:
    '현장 서비스 미이행, 직원이 계획된 장소에 배치되지 않음 | POS',
  retail_audit_36:
    '실제 수치가 아닌 추정치 기준으로 비용 청구 및 정산되지 않음',
  retail_audit_37: '판촉 지침을 잘못 적용하여 허위 데이터 제공',
  retail_audit_38: '우리는 어떻게 일하나요?',
  retail_audit_39:
    '감사 담당자가 에이전시의 실행 계획에 따라 지정된 POS 지점을 방문합니다.',
  retail_audit_40:
    '감사 담당자는 POS 자료 존재 여부, 브랜드 홍보대사 참여도, 판촉 지침 준수, 사기 방지 조치 등 브리핑에 명시된 주요 성과 지표(KPI)를 평가합니다.',
  retail_audit_41: '검증:',
  retail_audit_42: '우리는 수집한 데이터를 통합합니다.',
  retail_audit_43: '포괄적인 보고서를 작성합니다.',
  retail_audit_44:
    '검증팀은 모든 설문지를 프로젝트 브리핑 및 추가 코멘트 준수 여부 포함하여 철저히 검토합니다.',
  retail_audit_45: '온라인 보고 시스템:',
  retail_audit_46:
    '완료되고 검증된 설문지는 36시간 이내에 온라인 포털에 업로드됩니다.',
  retail_audit_47:
    '고객은 개인 계정을 통해 언제든지 진행 상황을 확인할 수 있습니다.',
  retail_audit_48: '결과 및 권장 사항이 포함된 최종 보고서를 제공합니다.',
  retail_audit_49: '전문가와 상담하기',
  retail_audit_50: '우리의 강점:',
  facility_check_audit_1: '시설',
  facility_check_audit_2: '점검 감사',
  facility_check_audit_3: '모든 세부 사항에서 브랜드 경험 향상',
  facility_check_audit_4: '우리의 접근 방식 탐색',
  facility_check_audit_5: '회사 소개',
  facility_check_audit_6: '우리는 누구인가',
  facility_check_audit_7:
    '글로벌 고객 경험 기업으로서 4Service는 브랜드가 탁월한 고객 경험을 창출하고 전달할 수 있도록 포괄적인 서비스를 제공합니다.',
  facility_check_audit_8: '우리의 시설 점검 감사 서비스',
  facility_check_audit_9:
    '는 매장 내 물리적 공간과 브랜드 존재감이 브랜드 표준을 충족하고 고객에게 긍정적인 인상을 주는지 확인하는 데 도움을 주기 위해 설계되었습니다.',
  facility_check_audit_10: '솔루션 1',
  facility_check_audit_11: '시설 점검 감사',
  facility_check_audit_12:
    '는 매장 또는 부스가 브랜드 기준과 얼마나 잘 부합하는지를 평가하는 세심한 점검입니다. 우리는 물리적 요소만 확인하는 것이 아니라 이러한 요소들이 고객의 브랜드 인식에 어떤 영향을 미치는지도 평가합니다.',
  facility_check_audit_13: '두 가지 솔루션',
  facility_check_audit_14: '두 가지 실행 방식',
  facility_check_audit_15: '방식',
  facility_check_audit_16: '전문 감사인에 의한 시설 점검 감사',
  facility_check_audit_17: '시설 점검의 검증',
  facility_check_audit_18: '보고서',
  facility_check_audit_19:
    '48시간 이내에 시각적 증거와 통계를 포함한 보고서를 받을 수 있습니다',
  facility_check_audit_20:
    '잘 수행된 시설 점검 감사는 브랜드에 여러 가지 이점을 제공할 수 있습니다:',
  facility_check_audit_21: '고객 전환율 향상:',
  facility_check_audit_22:
    '긍정적인 고객 경험은 판매 증가와 재구매로 이어질 수 있습니다. 당사의 감사는 고객 만족도에 영향을 줄 수 있는 문제점을 파악하고 해결하는 데 도움이 됩니다.',
  facility_check_audit_23: '브랜드 이미지 향상:',
  facility_check_audit_24:
    '오프라인 매장은 고객과의 주요 접점이며, 브랜드 이미지 형성에 중요한 역할을 합니다. 당사의 감사는 매장이 브랜드 가치와 일치하고 긍정적인 인상을 주는지 확인하는 데 도움이 됩니다.',
  facility_check_audit_25: '왜 저희인가요?',
  facility_check_audit_26: '시설 점검 감사가 중요한 이유는 무엇인가요?',
  facility_check_audit_27:
    '잘 수행된 시설 점검 감사는 브랜드에 여러 가지 이점을 제공할 수 있습니다:',
  facility_check_audit_28: '브랜드 이미지 향상:',
  facility_check_audit_29:
    '오프라인 매장은 고객과의 주요 접점이며, 브랜드 이미지 형성에 중요한 역할을 합니다. 당사의 감사는 매장이 브랜드 가치와 일치하고 긍정적인 인상을 주는지 확인하는 데 도움이 됩니다.',
  facility_check_audit_30: '고객 전환율 향상:',
  facility_check_audit_31:
    '긍정적인 고객 경험은 판매 증가와 재구매로 이어질 수 있습니다. 당사의 감사는 고객 만족도에 영향을 줄 수 있는 문제점을 파악하고 해결하는 데 도움이 됩니다.',
  facility_check_audit_32: '누구에게 필요할까요',
  facility_check_audit_33: '시설 점검 감사가 필요한 사람은 누구일까요?',
  facility_check_audit_34:
    '시설 점검 감사는 오프라인 매장과 실물 기반이 있는 모든 브랜드에 유용한 서비스입니다. 특히 다음과 같은 목표가 있는 브랜드에 중요합니다:',
  facility_check_audit_35: '브랜드 기준 준수 여부 확인:',
  facility_check_audit_36:
    '감사를 통해 매장이 브랜드 기준에서 벗어나는 부분을 식별할 수 있습니다.',
  facility_check_audit_37: '고객 경험 향상:',
  facility_check_audit_38:
    '감사를 통해 매장에서 고객 경험을 향상시킬 수 있는 기회를 식별할 수 있습니다.',
  facility_check_audit_39: '강력한 브랜드 구축:',
  facility_check_audit_40:
    '감사를 통해 오프라인 매장이 고객에게 긍정적인 인상을 주고 있는지 확인할 수 있습니다.',
  facility_check_audit_41:
    '직원 또는 미스터리 쇼퍼가 매장의 사진을 촬영합니다.',
  facility_check_audit_42: '그런 다음 설문지를 작성하고 사진을 첨부합니다.',
  facility_check_audit_43:
    '검증자가 사진을 수신하고 기준 준수 여부를 확인합니다.',
  facility_check_audit_44: '전문 감사인의 시설 점검 감사',
  facility_check_audit_45: '준비 단계:',
  facility_check_audit_46: '감사 일정의 공동 승인',
  facility_check_audit_47:
    '딜러에게 감사가 예정되어 있음을 사전 고지하고 준비시킵니다',
  facility_check_audit_48: '감사인 교육:',
  facility_check_audit_49:
    '4Service의 숙련된 교육자가 감사인에게 브랜드 가이드를 교육합니다',
  facility_check_audit_50: '감사 실행 단계:',
  facility_check_audit_51: '감사인은 특별 허가서를 가지고 매장을 방문합니다',
  facility_check_audit_52: '지침을 세밀하게 따르며 각 지점을 철저히 조사합니다',
  facility_check_audit_53:
    '본사 기준에 따른 평가와 함께 시각적 문서를 작성합니다',
  facility_check_audit_54: '최종 PPT 보고서',
  facility_check_audit_55: '결과를 설명하는 종합적인 파워포인트 보고서',
  facility_check_audit_56:
    '온라인 및 오프라인에서 감사 결과를 몰입감 있게 발표',
  facility_check_audit_57: '시설 점검 감사 검증',
  facility_check_audit_58: '단계:',
  facility_check_audit_59: '감사 실행 단계:',
  facility_check_audit_60:
    '브랜드 담당자는 4Service 앱을 사용하여 현장 사진을 촬영합니다',
  facility_check_audit_61: '엄격한 시각적 및 설명 기준을 준수합니다',
  facility_check_audit_62: '검증 단계:',
  facility_check_audit_63: '검증자는 각 보고서를 철저하게 검토합니다',
  facility_check_audit_64: '사진을 브랜드 기준과 종합적으로 비교합니다',
  facility_check_audit_65: '명확성을 위해 보고서에 주석과 통찰을 통합합니다',
  facility_check_audit_66: '필요한 경우 딜러와 직접 소통하여 명확히 합니다',
  facility_check_audit_67: '보고 단계:',
  facility_check_audit_68:
    '시각적 증거와 통계가 포함된 보고서는 이틀 이내에 제공됩니다',
  facility_check_audit_69: '지금 문의하세요',
  cx_solution_1: '우리는 단지 인사이트를 찾는 것이 아닙니다,',
  cx_solution_2: '비즈니스를 새로운 차원으로 끌어올립니다',
  cx_solution_3:
    '20년 이상의 고객 경험을 지닌 전문가들이 복잡한 솔루션을 발견하고, 귀사의 성장을 돕는 구체적인 실행 계획을 제공합니다',
  cx_solution_4:
    '미래에도 유효한 통합 솔루션에서 고유한 서비스 모음을 만나보세요',
  cx_solution_5: '올인원 고객 경험 솔루션',
  cx_solution_6: '광고 테스트',
  cx_solution_7: 'AI 및 신경마케팅',
  cx_solution_8: '고객의 소리',
  cx_solution_9: '데스크 리서치',
  cx_solution_10: '고객 여정 맵 (CJM)',
  cx_solution_11: '미스터리 쇼핑',
  cx_solution_12: 'CX 컨설팅',
  cx_solution_13: '소셜 미디어 리스닝',
  cx_solution_14: '정량적 및 정성적 조사',
  cx_solution_15: '서비스 디자인',
  cx_solution_16: '마케팅 전략',
  cx_solution_17: 'UX/UI 테스트',
  cx_solution_18: '타겟 인사이트',
  cx_solution_19: '귀하의 성공에 기여할 수 있어 영광입니다',
  cx_solution_20:
    '비즈니스의 목적과 목표에 따라 도구와 서비스를 맞춤화하고 결합하여 맞춤형 결과를 제공합니다',
  cx_solution_21: '종합 조사',
  cx_solution_22:
    '데이터 중심 시장에서 경쟁 우위를 제공하여 의사결정을 지원합니다.',
  cx_solution_23:
    '정성 조사는 개념, 의견 또는 경험을 이해하기 위한 비수치 데이터의 수집 및 분석입니다',
  cx_solution_24:
    '정량 조사 방법은 설문조사, 질문지, 투표 등을 통해 수집된 데이터를 객관적으로 측정하고 수치화하여 분석하는 방식입니다',
  cx_solution_25:
    '당사는 귀하의 특정 요구 사항에 따라 고유한 도구 세트를 활용합니다',
  cx_solution_26: '도구',
  cx_solution_27: 'CAWI',
  cx_solution_28:
    '컴퓨터 지원 웹 인터뷰링은 온라인 플랫폼을 통해 설문조사를 수행하고 데이터를 수집할 수 있게 해주는 중요한 도구로, 특수 소프트웨어의 도움을 받아 효율적이고 정확한 데이터 수집을 보장하여 고객의 시장 조사 요구를 충족시킵니다',
  cx_solution_29: 'CATI',
  cx_solution_30:
    '컴퓨터 지원 전화 인터뷰링은 우리가 전화로 설문조사를 수행하고 귀중한 데이터를 수집하기 위해 사용하는 방법으로, 특수 소프트웨어를 활용하여 프로세스를 간소화하고 시장 조사에서의 정확성을 확보합니다',
  cx_solution_31: 'F2F',
  cx_solution_32:
    '대면 인터뷰는 고객 및 소비자와의 직접적인 상호작용과 개인화된 참여를 통해 신뢰, 이해 및 효과적인 커뮤니케이션을 구축하여 지속 가능한 관계 형성과 비즈니스 성공을 촉진하는 데 필수적입니다',
  cx_solution_33: '문헌 조사',
  cx_solution_34:
    '문헌 조사는 포괄적인 데이터 수집과 분석을 포함하며, 인사이트를 수집하고 고객을 위한 전략적 의사결정을 알리는 연구 프로세스의 기초 단계입니다',
  cx_solution_35: 'SWOT 분석',
  cx_solution_36:
    'SWOT 분석은 내부의 강점과 약점, 외부의 기회와 위협을 식별하는 전략적 평가 도구로, 의사결정에 도움이 되는 인사이트를 제공하고 효과적인 비즈니스 전략 개발을 지원합니다',
  cx_solution_37: '민족지학적 조사',
  cx_solution_38:
    '사람들과 문화를 그들의 자연스러운 환경에서 몰입하고 관찰함으로써 연구하여 행동, 신념 및 사회적 역학에 대한 깊은 인사이트를 도출합니다',
  cx_solution_39: '심층 인터뷰',
  cx_solution_40:
    '심층 인터뷰는 우리가 사용하는 정성적 연구 방법으로, 참여자와 일대일로 깊이 있는 대화를 나누어 그들의 관점, 경험, 의견을 자세히 탐구하여 고객의 연구 목표와 의사결정 과정에 풍부한 인사이트와 이해를 제공합니다',
  cx_solution_41: '아이디에이션 세션',
  cx_solution_42:
    '아이디에이션 세션은 우리가 진행하는 협업적 브레인스토밍 세션으로, 다양한 관점과 전문성을 결합하여 고객의 문제나 기회를 위한 창의적인 아이디어와 솔루션을 창출하고 혁신을 촉진하며 전략적 이니셔티브를 추진합니다',
  cx_solution_43: '바이어 페르소나',
  cx_solution_44:
    '바이어 페르소나는 우리가 개발한 상세한 고객 프로필로, 조사와 데이터 분석을 바탕으로 고객사의 타깃 고객을 대표하며, 고객의 니즈, 선호도, 행동을 더 잘 이해하고 이에 맞춘 전략과 커뮤니케이션을 설계하여 효과적인 참여와 공감을 유도하고 비즈니스 성공을 촉진합니다',
  cx_solution_45: '미스터리 쇼핑',
  cx_solution_46:
    '미스터리 쇼핑은 우리가 제공하는 전략적 서비스로, 사전에 정의된 시나리오에 따라 고객과 회사 간의 상호작용을 측정하고 모니터링합니다',
  cx_solution_47: '동행 평가',
  cx_solution_48:
    '동행 평가는 고객의 전체 서비스 경험 동안 평가자가 함께 하여 고객 여정의 모든 측면에 대한 종합적인 인사이트를 제공하는 특수한 형태의 미스터리 쇼핑으로, 고객 서비스 전달에 대한 깊은 이해를 바탕으로 개선 방향을 제시합니다',
  cx_solution_49: '피드백 수집 분석',
  cx_solution_50:
    '피드백 수집 분석은 설문조사, 리뷰, 소셜 미디어 등 다양한 채널을 통해 고객 피드백을 체계적으로 수집 및 분석하는 핵심적인 과정으로, 귀중한 인사이트를 도출하고 트렌드를 식별하며, 제품, 서비스 및 전반적인 고객 경험 향상을 위한 데이터 기반 제안을 제공합니다',
  cx_solution_51: '포커스 그룹',
  cx_solution_52:
    '포커스 그룹은 특정 주제나 제품에 대해 다양한 참여자들이 심층적으로 토론하는 동적 연구 세션으로, 정성적 인사이트를 수집하고 태도, 선호도, 인식을 파악하며 아이디어와 개념을 탐색하여 고객의 의사결정 및 전략 수립을 지원합니다',
  cx_solution_53: '20년간 뛰어난 고객 경험을 구축해 온 역사',
  cx_solution_54: '귀하의 메시지가 청중의 관심을 끌고 공감되도록 하십시오.',
  cx_solution_55:
    '우리는 귀하의 기대를 뛰어넘는 결과를 제공하기 위해 헌신합니다',
  cx_solution_56: '우리는 귀하의 성장을 이끄는 복잡한 솔루션을 발견합니다',
  cx_solution_57: '당사의 방법론으로 고객 경험을 향상시키십시오',
  cx_solution_58:
    '고객 여정 맵은 대상 고객 정의, 니즈 및 환경 파악, 매력적인 경험 제공 계획 수립을 포함합니다',
  cx_solution_59: 'BHT',
  cx_solution_60:
    '브랜드 건강 추적 조사는 브랜드 인지도, 사용도, 브랜드 포지셔닝, 성과 등을 측정할 수 있습니다',
  cx_solution_61: 'CSI',
  cx_solution_62:
    '고객 만족도 지수는 고객이 회사의 제품 / 서비스에 얼마나 만족하는지를 나타내는 점수입니다.',
  cx_solution_63:
    '가격 모니터링은 경쟁사의 가격을 수집, 처리 및 분석하는 과정입니다',
  cx_solution_64: 'NPS',
  cx_solution_65:
    '순추천지수는 고객 경험 지표의 금본위이며, 다음 질문을 기반으로 합니다: 귀하는 해당 조직/제품/서비스를 얼마나 추천하고 싶습니까?',
  cx_solution_66: 'HR 리서치',
  cx_solution_67:
    '인사 리서치는 HR 관행과 성과를 평가하며, 현재 개발 및 관리에 대한 자세한 분석을 제공합니다',
  cx_solution_68:
    '사용성 테스트는 실제 사용자가 웹사이트, 앱 또는 기타 제품과 상호작용하는 방식과 그에 대한 반응을 관찰하는 과정입니다',
  cx_solution_69: '기타',
  cx_solution_70: '전문가들이 귀사에 최적화된 방법론을 선택합니다',
  cx_solution_71: '지금 시작해 보세요',
  cx_solution_72: '1 - 킥오프 미팅',
  cx_solution_73:
    '킥오프 미팅 중에는 주요 작업을 식별하고 초점을 맞춥니다. 결과: 목표, 조사 과제, 마감일, 방법, 책임 영역에 대한 이해',
  cx_solution_74: '2 - 콘셉트 개발',
  cx_solution_75:
    '4Service 분석 부서는 데이터를 통합하고 보고서 구조를 조정합니다. 이후 우리는 고객에게 결과를 프레젠테이션하고, 인사이트 및 실행 권장 사항을 보완하여 제공합니다.',
  cx_solution_76: '3 - 필드워크',
  cx_solution_77:
    '조사를 수행하기 위해 참여자를 모집하고 인터뷰 및 기타 기본 조사 단계를 수행합니다. 고객은 전사된 오디오-비디오 인터뷰 및 간결한 요약을 받습니다.',
  cx_solution_78: '4 - 분석',
  cx_solution_79:
    '4Service 분석 부서는 데이터를 통합하고 보고서 구조를 조정합니다. 이후 우리는 고객에게 결과를 프레젠테이션하고, 인사이트 및 실행 권장 사항을 보완하여 제공합니다.',
  cx_solution_80: '5 - 워크숍',
  cx_solution_81: '고객과 함께 실행 계획에 대해 논의하는 워크숍을 진행합니다',
  cx_solution_82: '당사의 모범 사례에 대해 자세히 알아보세요',
  cx_solution_83:
    '고객 여정 맵은 모든 커뮤니케이션 채널을 신속하게 검토하고, 주요 접점에서의 잠재적 결함을 식별하며, 계획된 흐름에서 벗어나는 영역을 포괄적으로 이해할 수 있도록 도와줍니다.',
  cx_solution_84: '언제 사용해야 하나요?',
  cx_solution_85:
    '청중 그룹에 대한 실제 데이터를 기반으로 맞춤형 광고 캠페인을 구축하십시오',
  cx_solution_86:
    '다양한 타깃 고객 세그먼트의 트리거를 파악하고 그들의 니즈를 충족시키십시오',
  cx_solution_87: '각 그룹을 정확하게 타겟팅하여 최대 전환을 이끌어내십시오',
  cx_solution_88:
    '동행 평가 기법은 귀하의 목표를 달성할 수 있는 최적의 방법을 평가하는 데 도움을 줍니다.',
  cx_solution_89: '신규 웹사이트 또는 제품 출시 전 테스트',
  cx_solution_90: '변경 사항을 구현하기 전 프로세스 점검',
  cx_solution_91: '판매 감소 시 웹사이트 또는 제품 평가',
  cx_solution_92: '고객 선호에 맞춘 신제품 출시',
  cx_solution_93: '경쟁사를 분석하여 시장에서 선도적인 위치를 확보',
  cx_solution_94:
    '우리는 고객 중심의 서비스 모델을 만들기 위한 포괄적인 360° 접근 방식을 제공합니다.',
  cx_solution_95: '직원 교육 및 개발',
  cx_solution_96: '서비스 기준 향상',
  cx_solution_97: '고객 유입 및 매출 증가',
  cx_solution_98: '직원을 위한 KPI 설정 및 동기부여 시스템',
  cx_solution_99: '당사의 성공 사례를 확인해 보세요',
  cx_solution_100: '자동차 산업',
  cx_solution_101: '담배',
  cx_solution_102: '소매업',
  cx_solution_103: '정성적 단계',
  cx_solution_104: '정량적 단계 (세분화)',
  cx_solution_105: '포커스 그룹',
  cx_solution_106: '전 세계 온라인 청중 도달',
  cx_solution_107: '인터뷰 중 다양한 기법 혼합',
  cx_solution_108: '오직 개방형 질문',
  cx_solution_109: '24시간 365일 응답자 지원',
  cx_solution_110: '중요한 세부 정보와 경로의 실제 모습 보존',
  cx_solution_111: '시장 조사',
  cx_solution_112: '회사 및 경쟁사 진단',
  cx_solution_113: '업데이트된 서비스 모델 및 신규 비즈니스 프로세스',
  cx_solution_114: '고객 중심 서비스 촉진',
  cx_solution_115: '서비스 전략 개발 및 변화 이행 및 통제',
  usage_attitude_1: '사용 및 \n 태도 (U&A)',
  usage_attitude_2:
    '타겟 오디언스가 브랜드를 어떻게 인식하고, 활용하며, 참여하는지를 종합적으로 파악하세요.',
  usage_attitude_3: '전문가와 상담하기',
  usage_attitude_4: '소개',
  usage_attitude_5:
    '<b>소비자 습관을 탐색하여</b> 선호도와 영향 요인을 심층적으로 파악하세요',
  usage_attitude_6:
    "<b>소비자 선택의 '이유'</b>를 세밀한 분석을 통해 알아보세요",
  usage_attitude_7:
    '<b>고객이 제품과 어떻게 상호작용하는지</b> 이해하여 전략적 인사이트 확보',
  usage_attitude_8:
    '<b>소비자 행동, 습관 및 선호도에 대한 인사이트</b>를 확보하여 정보에 기반한 의사결정 가능',
  usage_attitude_9: '경험',
  usage_attitude_10:
    '고객 경험 분야에서 20년 이상의 경력을 보유한 4Service 전문가들이 귀하의 비즈니스 성장을 돕는 고유한 솔루션을 제공합니다',
  usage_attitude_11: '문의하기',
  usage_attitude_12: '대상',
  usage_attitude_13:
    '브랜드 사용 및 태도 조사로 혜택을 보는 사람은 누구인가요?',
  usage_attitude_14: '다양한 산업 및 서비스 분야는 다음에 관심이 있습니다:',
  usage_attitude_15: '<b>고객의 요구와 불편 사항</b>을 인식',
  usage_attitude_16: '<b>고객 소비 촉진 기회</b> 식별',
  usage_attitude_17: '<b>신제품 카테고리 또는 마케팅 전략</b> 개발',
  usage_attitude_18: '<b>경쟁 환경에 대한 심층 이해</b> 확보',
  usage_attitude_19: '방법론은 고객의 요청에 따라 개별적으로 선정됩니다',
  usage_attitude_20:
    '<b>정성 조사</b>는 개념, 의견 또는 경험을 이해하기 위해 비수치적 데이터를 수집 및 분석하는 것입니다.',
  usage_attitude_21:
    '<b>정량 조사</b> 방법은 설문, 질문지 및 조사 등을 통해 수집된 데이터를 객관적으로 측정하고 수치적으로 분석하는 것을 포함합니다.',
  usage_attitude_22:
    '<b>데이터 수집 후</b> 전문가들이 정보를 분석하고 결론을 도출하여 최상의 추천을 제공합니다.',
  usage_attitude_23: '누가 필요로 하나요',
  usage_attitude_24: '귀하의 성공 스토리는 여기서 시작됩니다',
  usage_attitude_25:
    '<b>소비자 행동에 대한 깊은 이해를 바탕으로</b> 전략적 의사결정을 가능하게 하는 가치 있는 인사이트를 제공하는 리서치를 받게 됩니다.',
  usage_attitude_26:
    '<b>이 조사는 브랜드 전략을</b> 소비자 선호 및 태도에 보다 밀접하게 정렬하여 개선 및 최적화할 수 있는 견고한 기반을 제공합니다.',
  usage_attitude_27: '솔루션',
  usage_attitude_28: '당사의 솔루션으로 다양한 기회를 탐색하세요',
  usage_attitude_29: '카테고리 내 제품 선호도',
  usage_attitude_30:
    '식품, 음료, 의류, 전자제품 등 다양한 카테고리에서 소비자의 최상위 선호도를 파악합니다.',
  usage_attitude_31: '소비 / 사용 행동',
  usage_attitude_32:
    '특정 제품/서비스의 소비 또는 사용 빈도를 분석하고, 사용과 연관된 경우 및 상황을 파악합니다.',
  usage_attitude_33: '구매 행동',
  usage_attitude_34:
    '고객이 구매 시 사용하는 채널을 조사하고, 그들이 신뢰하는 정보 출처를 파악합니다.',
  usage_attitude_35: '소비자 동기 및 니즈',
  usage_attitude_36:
    '소비에 영향을 미치는 동기와 장벽을 조사합니다. 소비자 구매 결정에 영향을 미치는 요인을 평가합니다. 제품 카테고리에 대한 인식을 탐색하고 가격이 어떻게 인식되는지 분석합니다.',
  usage_attitude_37: '우리의 접근 방식',
  usage_attitude_38: '브랜드 사용 및 태도 조사',
  usage_attitude_39: '정보',
  usage_attitude_40: '정량적 및 정성적 방법을 모두 활용한 설문조사 실시',
  usage_attitude_41: '시작',
  usage_attitude_42: '개별 요청에 따라 목표를 설정하고 방법을 결정',
  usage_attitude_43: '분석',
  usage_attitude_44: '전문가들이 사용하는 정교한 기법',
  usage_attitude_45:
    '귀하의 구체적인 요구에 따라 고유한 도구 세트를 사용합니다',
  usage_attitude_46: 'CATI',
  usage_attitude_47:
    '컴퓨터 지원 전화 인터뷰(CATI)는 전화를 통해 설문조사를 실시하고 데이터를 수집하는 방식으로, 특수 소프트웨어를 사용하여 과정의 효율성과 정확성을 확보합니다.',
  usage_attitude_48: 'CAWI',
  usage_attitude_49:
    '컴퓨터 지원 웹 인터뷰(CAWI)는 온라인 플랫폼을 통해 설문조사 및 데이터 수집을 가능하게 하는 중요한 도구로, 특수 소프트웨어를 통해 고객의 시장 조사 요구에 맞춘 효율적이고 정확한 데이터 수집을 보장합니다.',
  usage_attitude_50: 'CAPI',
  usage_attitude_51:
    '컴퓨터 지원 대면 인터뷰(CAPI)는 데이터 수집을 최적화하고 인터뷰를 원활하게 진행하며 귀하의 비즈니스에 필요한 정확하고 유익한 결과를 보장하는 방법입니다.',
  usage_attitude_52: '포커스 그룹',
  usage_attitude_53:
    '포커스 그룹은 다양한 참가자들을 모아 특정 주제나 제품에 대해 심도 있게 논의하도록 유도하는 역동적인 조사 세션으로, 정성적 인사이트를 수집하고 태도, 선호도 및 인식을 파악하며 아이디어와 개념을 탐색하고 궁극적으로 고객의 의사결정 및 전략 수립을 지원합니다.',
  usage_attitude_54: 'F2F',
  usage_attitude_55:
    '대면 인터뷰(F2F)는 우리의 접근 방식에서 핵심적인 요소로, 고객과의 직접 상호작용과 맞춤형 소통을 가능하게 하여 신뢰와 이해를 구축하고 지속 가능한 관계 형성과 비즈니스 성공을 촉진합니다.',
  usage_attitude_56: '민족지학 연구',
  usage_attitude_57:
    '사람들과 문화를 그들의 자연스러운 환경 속에서 몰입과 관찰을 통해 연구하며, 행동, 신념 및 사회적 역학에 대한 깊은 인사이트를 이끌어냅니다.',
  thank_you_page: '시간을 내주셔서 감사합니다! 담당자가 곧 연락드릴 것입니다.',
  back_main: '메인으로 돌아가기',
  opportunities_1: '당사의 사례에 대해 자세히 알아보세요',
  opportunities_2: '발견하기',
  opportunities_3: '직접 경험해보세요',
  opportunities_4: '기회',
  opportunities_5: '4Service 리서치 홀딩과 함께하는 국제 비즈니스의 기회',
  opportunities_6:
    '당사는 어떤 <span>제품</span>으로 귀사의 비즈니스를 강화할 수 있을까요?',
  opportunities_7: 'CX',
  opportunities_8: '비즈니스를 위한 맞춤형 종합 솔루션',
  opportunities_9: '모든 유형의 미스터리 쇼핑',
  opportunities_10:
    '미스터리 직원, 미스터리 콜러, 럭셔리 미스터리 쇼퍼, 자동차 미스터리 쇼퍼 등 다양한 유형을 수행합니다',
  opportunities_11: '비즈니스 맞춤형 IT 솔루션',
  opportunities_12: 'AI 기반 자사 IT 솔루션, 피드백 분석 및 통화 전사 플랫폼',
  opportunities_13: '시장 조사',
  opportunities_14:
    '모든 비즈니스 요청에 대한 솔루션 (브랜드 건강 추적, 세분화, NPS, eNPS, CJM, 제품 및 광고 테스트 등)',
  opportunities_15: '감사',
  opportunities_16:
    '다양한 서비스 감사 및 가격 모니터링 수행 (오프라인, 특정 틈새 등)',
  opportunities_17: '서비스 디자인',
  opportunities_18:
    '4Service는 DesignThinkers Academy의 인증 파트너로, 팀을 위한 기업 교육을 제공하며 정기적으로 워크숍을 진행합니다',
  opportunities_19:
    '우리는 경험을 공유하지만 <span>귀하의 비즈니스 프로세스를 존중하고 방해하지 않습니다</span>.',
  opportunities_20:
    '비즈니스가 성장하는 과정에서 직면하는 어려움을 알고 있으며, 국제적인 성공 사례를 통해 이를 극복하는 방법을 알고 있습니다. 귀하는 경험뿐만 아니라 자원도 얻게 됩니다.',
  opportunities_21: '협력을 제안드립니다!',
  opportunities_22:
    '귀하의 비즈니스를 위한 <span>파트너십 프로그램</span>을 제공합니다',
  opportunities_23:
    '국제적으로 인정받는 4Service 브랜드 하에 신규 고객 유치에 긍정적인 영향을 줄 수 있습니다.',
  opportunities_24:
    '파트너는 교육, 마케팅 자료, 운영 지원을 포함한 포괄적인 지원을 받습니다.',
  opportunities_25:
    '당사와의 파트너십은 귀하의 현재 비즈니스 프로세스를 방해하지 않고 계획을 실현할 수 있게 합니다.',
  opportunities_26: '당사의 <span>사무소</span>',
  opportunities_27: '당사의 고객',
  opportunities_28: '우리는 CX 분야에서 20년 이상의 경험을 보유하고 있습니다',
  opportunities_29: '서비스 국가',
  opportunities_30: '천',
  opportunities_31: '독창적인 프로젝트',
  opportunities_32: '백만',
  opportunities_33: '미스터리 쇼퍼 방문 수',
  opportunities_34: '유럽 TOP 10 CX 에이전시에 포함됨',
  opportunities_35: '4Service와 함께하는 귀하의 기회',
  opportunities_36: '수익 증가',
  opportunities_37: '국제 주문에 접근할 수 있습니다',
  opportunities_38: '독창적인 CX 접근 방식',
  opportunities_39: '20년 경력 전문가의 지원',
  opportunities_40: '지원',
  opportunities_41: '우리 팀이 결과 달성을 지원합니다',
  opportunities_42: '영업',
  opportunities_43: '판매 시스템 구축을 지원합니다',
  opportunities_44: '소프트웨어 접근',
  opportunities_45: '모든 인증된 IT 도구에 접근할 수 있습니다',
  opportunities_46: '교육',
  opportunities_47: '직원 교육뿐만 아니라 지속적인 컨설팅도 제공합니다',
  opportunities_48: '누가 파트너십에 적합한가요?',
  opportunities_49: '귀하의 비즈니스가 마케팅 조사와 관련이 있나요?',
  opportunities_50: '아니면 새로운 분야에 도전해보고자 하시나요',
  opportunities_51: '다음을 계획하고 계신가요:',
  opportunities_52: '혁신 도입',
  opportunities_53: '국제 브랜드와 협업',
  opportunities_54: '제품 포트폴리오 확장',
  opportunities_55: '시장 내 입지 강화?',
  opportunities_56: '직원 교육',
  opportunities_57: '비즈니스 확장',
  opportunities_58: '당사의 자원 = 귀하의 자원',
  opportunities_59:
    '당사의 풍부한 경험을 바탕으로 협력 초기 단계에서 귀하와 이를 공유할 준비가 되어 있습니다',
  opportunities_60: '데이터 분석:',
  opportunities_61: '국제 분석 팀',
  opportunities_62: '데이터 처리 방식 - SPSS, Power BI',
  opportunities_63: '혁신적인 방법론 및 다양한 방법론',
  opportunities_64: '모든 형식의 보고서 제공',
  opportunities_65: '소프트웨어:',
  opportunities_66: '자체 맞춤형 IT 개발',
  opportunities_67: 'CAPI용 DigSee Sure',
  opportunities_68: 'CAWI용 SurveyMonkey',
  opportunities_69: 'Shopmetrics',
  opportunities_70: 'VoIPTime (콜센터)',
  opportunities_71: '마케팅 지원:',
  opportunities_72: 'PR 지원',
  opportunities_73: '홍보 및 콘텐츠 제작 지원',
  opportunities_74: '리드 생성 프로세스 설정',
  opportunities_75: 'IT 지원:',
  opportunities_76: '소프트웨어 설치, 구성 및 사용에 대한 기술 지원',
  opportunities_77: '원격 지원',
  opportunities_78: '보안 관리',
  opportunities_79: '운영 지원:',
  opportunities_80: '현장 프로세스 설정 지원',
  opportunities_81: '부정 행위 방지 시스템',
  opportunities_82: '복잡도에 상관없는 리크루팅',
  opportunities_83: '프로젝트 및 현장 부서 팀의 운영 관리',
  opportunities_84: '채용 품질 관리',
  opportunities_85: 'UpWork',
  opportunities_86: '어떤 혜택을 받을 수 있나요?',
  opportunities_87: '고객 기반 확대',
  opportunities_88: '시장 이미지 강화',
  opportunities_89: '고객 이탈 위험의 다각화',
  opportunities_90: '기술 프로세스 최적화',
  opportunities_91: '국제 경험',
  opportunities_92: '기존 고객 대상 판매 증대',
  main_67:
    '경쟁력 있는 가격 분석은 소비자의 지불 의사 데이터를 활용하여 주요 기능을 식별함으로써 제안을 최적화하고, 수익을 증가시키며, 시장 점유율을 확대합니다',
  main_68:
    '소매점이 브랜드 기준에 부합하는지 보장하고, 물리적 속성과 고객 인식에 미치는 영향을 평가합니다',
  main_69: 'CX 솔루션',
  main_70:
    '당사의 독창적인 360도 CX 솔루션을 확인해보세요: 귀사의 목표에 따라 도구와 서비스를 맞춤화하여 비즈니스를 추진합니다',
  main_71: '음성 분석',
  main_72:
    '당사의 고급 음성 분석 도구는 음성을 텍스트로 전사하여 고객 경험 개선, 성과 모니터링, 규정 준수 보장 및 성장을 위한 귀중한 인사이트를 제공합니다',
  parthership: '파트너십',
  banner_1: 'CX 컨설팅 및 서비스 - 비즈니스에 대한 360° 뷰',
  banner_2: '최신 연구 정보를 받아보세요!',
  banner_3: '개인정보 처리방침에 따라 개인정보 처리에 동의합니다',
  banner_4: '*시장 선택',
  banner_5: '구독해 주셔서 감사합니다!',
  banner_6: '가장 흥미로운 콘텐츠만 공유해드릴게요!',
  banner_7: '제출',
  banner_8: '우크라이나어',
  banner_9: '카자흐스탄',
  brand_awareness_1: '브랜드 인지도',
  brand_awareness_2: '및 사용',
  brand_awareness_3:
    '비즈니스 성공을 위한 브랜드 인지도와 사용의 잠재력을 발휘하세요',
  brand_awareness_4: '전문가에게 문의하세요',
  brand_awareness_5: '정보',
  brand_awareness_6: '<b>브랜드의</b> 인식도 및 친숙도를 평가합니다',
  brand_awareness_7: '<b>타겟 시장 내</b> 브랜드 인지도 수준을 확인합니다',
  brand_awareness_8: '<b>유지율과 충성도</b>를 면밀히 모니터링합니다',
  brand_awareness_9: '<b>필요한 지표를 향상시킬</b> 최적의 전략을 선택합니다',
  brand_awareness_10: '당사의 솔루션을 통해 수많은 기회를 탐색하세요',
  brand_awareness_11: '브랜드 인지도',
  brand_awareness_12: '브랜드 사용',
  brand_awareness_13: '<b>소비자 세그먼트에서</b> 브랜드 인지도를 확인하세요',
  brand_awareness_14: '<b>청중 사이의</b> 인지도 수준을 모니터링하세요',
  brand_awareness_15: '<b>구매 직전 소비자의</b> 자발적 생각을 연구하세요',
  brand_awareness_16: '<b>브랜드 인지도를 높이는</b> 주요 출처를 이해하세요',
  brand_awareness_17:
    '<b>귀하의 브랜드 제품/서비스를 경험한</b> 소비자 수를 고려하세요',
  brand_awareness_18: '<b>처음 사용 후 브랜드에 충성한</b> 소비자를 식별하세요',
  brand_awareness_19: '<b>브랜드 추천 가능성</b>을 확인하세요',
  brand_awareness_20: '<b>미래 사용을 고려하는</b> 소비자의 비율을 파악하세요',
  brand_awareness_21: '누가 브랜드 인지도 및 사용의 혜택을 받나요?',
  brand_awareness_22: '신제품을 출시하는 기업',
  brand_awareness_23: '기존 브랜드를 재활성화하는 기업',
  brand_awareness_24:
    '브랜드 인지도 및 사용 현황을 이해하고 개선하려는 모든 기업',
  brand_awareness_25:
    '당사의 방법론은 브랜드 인지도 및 사용을 최적화하기 위한 귀중한 인사이트를 제공합니다',
  brand_awareness_26: '방법론은 고객 요청에 따라 개별적으로 선택됩니다',
  brand_awareness_27: '브랜드 사용 퍼널 방법론',
  brand_awareness_28:
    '트라이얼율은 브랜드를 인지하고 제품/서비스를 사용해본 청중의 비율을 나타냅니다',
  brand_awareness_29:
    '반복율은 브랜드를 인지하고 사용한 청중 중 지난 12개월 동안 계속해서 제품이나 서비스를 구매한 비율을 나타냅니다',
  brand_awareness_30:
    '유지율은 지난 6개월간 브랜드 제품이나 서비스를 지속적으로 사용한 개인의 비율을 나타냅니다',
  brand_awareness_31:
    '유지율은 지난 6개월 동안 브랜드 제품/서비스를 사용한 후 계속해서 선택하고 충성도를 유지한 고객의 비율을 보여줍니다',
  brand_awareness_32: '브랜드 인지도 방법론',
  brand_awareness_33:
    '가장 먼저 떠오르는 것(TOM)은 응답자가 자발적으로 가장 먼저 언급한 브랜드입니다',
  brand_awareness_34:
    '총 자발적 인지도는 TOM을 포함한 자발적 언급의 총합입니다',
  brand_awareness_35:
    '보조 인지도는 질문 시 사용자에게 브랜드가 얼마나 인식되는지를 보여줍니다',
  brand_awareness_36: '브랜드 속성 성과 맵',
  brand_awareness_37:
    '이 도구는 다양한 브랜드 속성의 중요성을 평가하고 시각적으로 표현하여 각 속성이 브랜드 성과와 소비자 인식에 어떻게 기여하는지를 보여줍니다',
  brand_awareness_38:
    '종합적인 분석을 통해 브랜드 영향력을 강화할 수 있는 핵심을 파악하세요',
  brand_awareness_39: '브랜드 지각 맵',
  brand_awareness_40:
    '이 도구는 경쟁 시장 환경에서 소비자 인식을 시각적으로 표현합니다. 이 접근 방식은 브랜드 간의 차이점을 명확히 구분하고 중요한 시장 속성을 강조하는 데 필수적입니다',
  brand_awareness_41:
    '브랜드와 그 특징 간의 관계를 관찰하고 해석하는 과정을 간소화합니다',
  brand_awareness_42:
    '특정 브랜드가 특정 속성과 가까울수록 해당 속성과의 강한 연관성을 의미합니다. 마찬가지로 두 브랜드가 가까울수록 유사성이 많고, 공통 이미지를 공유하며 동일한 시장 세그먼트에 속함을 나타냅니다',
  consumer_journey_map_1: '소비자 여정 맵',
  consumer_journey_map_2:
    '우리의 소비자 여정 지도를 통해 비즈니스의 장벽을 발견하고 극복하세요',
  consumer_journey_map_3: '신뢰받는 기업',
  consumer_journey_map_4: '4Service',
  consumer_journey_map_5:
    '소비자와 브랜드 간 상호작용을 최적화하기 위한 CJM의 잠재력을 활용하세요',
  consumer_journey_map_6:
    '소비자가 제품을 구매하기 전 어떤 단계를 거치는지 파악하세요',
  consumer_journey_map_7:
    '가상의 고객이 아닌 실제 고객으로부터 인사이트를 얻으세요',
  consumer_journey_map_8: '고객 경험에 대한 포괄적인 이해를 얻으세요',
  consumer_journey_map_9: '놓친 기회를 식별하고 경쟁사와 비교 분석하세요',
  consumer_journey_map_10: '우리의 CJM 접근 방식을 확인하세요',
  consumer_journey_map_11:
    '우리는 다양한 채널과 일정 기간 동안 제품, 서비스, 회사 또는 브랜드와의 소비자 상호작용 경로를 설계합니다.',
  consumer_journey_map_12:
    '구매 완료 전 소비자가 거치는 단계와 각 단계에서 고객의 기대, 감정 및 동기를 설명합니다.',
  consumer_journey_map_13: '우리와 함께 얻는 이점',
  consumer_journey_map_14:
    '우리는 글로벌 비즈니스 성공의 복잡함을 이해하는 경험 많은 전문가 팀을 제공합니다',
  consumer_journey_map_15: '기대 이상의 결과를 제공하기 위해 헌신합니다',
  consumer_journey_map_16: '성장에 기여하는 복합 솔루션을 찾아냅니다',
  consumer_journey_map_17: '맞춤형 CJM 솔루션을 전문적으로 제공합니다',
  consumer_journey_map_18: '상담 예약하기',
  consumer_journey_map_19: '데이터 기반 의사결정',
  consumer_journey_map_20: '가정이 아닌 실제 데이터에 기반하여 결정하세요',
  consumer_journey_map_21: '귀하의 CJM 최적화하기',
  consumer_journey_map_22:
    '고객 여정의 모든 단계에서 그들의 요구와 기대를 충족시켜 더 강한 관계를 구축하세요',
  consumer_journey_map_23: '시장 선도',
  consumer_journey_map_24: '경쟁사와 비교하고 시장에서 앞서 나가세요',
  consumer_journey_map_25: '추천 사항',
  consumer_journey_map_26:
    '우리의 CJM 추천을 실행하여 성공을 열고, 고객 충성도를 높이며, 매출을 증대하고, 비즈니스 잠재력을 극대화하세요',
  consumer_journey_map_27:
    '소비자 여정 지도를 통해 실제 소비자 여정을 파악하세요',
  consumer_journey_map_28:
    '20년 이상의 경험을 가진 전문가들이 포괄적인 조사를 제공합니다',
  consumer_journey_map_29:
    '정성적 조사는 개념, 의견 또는 경험을 파악하기 위해 비수치 데이터를 수집하고 분석하는 것입니다.',
  consumer_journey_map_30:
    '정량적 연구 방법은 설문조사, 질문지 및 여론조사를 통해 수집된 데이터를 객관적으로 측정하고 수치로 분석합니다.',
  consumer_journey_map_31:
    '데이터 수집 후, 전문가들은 정보를 분석하고 최선의 추천을 제공하기 위해 결론을 도출합니다.',
  boarding_1: '고객 여정 지도',
  boarding_2:
    '고객 여정 매핑(CJM)은 대상 고객을 정의하고, 그들의 필요와 환경을 이해하며, 몰입감 있는 경험을 제공하기 위한 계획을 수립하는 것입니다',
  boarding_3: '순추천지수',
  boarding_4:
    '순추천지수(NPS)는 고객 경험 지표의 황금 기준으로, 단 하나의 질문을 기반으로 합니다: "귀하는 이 조직/제품/서비스를 추천할 가능성이 얼마나 됩니까?"',
  boarding_5: '브랜드 건강 추적',
  boarding_6:
    '브랜드 건강 추적(BHT) 조사는 인지도와 사용, 브랜드 포지셔닝, 브랜드 성과에 대한 브랜드의 성과를 측정할 수 있습니다',
  boarding_7: '인사 연구',
  boarding_8:
    '인사 연구는 HR 관행 및 성과를 평가하고 현재 개발 및 관리에 대한 상세한 분석을 제공합니다',
  boarding_9: 'UX 테스트',
  boarding_10:
    '사용자 경험(UX) 테스트는 실제 사람들이 웹사이트, 앱 또는 기타 제품과 상호작용하는 방식과 그들의 행동 및 반응을 관찰하는 것입니다',
  boarding_11: '고객 만족 지수',
  boarding_12:
    '고객 만족도는 귀사의 제품 또는 서비스 구매에 대한 고객의 기대 충족 정도를 측정합니다',
  boarding_13: '광고 테스트',
  boarding_14:
    '광고 캠페인은 큰 투자입니다. 귀하의 광고가 효과적이고 ROI를 극대화하는지 확인하세요',
  boarding_15: '현장 감사/소매 감사',
  boarding_16:
    '매장 또는 브랜드에 대한 세부 데이터를 수집하고 성장 장벽을 분석하며 이를 극복하기 위한 효과적인 전략을 수립하세요',
  boarding_17: 'Play4Sales',
  boarding_18: '성과 관리 소프트웨어. 판매 증대를 위한 게임화된 애플리케이션',
  boarding_19: 'Voicer',
  boarding_20:
    '피드백 관리 시스템. 하나의 시스템에서 고객의 목소리를 수집. 고객 피드백 관리 시스템',
  boarding_21: '정성적 연구',
  boarding_22:
    '정성적 연구는 개념, 의견 또는 경험을 이해하기 위해 비수치 데이터를 수집하고 분석하는 것입니다',
  boarding_23: '정량적 연구',
  boarding_24:
    '정량적 연구 방법은 설문, 질문지, 여론조사를 통해 수집된 데이터를 객관적으로 측정하고 수치 분석하는 것입니다',
  boarding_25: '미스터리 쇼핑',
  boarding_26:
    '미스터리 쇼핑은 사전에 정의된 시나리오를 바탕으로 고객과 회사 간 상호작용을 측정하고 모니터링하는 시장 조사 기법입니다',
  boarding_27: 'Wantent',
  boarding_28:
    'AI 기반 콘텐츠 인텔리전스 플랫폼으로, 청중으로부터 인사이트를 제공합니다',
  boarding_29: '가격 모니터링',
  boarding_30:
    '가격 모니터링은 경쟁사의 가격을 수집, 처리, 분석하는 과정입니다',
  boarding_31: '서비스 디자인',
  boarding_32:
    '서비스 디자인은 제품 또는 서비스를 사용할 사람들의 욕구와 필요를 이해하기 위해 그들과 시간을 보내는 것입니다',
  boarding_33: '자동차 산업 가격 분석',
  boarding_34:
    '경쟁 가격 분석은 소비자의 지불 의향 데이터를 활용하여 주요 기능을 식별하고, 제안을 최적화하며, 수익을 높이고 시장 점유율을 향상시킵니다',
  boarding_35: '시설 점검 감사',
  boarding_36:
    '귀하의 소매점이 브랜드 기준에 부합하는지 확인하며, 물리적 특성과 그것이 고객 인식에 미치는 영향을 평가합니다',
  boarding_37: 'CX 솔루션',
  boarding_38:
    '우리의 독특한 360도 CX 솔루션을 확인하세요: 귀하의 비즈니스 목표에 맞춰 도구와 서비스를 맞춤 구성합니다',
  boarding_39: '음성 분석',
  boarding_40:
    '고급 음성 분석 도구는 음성 언어를 텍스트로 전환하여 고객 경험 향상, 성과 모니터링, 규정 준수 확보, 성장을 촉진하는 데 유용한 인사이트를 제공합니다',
  boarding_41: '사용 및 태도',
  boarding_42:
    '사용법과 태도는 실용적인 사용 패턴과 심리적 태도를 분석하여 브랜드와의 관여 방식을 이해하고 맞춤형 마케팅 및 제품 전략을 가능하게 하는 접근 방식입니다.',
  boarding_43: '브랜드 인지도 및 사용',
  boarding_44:
    '브랜드 인지도 및 사용은 대상 시장 내에서의 인지도, 친숙도, 상호작용 빈도 및 유지율을 평가하여 브랜드 가시성과 참여도를 향상시키는 것을 포함합니다.',
  boarding_45: '브랜드 아이덴티티 및 포지셔닝',
  boarding_46:
    '브랜드 아이덴티티와 포지셔닝은 소비자 인식, 다양한 청중의 관점, 브랜드에 대한 인식을 밝혀내는 종합적인 분석입니다.',
  boarding_47: '고객 프로파일링 및 세분화',
  boarding_48:
    '고객 프로파일링 및 세분화는 공통된 특성에 따라 목표 시장을 구분하여 특정 청중 세그먼트에 맞는 맞춤형 전략을 수립할 수 있도록 합니다.',
  boarding_49: '소비자 여정 맵',
  boarding_50:
    '소비자 여정 맵은 제품이나 브랜드와 상호작용하는 동안 소비자가 경험하는 단계, 접점, 감정 및 동기를 시각적으로 표현한 것입니다.',
  boarding_51:
    '실행 가능한 인사이트를 제공하고 비즈니스에 영향력 있는 결과를 이끌어내기 위한 우리의 헌신을 뒷받침하는 혁신적인 기법을 알아보세요.',
  boarding_52:
    '산업에 맞춘 데이터 기반 인텔리전스를 갖춘 제품군을 탐색하여 정보에 입각한 결정을 내리고 앞서 나가세요.',
  boarding_53:
    '종합적인 시장 조사 솔루션으로 시장 동향, 소비자 행동 및 경쟁 환경을 깊이 있게 파악하세요.',
  boarding_54: '애드 혹 조사',
  boarding_55:
    '애드 혹 조사는 특정 이슈를 해결하기 위해 기존 방법론의 조합이나 새로운 접근 방식을 활용한 맞춤형 접근 방식입니다.',
  boarding_56: '사회학 조사',
  boarding_57:
    '사회학 조사는 인간 행동 및 사회적 상호작용의 패턴을 밝혀내어 혁신적인 전략을 유도하고 목표 청중과의 의미 있는 연결을 만드는 데 유용한 인사이트를 제공합니다.',
  not_found_1: '죄송합니다! 해당 페이지를 찾을 수 없습니다.',
  not_found_2: '저희 제품을 확인해보시겠어요?',
  not_found_3: '컨설팅 예약',
  customer_profiling_segmentation_1: '고객 프로파일링 및 세분화',
  customer_profiling_segmentation_2:
    '우리는 귀하의 타겟 청중을 정확히 파악하여 전략의 효과를 높이도록 돕습니다',
  customer_profiling_segmentation_3:
    '시장 세분화의 힘을 활용하여 메시지가 항상 타겟 소비자 그룹에 효과적으로 도달하도록 하세요',
  customer_profiling_segmentation_4: '소비자를 더 깊이 이해하세요',
  customer_profiling_segmentation_5:
    '귀하의 제품에 가장 적합한 타겟 청중을 찾으세요',
  customer_profiling_segmentation_6: '새로운 세그먼트를 탐색하여 유치하세요',
  customer_profiling_segmentation_7: '구매 장벽을 발견하세요',
  customer_profiling_segmentation_8:
    '우리는 맞춤형 세분화 솔루션을 제공하는 데 전문성을 갖추고 있습니다',
  customer_profiling_segmentation_9: '독창적인 접근',
  customer_profiling_segmentation_10:
    '귀하의 니즈에 맞게 특별히 제작된 독창적이고 맞춤화된 세분화 솔루션을 경험하세요',
  customer_profiling_segmentation_11: '타겟 페르소나',
  customer_profiling_segmentation_12:
    '심층 시장 분석 및 종합적인 조사를 기반으로 제작된 타겟 페르소나',
  customer_profiling_segmentation_13: '새로운 세그먼트',
  customer_profiling_segmentation_14:
    '가장 가치 있는 청중 세그먼트를 식별하고 맞춤 타겟팅의 이점을 활용하세요',
  customer_profiling_segmentation_15: '권장 사항',
  customer_profiling_segmentation_16:
    '우리의 권장 사항을 실행하여 성공을 달성하고, 고객 충성도를 높이며, 매출을 증대시키고 비즈니스 잠재력을 극대화하세요',
  customer_profiling_segmentation_17:
    '20년 이상의 경험을 가진 전문가들이 종합적인 조사를 제공합니다',
  customer_profiling_segmentation_18:
    '정성적 연구는 개념, 의견 또는 경험을 이해하기 위해 비수치 데이터를 수집하고 분석하는 것을 포함합니다.',
  customer_profiling_segmentation_19:
    '정량적 연구 방법은 설문 조사, 질문지 및 여론 조사를 통해 얻은 데이터를 객관적으로 측정하고 수치적으로 분석하는 것을 포함합니다.',
  customer_profiling_segmentation_20:
    '데이터를 수집한 후 전문가들은 정보를 분석하고 결론을 도출하여 최고의 권장 사항을 제공합니다.',
  customer_profiling_segmentation_21:
    '우리는 단순히 측정만 하는 것이 아니라, 명확한 단계별 실행 계획도 제공합니다',
  customer_profiling_segmentation_22: '우리의 방법론',
  customer_profiling_segmentation_23: '자카드 지수',
  customer_profiling_segmentation_24:
    '응답자에게 직접 질문하면 기업 선호도에 대한 답변이 실제 행동과 일치하지 않을 수 있습니다. 우리는 직접 질문하는 대신 자카드 통계 분석을 활용하여 기업 속성과 소비자 선택 간의 관계를 이해합니다.',
  customer_profiling_segmentation_25: '동인',
  customer_profiling_segmentation_26:
    '우리는 결과에 영향을 미치는 요인(동인)을 식별하고 그것들을 중요도에 따라 주요, 중간, 비중요 동인으로 분류합니다.',
  customer_profiling_segmentation_27: '세분화',
  customer_profiling_segmentation_28:
    '고객 선택의 명확한 특성을 반영한 세분화를 제공합니다.',
  customer_profiling_segmentation_29: '세분화에 대한 우리의 접근 방식',
  customer_profiling_segmentation_30: '인구통계적',
  customer_profiling_segmentation_31: '연령',
  customer_profiling_segmentation_32: '성별',
  customer_profiling_segmentation_33: '소득',
  customer_profiling_segmentation_34:
    '이는 특정 그룹에 맞춰 제품, 서비스 및 마케팅을 조정하여 관련성과 효과를 높이는 데 도움이 됩니다',
  customer_profiling_segmentation_35: '심리적',
  customer_profiling_segmentation_36: '라이프스타일',
  customer_profiling_segmentation_37: '가치관',
  customer_profiling_segmentation_38: '행동',
  customer_profiling_segmentation_39:
    '이는 개인화된 마케팅, 고객과의 깊은 연결, 충성도 및 매출 증대를 가능하게 합니다',
  customer_profiling_segmentation_40: '행동적',
  customer_profiling_segmentation_41: '행동',
  customer_profiling_segmentation_42: '동기',
  customer_profiling_segmentation_43: '구매 빈도',
  customer_profiling_segmentation_44:
    '이는 표적 마케팅, 고객 만족도 향상, 유지율 증가 및 회사의 수익성 개선을 가능하게 합니다',
  customer_profiling_segmentation_45: '지리적',
  customer_profiling_segmentation_46: '위치',
  customer_profiling_segmentation_47:
    ' 이는 표적 마케팅, 맞춤형 제품, 효율적인 유통 및 회사의 시장 침투율 향상을 가능하게 합니다.',
  brands_identity_1: '브랜드 아이덴티티 및 포지셔닝',
  brands_identity_2:
    '심층 분석을 통해 브랜드를 변화시키고, 소비자 인식에 대한 통찰을 밝혀내어 성공을 위한 전략을 다듬어 보세요',
  brands_identity_3: '전문가와 상담하세요',
  brands_identity_4: '<b>포괄적인 브랜드</b> 정체성 분석을 알아보세요',
  brands_identity_5: '<b>소비자 인식에 대한</b> 통찰력을 탐색하세요',
  brands_identity_6: '<b>다양한</b> 타겟 오디언스의 견해를 이해하세요',
  brands_identity_7:
    '<b>소비자 행동, 습관 및 선호도에 대한 통찰력을 얻어</b> 정보에 기반한 결정을 내리세요',
  brands_identity_8:
    '20년 이상의 고객 경험을 보유한 4Service 전문가들이 비즈니스 성장을 돕는 독창적인 솔루션을 만듭니다',
  brands_identity_9:
    '<b>필수 데이터를 갖춘 조사 패키지를 이용하실 수 있습니다.</b> 이는 강점과 개선이 필요한 영역을 보여주는 진단 도구입니다',
  brands_identity_10:
    '<b>우리의 서비스는</b> 기업이 정보에 기반한 결정을 내리고, 전략을 다듬고, 업계에서 성공을 이끄는 데 필요한 도구를 제공합니다.',
  brands_identity_11: '경쟁 시장에서 브랜드의 입지를 강화하기 위해',
  brands_identity_12: '시장 입지를 강화하려는 기업',
  brands_identity_13: '전략을 향상시키려는 기업',
  brands_identity_14: '브랜드 정체성',
  brands_identity_15: '브랜드 포지셔닝',
  brands_identity_16:
    '<b>소비자 세그먼트 전반에서</b> 브랜드 인식을 밝혀보세요.',
  brands_identity_17:
    '<b>귀하의 브랜드와 경쟁사에</b> 부여된 특성을 파악하세요.',
  brands_identity_18: '<b>전략적 개선을 위한</b> 강점과 약점을 평가하세요.',
  brands_identity_19:
    '<b>홍보하는 가치와 브랜드 이미지의</b> 일치도를 평가하세요.',
  brands_identity_20: '<b>브랜드의 신뢰성에 대한</b> 인식을 평가하세요.',
  brands_identity_21: '<b>브랜드의 전형적 및 상징적</b> 인식을 탐색하세요.',
  brands_identity_22:
    '<b>경쟁사와 비교했을 때 브랜드의</b> 고유한 판매 포인트와 차별화를 식별하세요.',
  brands_identity_23:
    '<b>소비자가 제품/서비스를 구매할 가능성에</b> 영향을 미치는 주요 속성을 확인하세요.',
  brands_identity_24:
    '<b>브랜드가 소비자의 마음속에</b> 어떻게 자리 잡고 있는지 파악하고 원하는 시장 세그먼트를 유치하기 위한 커뮤니케이션 요소를 식별하세요.',
  brands_identity_25: '방법론은 고객 요청에 따라 개별적으로 선택됩니다',
  brands_identity_26: '브랜드 인지도 및 사용',
  brands_identity_27:
    '브랜드 수준 평가는 인지도 및 소비 수준 측정을 포함하며, 평가의 기본 요소로 작용합니다.',
  brands_identity_28: '브랜드 전달력 및 신뢰',
  brands_identity_29:
    '이 지표는 고객 추천(지지도)과 브랜드가 약속을 지속적으로 이행하고, 긍정적인 고객 경험을 창출하며, 신뢰를 구축하는 능력을 측정합니다.',
  brands_identity_30: '브랜드 이미지 성과',
  brands_identity_31:
    '브랜드 성과 평가는 여섯 가지 핵심 가치(3가지 이성적, 3가지 감성적)와의 연관성, 카테고리 내 차별성, 소비자에게 자부심을 줄 수 있는 능력을 평가합니다.',
  brands_identity_32: '브랜드 건강 점수',
  brands_identity_33:
    '브랜드 건강 점수는 경쟁 환경에서 브랜드의 전반적인 성과를 종합적으로 보여줍니다.',
  sociological_research_1: '사회학 조사',
  sociological_research_2:
    '우리는 사회적 현상과 과정을 심층적으로 분석하여 독창적인 분석 결론과 권장 사항을 통해 정보에 기반한 결정을 내릴 수 있도록 지원합니다',
  sociological_research_3: '문의하기',
  sociological_research_4: '우리의 고객',
  sociological_research_5: 'CAWI',
  sociological_research_6:
    'CATI - 전화 설문 조사를 컴퓨터를 통해 수행하는 데이터 수집 방법입니다. CATI 소프트웨어는 데이터 수집, 응답 입력, 설문 관리 프로세스를 자동화할 수 있도록 해줍니다. 이를 통해 설문 제어가 쉬워지고, 데이터를 빠르게 분석 및 처리할 수 있으며, 설문의 표준화 수준이 높아집니다.',
  sociological_research_7: 'CATI',
  sociological_research_8:
    'CAWI - 응답자가 웹 인터페이스를 통해 설문지를 작성하거나 질문에 답하는 데이터 수집 방법으로, 데이터를 자동으로 수집 및 처리하는 전문 소프트웨어를 사용합니다. CAWI 방법은 대규모 조사를 수행하고 데이터를 빠르게 수집 및 분석하는 데 유용합니다.',
  sociological_research_9: 'CAPI',
  sociological_research_10:
    'CAPI - 연구원이 태블릿이나 휴대전화를 사용해 대면 설문 응답을 입력하는 데이터 수집 방법으로, 데이터 입력 오류를 줄이고 결과 분석을 단순화하는 자동화된 수집을 가능하게 합니다.',
  sociological_research_11: '우리의 전문가들은 다양한 도구를 사용합니다',
  sociological_research_12: '표본',
  sociological_research_13: '우리는 복잡한 표본도 계산하고 적용합니다',
  sociological_research_14:
    '우리의 작업에는 단순, 체계적, 층화 및 군집 표본을 사용합니다',
  sociological_research_15:
    '전국 대표 대면 조사를 위해 층화 다단계 표본 추출 절차를 사용합니다',
  sociological_research_16:
    '정착지는 지역별로 크기와 유형에 따라 선택되며, 각 지역의 비율에 따라 수가 결정됩니다',
  sociological_research_17: '우리는 수행합니다',
  sociological_research_18: '여론 조사',
  sociological_research_19: '사회경제 조사',
  sociological_research_20: '문헌 조사',
  sociological_research_21: '사회 서비스 품질 평가',
  sociological_research_22: '사례 연구',
  sociological_research_23: '인사 조사',
  sociological_research_24:
    '특정 집단(취약 계층, 국내 실향민, 군인, 청년 등)에 대한 조사',
  sociological_research_25: '우리는 각 고객과 개별적으로 협력합니다',
  sociological_research_26: '우리의 고객:',
  sociological_research_27: '자선 단체',
  sociological_research_28: '공공 단체 및 연합',
  sociological_research_29: '정부 기관',
  sociological_research_30: '우리의 작업 접근 방식',
  sociological_research_31:
    '우리는 과학적 접근 방식과 현재 현실에 대한 깊은 이해, 다양한 조사 방법을 활용하여 데이터를 수집합니다.',
  sociological_research_32:
    '우리는 특정 요청에 대응할 수 있는 경험을 갖춘 전문가를 배정하며, 다양한 분야의 전문가 풀을 보유하고 있습니다.',
  sociological_research_33:
    '우리는 수집된 데이터를 과제의 특성에 맞게 독창적인 도구를 사용하여 분석하는 자체 분석 부서를 보유하고 있습니다.',
  sociological_research_34:
    '우리는 타겟 오디언스의 요구와 기대를 고려하여 상세한 결론과 권장 사항이 담긴 보고서를 작성합니다.',
  sociological_research_35:
    '우리는 권장 사항 실행 중 자문 및 지원을 제공하여 긍정적인 변화를 실현할 수 있도록 도와드립니다.',
  sociological_research_36: '우리의 조사는 TV에 소개되었습니다',
  sociological_research_37: '우리의 보고서를 확인해보세요',
  sociological_research_38:
    '우리의 과학적 접근 방식은 우크라이나 및 유럽 전역에서 고객에게 정확하고 신뢰할 수 있는 사회학 데이터를 최소 오차로 보장합니다',
  sociological_research_39:
    '우리는 사회학 조사 수행에 있어 모든 윤리 원칙과 기준을 준수합니다.',
  sociological_research_40:
    '우리는 우크라이나 사회학 협회의 사회학자 윤리 강령 및 헬싱키 선언의 윤리 원칙을 준수합니다. ESOMAR, 우크라이나 마케팅 협회, 전우크라이나 컨택 센터 협회 회원입니다.',
  sociological_research_41: '현장조사',
  sociological_research_42: '온라인 패널',
  sociological_research_43: '정기 면접원',
  sociological_research_44: '감독자',
  sociological_research_45: '현장 품질 관리',
  sociological_research_46: 'GPS 좌표 100% 고정(CAPI)',
  sociological_research_47: '설문지 검증(CAWI, CAPI, CATI, PAPI)',
  sociological_research_48: '인터뷰 100% 녹음(CAPI, CATI)',
  sociological_research_49: '우리는 정품 소프트웨어를 사용합니다:',
  sociological_research_50: '통계 데이터 분석 및 데이터 세트 처리를 위한 SPSS',
  sociological_research_51:
    'CAPI용 DigSee Sure: 설문지 논리, 지리 위치, 인터뷰 오디오 녹음, 동영상 자료 시연',
  sociological_research_52:
    'CAWI용 SurveyMonkey: 설문지 논리, 편리한 형식, 시각화',
  sociological_research_53:
    'VoIPTime(컨택센터): 어떤 복잡도든 설문지 프로그래밍, 오디오 녹음 전달',
  sociological_research_54: '표본',
  sociological_research_55: '우리는 어떤 복잡도의 표본도 계산하고 적용합니다',
  sociological_research_56:
    '우리의 작업에서는 단순, 체계적, 층화, 군집 표본을 사용합니다',
  sociological_research_57:
    '전국 대표 대면 설문에서는 층화된 다단계 표본 절차를 사용합니다',
  sociological_research_58:
    '지역별 정착지 선택은 크기와 유형에 따라 수행되며, 각 지역에서의 비율에 따라 수량이 결정됩니다',
  sociological_research_59: '팀',
  sociological_research_60:
    '우리의 사회학자들은 우크라이나 사회학자 협회의 회원입니다',
  sociological_research_61:
    '우리는 다양한 산업에서 정량 및 정성 프로젝트 경험이 있는 정규 분석가 12명을 보유하고 있습니다.',
  sociological_research_62:
    '우리는 10년 이상의 연구 경험을 가진 강력한 전문 분석 팀을 보유하고 있습니다. 우리는 과학자, 박사, MBI를 보유하고 있습니다.',
  sociological_research_63: '이리나 막시미우크',
  sociological_research_64:
    '연구부서장. 마케팅 조사에서 15년 이상의 경험, 연구 전 과정 관리, 분석 보고서 및 프레젠테이션 준비',
  sociological_research_65: '안드리 빌로스쿠르스키',
  sociological_research_66:
    '프로그래밍 및 데이터 처리 책임자. 마케팅, 사회학 및 시장 조사 분야에서 20년의 경험',
  sociological_research_67: '올레나 소모바',
  sociological_research_68:
    '프로그래밍 전문가. 돈SUU 사회학 박사 과정 재학 중. 마케팅 조사 경험 5년. 여성 민주 동맹 이사회 위원, 모금 책임자.',
  sociological_research_69: '안나 파달카',
  sociological_research_70:
    '연구부 사회학 연구 부서장. 국내외 사회 및 사회학 프로젝트에서 13년의 경험 보유. 사회학 박사, 우크라이나 컨택센터 협회 연구 위원장.',
  ad_hoc_1: '애드혹',
  ad_hoc_2: '특수한 사례를 위한 대체 조사를 확인하세요',
  ad_hoc_3: '문의하기',
  ad_hoc_4: '우리의 접근법',
  ad_hoc_5:
    '우리 전문가 팀은 수집된 데이터를 면밀히 분석하여 귀하의 성장을 돕는 복잡한 솔루션을 제공합니다.',
  ad_hoc_6:
    '설문조사, 인터뷰, 포커스 그룹, 데이터 분석 등 다양한 방법론을 기반으로 귀하의 요구에 맞는 고유한 조사를 설계합니다.',
  ad_hoc_7: '왜 애드혹 조사를 선택해야 할까요?',
  ad_hoc_8: '유연성',
  ad_hoc_9:
    '모든 조사 프로젝트는 다릅니다. 애드혹 조사를 통해 우리는 필요에 따라 고유한 접근 방식을 조정하고 발전시켜 귀하의 인사이트가 항상 유효하고 실행 가능하도록 보장합니다.',
  ad_hoc_10: '정밀성',
  ad_hoc_11:
    '귀하의 고유한 요구에 맞춘 방법론을 통해 가치 있는 인사이트를 제공하는 정확하고 목표 지향적인 결과를 전달합니다.',
  ad_hoc_12: '혁신',
  ad_hoc_13:
    '우리는 조사 과정에서 혁신과 창의성을 중시하며, 숨겨진 기회와 과제를 발견하기 위해 새로운 기술과 접근 방식을 탐색합니다.',
  ad_hoc_14: '시의성',
  ad_hoc_15:
    '애드혹 조사는 빠른 실행을 가능하게 하여 산업 내 경쟁력을 유지하는 데 필요한 중요한 인사이트를 제때 제공할 수 있도록 합니다.',
  ad_hoc_16: '전문성',
  ad_hoc_17:
    '4Service 전문가들은 20년 이상의 시장 조사 및 고객 경험을 바탕으로 귀하의 비즈니스를 성장시키는 고유한 솔루션을 만듭니다',
  ad_hoc_18: '귀하의 특정 요구 사항에 따라 고유한 도구 세트를 활용합니다',
  ad_hoc_19: '기존 방법론이 맞지 않나요?',
  ad_hoc_20: '애드혹 조사 요청하기',
  ad_hoc_21: '특정 문제에 맞춤화',
  ad_hoc_22:
    '기존 방법론의 다양한 요소를 혼합하거나 전혀 새로운 접근 방식을 사용합니다',
  ad_hoc_23: '개별 접근',
  ad_hoc_24: '귀하의 문제에 직접적으로 맞는 솔루션을 신중하게 조정합니다',
  ad_hoc_25: '기대 이상을 제공',
  ad_hoc_26:
    '귀하의 비즈니스가 목표를 달성할 수 있도록 실현 가능한 계획과 권장사항을 제공합니다',
  ad_hoc_27: '비표준 문제가 있습니다',
  ad_hoc_28: '기존 방법론이 귀하의 문제에 맞지 않습니다',
  ad_hoc_29: '여러 방법론 또는 그 일부를 동시에 요청하고 싶습니다',
  ad_hoc_30: '누가 애드혹 조사로 혜택을 받을 수 있을까요?',
  service_design_1: '우리의 일부 고객사',
  service_design_2: '서비스 디자인',
  service_design_3:
    '제품 및 판매 중심에서 서비스 및 인간 중심으로 비즈니스를 전환하세요',
  service_design_4: '전문가와 상담하기',
  service_design_5: '무료로 배우세요!',
  service_design_6:
    '우리는 실용적이고 유용한 정보를 서비스 디자인 라이브러리에 수집했습니다',
  service_design_7:
    '라이브러리에는 각 단계에 대한 자세한 설명, 관련 도구 및 기법, 중요한 세부 사항에 대한 팁, 비디오 데모가 포함되어 있습니다.',
  service_design_8: '라이브러리로 이동',
  service_design_9: '서비스 디자인으로 이점을 누리세요!',
  service_design_10:
    '서비스 디자인은 사용자 만족도와 운영 효율성을 향상시키기 위해 사람, 프로세스, 접점 등 서비스 생태계를 전체적으로 다루며 서비스를 창출하고 개선하는 것을 목표로 합니다',
  service_design_11:
    '서비스 디자인은 당신이 왜 한 카페를 다른 카페보다 선호하는지에 관한 것만은 아닙니다. 그곳에 계속해서 돌아가고, 친구들에게 추천하는 이유이기도 합니다.',
  service_design_12: '비즈니스가 서비스 디자인으로 얻을 수 있는 이점',
  service_design_13: '사용자 만족도',
  service_design_14:
    '사용자에게 기쁨을 주는 매끄럽고 개인화된 경험을 만드세요.',
  service_design_15: '운영 효율성',
  service_design_16:
    '프로세스를 간소화하고, 비용을 절감하며, 서비스 제공을 향상시키세요.',
  service_design_17: '브랜드 일관성',
  service_design_18: '모든 접점이 브랜드의 가치와 일치하도록 하세요.',
  service_design_19: '변화에 대한 적응력',
  service_design_20:
    '변화하는 요구에 따라 성장하고 진화할 수 있는 서비스를 설계하세요.',
  service_design_21: '충성도 증가',
  service_design_22:
    '탁월한 서비스 경험을 통해 고객 관계를 강화하고 충성도를 높이세요.',
  service_design_23: '경쟁 우위',
  service_design_24:
    '독특하고 기억에 남는 서비스 경험으로 시장에서 돋보이세요.',
  service_design_25: '이유',
  service_design_26: '왜 서비스 디자인을 선택해야 하나요?',
  service_design_27:
    '이것은 기업이 제품 및 판매 중심에서 인간의 요구와 문제에 집중하도록 돕는 문화이자 방법론이며 사고방식입니다.',
  service_design_28: '당사의 서비스',
  service_design_29: '고객 서비스 디자인',
  service_design_30:
    '신제품을 개발하거나 기존 제품을 개선하기 위한 고객 중심 프로젝트를 개발 및 실행하며, 향후 독립적인 업무를 위한 교육도 제공합니다.',
  service_design_31: '직원 서비스 디자인',
  service_design_32:
    '직원 중심의 프로세스, 구조 및 변화를 개발 및 구현하기 위한 실용적인 과정입니다.',
  service_design_33: '미래 디자인 사고',
  service_design_34:
    '다양한 시나리오와 가능한 혁신을 고려한 미래 개념과 기업 전략 개발입니다.',
  service_design_35: '비즈니스 창의성',
  service_design_36:
    '참가자들이 창의력을 활용하여 특정 문제를 해결하고 독특한 시장 솔루션을 개발할 수 있도록 돕는 실용적인 교육입니다.',
  service_design_37: '워크숍',
  service_design_38:
    '세계적으로 인정받는 인증과 함께 실용적인 워크숍을 제공합니다.',
  service_design_39: '기대 이상을 충족하는 제품, 서비스 및 시설을 만드세요.',
  service_design_40: '작동하는 비즈니스 프로세스를 구현하세요.',
  service_design_41: '직원과 고객 간의 관계를 조화롭게 만드세요.',
  service_design_42: '캘린더',
  service_design_43: '곧 공개됩니다',
  service_design_44: '이전 이벤트에 대해 자세히 알아보세요',
  service_design_45: 'Service Design 기초',
  service_design_46: '기대 이상을 충족하는 제품, 서비스 및 시설을 만드세요.',
  service_design_47: 'EX 서비스 디자인',
  service_design_48: '기대 이상을 충족하는 제품, 서비스 및 시설을 만드세요.',
  service_design_49: '더 보기',
  service_design_50: '당사의 접근 방식',
  service_design_51: '4Service는 인간 중심 서비스의 기반입니다!',
  service_design_52:
    '우리는 기업이 필요한 사고방식을 개발하고 인간 중심의 내부 환경을 조성하도록 돕습니다.',
  service_design_53: '도구',
  service_design_54:
    '고객의 특정 요구 사항에 따라 독특한 기술과 도구 세트를 사용합니다.',
  service_design_55: '사용자 조사',
  service_design_56:
    '인터뷰, 설문조사, 대면 인터뷰, 민족지학적 연구를 통해 사용자 요구와 행동을 이해합니다.',
  service_design_57: '페르소나',
  service_design_58:
    '디자인 결정을 안내하기 위해 다양한 사용자 유형을 나타내는 가상의 인물입니다.',
  service_design_59: '고객 여정 맵',
  service_design_60:
    '사용자의 서비스 경험을 시각적으로 나타내어 주요 접점과 불편한 점을 식별합니다.',
  service_design_61: '브레인스토밍 세션',
  service_design_62:
    '이해관계자들과 함께 아이디어와 솔루션을 창출하는 협업 세션입니다.',
  service_design_63: '프로토타이핑',
  service_design_64:
    '서비스의 개념을 테스트하고 다듬기 위한 초기 버전을 만듭니다.',
  service_design_65: '서비스 청사진',
  service_design_66:
    '서비스 구성 요소 및 프로세스 간의 관계를 보여주는 자세한 다이어그램입니다.',
  service_design_67: '파트너',
  service_design_68: '4Service & DTA',
  service_design_69: '4Service는 디자인 사고 아카데미의 공식 독점 대표입니다.',
  service_design_70: '우리의 파트너십을 통해, 우리는 다음을 수행합니다:',
  service_design_71:
    '<b>서비스 디자인 방법을</b> 사용하는 실용적인 교육을 최고의 전문가들과 함께 워크숍에서 제공합니다;',
  service_design_72: '<b>공인된</b> 디자인 사고 전문가를 교육합니다;',
  service_design_73:
    '<b>국제 퍼실리테이터와 함께</b> 많은 회사에 서비스 디자인 프로젝트를 구현합니다.',
  service_design_74:
    '우리는 다음 국가에 서비스 디자인 우수 센터를 설립했습니다:',
  service_design_75: '우크라이나',
  service_design_76: '카자흐스탄',
  service_design_77: '튀르키예',
  service_design_78: '조지아',
  service_design_79: '아제르바이잔',
  service_design_80: '우리의 사례에 대해 더 알아보세요',
  service_design_81: '라이브러리로 이동',
  service_design_82: '서비스 디자인에 오신 것을 환영합니다!',
  four_opinion_1: '4Service 보상 설문조사',
  four_opinion_2: '온라인 설문에 참여하고 집에서 편하게 수익을 얻으세요',
  four_opinion_3: '가입하고 수익 시작하기',
  four_opinion_4: '우리의 장점',
  four_opinion_5: '신뢰받는 기업',
  four_opinion_6:
    '우리 커뮤니티는 우크라이나 9만 명, 카자흐스탄 10만 명 이상의 소비자로 구성되어 있습니다',
  four_opinion_7: '당신의 시간을 소중히 여깁니다',
  four_opinion_8: '설문 참여에 대한 보상으로 선물이나 현금을 받을 수 있습니다',
  four_opinion_9: '당신의 의견은 큰 영향력을 갖습니다',
  four_opinion_10:
    '모든 댓글은 브랜드가 고객의 니즈를 더 잘 이해하도록 돕습니다',
  four_opinion_11:
    '4Service의 4Forum 설문조사에 참여하고 온라인으로 수익을 얻거나 경품을 받으세요',
  four_opinion_12: '4Forum 가입하기',
  four_opinion_13: '우리 채널에서 더 많은 흥미로운 이야기를 확인하세요',
  four_opinion_14: '우크라이나 관련 정보 자세히 보기',
  four_opinion_15: '카자흐스탄 관련 정보 자세히 보기',
  four_opinion_16: '왜 우리 설문조사에 참여해야 할까요?',
  four_opinion_17: '4Service는 고객 경험 관리 전문 국제 리서치 그룹입니다',
  four_opinion_18:
    '우리는 유럽 고객 경험 관리 상위 10개 에이전시 중 하나입니다',
  four_opinion_19: '우리의 사명은 전 세계 고객 서비스를 향상시키는 것입니다!',
  four_opinion_20: '온라인 설문으로 수익을 시작하는 방법은?',
  four_opinion_21: '웹사이트에서 가입하세요 ',
  four_opinion_22: '설문 초대는 이메일로 받게 됩니다.',
  four_opinion_23: '설문을 끝까지 완료하고 수익을 얻으세요',
  four_opinion_24: '실제 참가자 후기',
  four_opinion_25: '비탈리아 코한',
  four_opinion_26:
    '“설문에 참여했는데 까먹고 있었어요. 잠시 후 나탈리아 씨가 전화로 제가 당첨되었다고 알려주었어요. 그리고 제 경품 Samsung Galaxy M52 5G입니다. 정말 감사합니다 😁”',
  four_opinion_27: '빅토리아 포포프스카',
  four_opinion_28:
    '“스피커를 받았어요. 정직하고 공정하며 흥미로운 경품 추첨 감사합니다.”',
  four_opinion_29: '율리아 알렉산드리브나',
  four_opinion_30:
    '“최근 경험한 것 중 가장 놀라운 일이었어요💕 단순히 당첨된 게 아니라 정말 멋진 물건을 받았어요. 다양한 걸 예상했지만 이렇게 멋질 줄은 몰랐어요. 다시 한 번 큰 감사드립니다”',
  four_opinion_31: '우리와 함께라면 실제 현금을 벌거나 경품을 받을 수 있습니다',
  four_opinion_32: '우리 채널에서 최신 설문을 확인하세요',
  four_opinion_33: '채널로 이동',
  four_opinion_34:
    '당신의 답변은 기업이 모든 소비자를 위해 서비스와 제품을 개선하는 데 도움이 됩니다.',
  four_opinion_35: '설문 보상은 매월 말, 최소 지급액에 도달한 후 지급됩니다.',
  four_opinion_36:
    '개인 계정에 결제 정보를 반드시 입력하세요 — 없으면 지급이 불가능합니다.',
  four_opinion_37: '의견에 대한 보상을 받으세요',
  four_opinion_38:
    '자신의 의견을 공유하고 완료한 설문마다 공정한 보상을 받으세요. 현금으로 지급하며 알 수 없는 포인트가 아닙니다.',
  four_opinion_39: '브랜드의 신뢰',
  four_opinion_40:
    '많은 브랜드가 우리를 신뢰하기 때문에 매월 10만 건 이상의 인터뷰를 진행합니다.',
  four_opinion_41: '제품과 서비스의 미래에 영향력 행사',
  four_opinion_42:
    '제조사와 기업은 더 나은 제품을 만들기 위해 귀하의 피드백을 참고합니다.',
  four_opinion_43: '최신 정보를 가장 먼저 확인',
  four_opinion_44: '신제품, 광고, 아이디어를 시장 출시 전에 테스트하세요.',
  four_opinion_45: '간편하고 편리한 과정',
  four_opinion_46:
    '컴퓨터나 스마트폰으로 원하는 시간에 참여 가능, 장소 제약 없음.',
  four_opinion_47: '신뢰성과 안전성',
  four_opinion_48:
    '개인정보 보호와 제때 지급을 보장합니다. 정보가 제3자에게 전달되지 않습니다.',
  career_1: '팀의 일원이 되세요',
  career_2: '4Service',
  career_3:
    '지속적인 전문성 향상의 무한한 기회가 있는 팀에서 여러분을 기다립니다!',
  career_4: '채용 공고 보기',
  career_5: '채용 공고를 찾지 못하셨나요?',
  career_6: '이력서를 보내주시면 저희가 연락드릴게요!',
  career_7: '이력서 보내기',
  career_8: '등록 양식',
  career_9: '*이름',
  career_10: '*성',
  career_11: '*이메일',
  career_12: '*전화번호',
  career_13: '이력서 업로드',
  career_14: '보내기',
  career_15: '4Service에서 커리어를 시작하세요',
  career_16: '주요 업무:',
  career_17: '요구 사항:',
  career_18: '우리는 다음을 제공합니다:',
  career_19: '지원하기',
  career_20: '4Service — 국제 리서치 기업',
  career_21: '2001년부터 운영 중',
  career_22: '회사 소개',
  career_23: '기업 문화를 발전시키고 있습니다',
  career_24: '우리의 이니셔티브',
  career_25: '전 세계적으로 고객 서비스를 개선하고 있습니다',
  career_26: '4Service 채용 공고',
  career_27: '4Service와 함께하는 기회',
  career_28:
    '“모닝 커피” 주간 세션, 팀 빌딩, 사회적 이니셔티브를 통한 정신 건강 지원',
  career_29:
    '<span>Mercedes, Huawei, Philip Morris</span>와 같은 세계적인 브랜드와의 흥미로운 업무 경험',
  career_30: '세미나, 트레이닝, 워크숍을 통한 지속적인 전문성 개발',
  career_31: '미스터리 쇼퍼 역할을 통해 유명 브랜드의 발전에 기여',
  career_32:
    '<span>우크라이나, 카자흐스탄, 루마니아, 오스트리아, 아제르바이잔, 조지아</span> 등 어디에서든 원격 또는 사무실 근무 가능',
  career_33: '이벤트, 웨비나, 네트워킹을 통한 개인 브랜드 개발',
  career: '커리어',
  footer_btn_1: '쇼퍼가 되세요',
  footer_btn_2: '유료 설문에 참여하세요',
  diary_study_1: '다이어리',
  diary_study_2: '연구',
  diary_study_3:
    '시간이 지나면서 변화하는 사용자 경험과 라이프스타일을 모니터링하고 인사이트를 수집합니다',
  diary_study_4: '전문가와 상담하세요',
  diary_study_5: '문의하기',
  diary_study_6: '시작하기',
  diary_study_7:
    '정성적 및 정량적 데이터를 모두 포함하는 다이어리 스터디를 요청하여 소비자 행동, 시장 동향, 브랜드 성과에 대한 귀중한 인사이트를 얻으세요',
  diary_study_8: '동적 라이프스타일 및 사용자 경험 연구',
  diary_study_9:
    '다이어리 스터디는 사용자의 상호작용에 대한 심층적이고 맥락적인 인사이트를 제공하며, 다른 방법으로는 알 수 없는 패턴과 변화를 식별하는 데 도움을 줍니다.',
  diary_study_10:
    '이 방법은 자연스러운 환경에서 실시간 데이터 수집을 가능하게 하여 신뢰성과 관련성을 크게 높입니다',
  diary_study_11: '제공',
  diary_study_12: '맞춤형 다이어리 스터디를 제공합니다',
  diary_study_13: '소비자 참여',
  diary_study_14:
    '참여자들이 일상적인 환경에서 자신의 행동, 활동 및 경험을 시간에 따라 기록하는 온라인 커뮤니티를 제공합니다.',
  diary_study_15: '시장 조사',
  diary_study_16:
    '우리는 고객의 특정 요구를 충족시키기 위해 심층적인 시장 조사를 수행하여 통찰력 있는 데이터를 제공합니다.',
  diary_study_17: '브랜드 인사이트',
  diary_study_18:
    '소비자의 인식과 행동을 심층적으로 분석하여 브랜드 전략을 수립하는 데 도움이 되는 귀중한 인사이트를 발견합니다.',
  diary_study_19: '전문가',
  diary_study_20:
    '20년 이상의 고객 경험을 보유한 4Service 전문가들이 귀하의 비즈니스 성장을 돕기 위한 독창적인 솔루션을 만듭니다',
  diary_study_21: '프로젝트 관리',
  diary_study_22:
    '우리 팀은 프로젝트의 모든 측면이 원활하게 진행되도록 철저히 계획하고 실행하는 종합적인 프로젝트 관리 지원을 제공합니다.',
  diary_study_23: '컨설팅',
  diary_study_24:
    '우리는 프로젝트의 모든 단계를 안내하고 문제를 해결하며 성과를 최적화하기 위한 전문 컨설팅을 제공합니다.',
  diary_study_25: '품질 보증',
  diary_study_26:
    '모든 단계에서 엄격한 품질 기준을 유지하여 프로젝트가 기대치를 충족하고 초과 달성하도록 보장합니다.',
  diary_study_27: '이점',
  diary_study_28: '우리와 함께하는 혜택',
  diary_study_29: '<b>시간이 지남에 따라 무한한</b> 인사이트의 원천',
  diary_study_30: '<b>모든 단계에서의</b> 전문가 가이드라인',
  diary_study_31: '<b>전 세계 소비자와 기업을</b> 연결합니다',
  diary_study_32: '<b>심층 피드백과 응답을 통한</b> 편리한 데이터 수집',
  diary_study_33: '<b>프로젝트 어느 단계에서나</b> 접근 가능한 데이터',
  diary_study_34: '<b>성장을 지원하는</b> 복합 솔루션',
  diary_study_35: '리서치',
  diary_study_36: '특별한 인사이트가 포함된 맞춤형 정량 조사 받기',
  shoppers_1: '플랫폼',
  shoppers_2: '미스터리 쇼퍼',
  shoppers_3: '가입하기',
  shoppers_4: '4Service와 함께 서비스를 평가하고 수익을 창출하세요',
  shoppers_5: '4Service에서 경력을 시작하세요',
  shoppers_6: '흥미로운 프로젝트가 여러분을 기다리고 있습니다',
  shoppers_7: '가입하기',
  shoppers_8: '우리 팀에 합류하세요',
  shoppers_9: '자세히 알아보기 ›',
  shoppers_10: '슈퍼바이저',
  shoppers_11:
    '팀의 작업을 감독하고, 계획 수립, 작업 조정, 품질 관리 및 조직 문제 해결을 책임지는 관리자입니다.',
  shoppers_12: '미스터리 쇼퍼',
  shoppers_13:
    '지정된 시나리오에 따라 상점, 식당 또는 기타 장소를 방문하고 자신의 인상을 보고하는 전문가입니다. ',
  shoppers_14: '머천다이저',
  shoppers_15:
    '브랜드 또는 회사의 기준에 따라 매장에 상품을 진열하는 전문가입니다.',
  shoppers_16: '감사원',
  shoppers_17: '기준 및 요구 사항 준수 여부를 확인하는 전문가입니다.',
  shoppers_18: '테스터',
  shoppers_19:
    '서비스, 제품 또는 프로세스의 품질을 고객의 관점에서 평가하고 기대치와의 일치 여부 및 잠재적인 문제를 식별하는 전문가입니다.',
  shoppers_20: '비밀 고객',
  shoppers_21:
    '고객 서비스 프로세스를 분석하고, 커뮤니케이션 품질, 반응 속도, 절차의 편의성 및 전반적인 상호작용 인상을 평가하는 전문가입니다.',
  shoppers_22: '홍보원',
  shoppers_23:
    '제품 시연, 광고 자료 배포, 프로모션 행사 조직 및 고객 질문 응답을 통해 제품을 홍보하는 전문가입니다. ',
  shoppers_24: '인터뷰 참가자',
  shoppers_25:
    '심층 인터뷰 참가자는 특정 주제, 제품 또는 서비스에 대한 자신의 생각, 감정, 동기 또는 경험을 밝히기 위한 연구에 참여합니다.',
  shoppers_26: '4Service의 일원이 되세요',
  shoppers_27: '우리는 <b>전 세계</b>에서 활동합니다',
  shoppers_28: '우리 팀은 <b>1000명 이상의 전문가</b>로 구성되어 있습니다',
  shoppers_29: '우리는 <b>20년 이상의 성공적인 경험</b>을 가지고 있습니다',
  shoppers_30: '지침',
  shoppers_31: '방문 오디오 녹음 방법',
  shoppers_32: '전화 통화 오디오 녹음 방법',
  shoppers_33: '오디오 파일을 설문지에 첨부할 수 없나요?',
  shoppers_34: '미스터리 쇼퍼를 위한 MSPA의 전문 기준 및 윤리 강령',
  shoppers_35: 'F.A.Q.',
  shoppers_36: '자주 묻는 질문',
  shoppers_37: '한 달에 얼마나 벌 수 있나요?',
  shoppers_38: '내 도시에서 얼마나 자주 과제를 수행할 수 있나요?',
  shoppers_39:
    '장소가 폐쇄되었을 경우 어떻게 해야 하며, 그러한 방문에 대한 보상은 무엇인가요?',
  shoppers_40: '보상은 어떻게 받나요?',
  shoppers_41: '보상 수령 시기는 어떻게 되나요?',
  shoppers_42: '보상 수령과 관련된 질문은 누구에게 해야 하나요?',
  shoppers_43: '한 달간의 보상 금액은 과제를 수행하는 빈도에 따라 달라집니다.',
  shoppers_44:
    '과제 1건당 보상은 40 UAH(간단한 방문 및 전화)에서 1200 UAH(복합 및 프리미엄 방문)까지 다양합니다. 이는 프로젝트의 복잡성과 특성에 따라 다릅니다.',
  shoppers_45:
    '과제 수행은 일상적인 쇼핑이나 친구들과의 외식과 결합된 즐거운 취미가 될 수 있습니다',
  shoppers_46: '장소 수, 프로젝트 규모;',
  shoppers_47: '회전율(같은 장소는 3개월/분기마다 1회까지만 방문 가능);',
  shoppers_48: '귀하의 프로필/기술이 프로젝트 요구 사항에 부합하는 정도;',
  shoppers_49: '신청서 제출의 신속성.',
  shoppers_50: '검토 중인 장소가 다음과 같은 경우:',
  shoppers_51:
    '폐쇄된 경우 – 입구 문, 폐쇄 이유 공지(있는 경우), 운영 시간 또는 주소가 보이는 외관을 촬영하세요.',
  shoppers_52:
    '지정된 주소에 존재하지 않는 경우 – 인근 지역의 동영상을 찍고, 이웃 건물 외관의 주소가 보이도록 사진을 찍으세요. 그 후 코디네이터에게 연락하세요.',
  shoppers_53: '보상은 개인의 경우 «PrivatBank» 카드로 지급됩니다.',
  shoppers_54: '보상 수령 시기에 대한 정보는 개인 계정에서 확인할 수 있습니다.',
  shoppers_55:
    '또한 자신의 코디네이터에게 문의하거나 미스터리 쇼퍼 지원 서비스(ua@4service.support)로 연락할 수 있으며, 이메일 제목에 질문이 있는 프로젝트 이름을 명시하세요.',
  shoppers_56:
    '보상 수령에 대한 일반 일정은 개인 계정의 «홈페이지»에 명시되어 있습니다.',
  shoppers_57:
    '보상을 받지 못했고 시한이 지났다면, 개인 계정에서 다음 작업을 수행하세요:',
  shoppers_58: '1. 모든 개인정보가 입력되어 있고, 빈 칸이 없는지 확인하세요;',
  shoppers_59:
    '2. 결제 카드 정보가 정확하고 카드 유효기간이 만료되지 않았는지 확인하세요;',
  shoppers_60: '3. 개인용 은행 카드가 지정되어 있습니다;',
  shoppers_61:
    '4. 시스템에 등록된 성명이 카드의 성명과 일치합니다 (오류 없이 작성됨).',
  shoppers_62:
    '모든 데이터를 확인하고 정확하게 작성되었으면, "ua@4service.support"로 미스터리 쇼퍼 지원 서비스에 문의하십시오. 이메일 제목에 문제의 프로젝트 이름을 기재하십시오.',
  shoppers_63: '미스터리 쇼퍼를 위한 <br /> 애플리케이션',
  shoppers_64: '4Shoppers 앱 다운로드:',
  shoppers_65: '또는',
  shoppers_66: '문의하기',
  shoppers_67: '지원팀과 채팅',
  shoppers_68: '전화:',
  shoppers_69: '이메일:',
  shoppers_70: '질문이 남아 있나요?',
  shoppers_71: '현장 직원 <br /> 지원 서비스',
  shoppers_72: '연락하기',
  shoppers_73: '현장 직원 지원 서비스',
  shoppers_74: '미스터리 쇼퍼 작업과 관련된 방문, 지급 및 기타 문의 사항',
  shoppers_75: '다음에 따라 개인정보 처리에 동의합니다:',
  shoppers_76: '성명',
  shoppers_77: '문제 요약',
  shoppers_78: '로그인',
  shoppers_79: '연락처 전화번호',
  shoppers_80: '지급 기한',
  shoppers_81: '기타',
  shoppers_82: '문의하기',
  employee_experience_1: '직원 경험',
  employee_experience_2: '귀하의 비즈니스 성공은 직원 경험에서 시작됩니다',
  employee_experience_3: '문의하기',
  employee_experience_4: '귀하의 성공 스토리는 여기서 시작됩니다',
  employee_experience_5:
    '20년 이상의 시장 조사 및 고객 경험을 가진 4Service 전문가들이 귀하의 비즈니스를 성장시키는 독특한 솔루션을 만듭니다.',
  employee_experience_6:
    '우리의 서비스는 비즈니스가 정보에 기반한 결정을 내리고, 전략을 정제하며, 각 산업에서 성공을 이끌어내는 데 필요한 도구를 제공합니다.',
  employee_experience_7: '귀하의 특정 요구에 맞는 이상적인 방법론을 선택합니다',
  employee_experience_8: '직원 여정 맵',
  employee_experience_9:
    '우리는 채용부터 퇴사까지 직원의 전체 생애 주기를 매핑하고, 그들의 경험에 영향을 미치는 주요 접점을 식별합니다. 이를 통해 개선이 필요한 영역과 각 단계에서 만족도 및 참여도를 높일 수 있는 기회를 찾습니다.',
  employee_experience_10: '벤치마크가 포함된 직원 여정 맵',
  employee_experience_11:
    '직원 여정 매핑을 한 단계 더 발전시켜, 귀하의 직원 경험을 산업 벤치마크와 비교합니다. 이를 통해 내부 프로세스를 단순화하고, 직원 충성도를 높이며, 모범 사례를 채택할 방법을 찾을 수 있습니다.',
  employee_experience_12: '고용주 브랜드 건강 연구',
  employee_experience_13:
    '우리는 귀하의 직원들이 회사 브랜드를 어떻게 인식하는지 평가합니다. 강력한 내부 브랜드는 더 동기 부여되고 충성도 높은 직원층을 이끌어내며, 이는 더 나은 고객 상호작용과 외부 평판으로 이어집니다.',
  employee_experience_14: '직원 넷 프로모터 점수 (eNPS)',
  employee_experience_15:
    'eNPS를 사용하여 귀하의 직원들이 회사를 훌륭한 근무지로 추천할 가능성이 얼마나 되는지 측정합니다. 이 간단하면서도 강력한 지표는 전반적인 직원 만족도와 충성도에 대한 통찰을 제공합니다.',
  employee_experience_16: '직원 헌신도 및 만족도 지수 (ECSI)',
  employee_experience_17:
    '우리의 ECSI 방법론은 직원들이 자신의 역할과 회사에 대해 얼마나 헌신적이고 만족하는지를 평가합니다. 이를 통해 직원 참여 수준을 파악하고, 이직률을 낮추기 위한 개선 영역을 찾을 수 있습니다.',
  employee_experience_18: '전직 및 현직 직원과의 심층 인터뷰',
  employee_experience_19:
    '우리는 전직 직원과 인터뷰하여 그들이 회사를 떠난 이유와 이직률을 개선할 방법을 파악합니다. 현직 직원과의 대화는 고객 서비스 향상, 참여도 증진 및 KPI 달성에 대한 장벽을 극복할 방법을 제시합니다.',
  employee_experience_20: 'UGC 분석',
  employee_experience_21:
    '사용자 생성 콘텐츠 (UGC) 분석은 전문 웹사이트, 소셜 미디어, 포럼 및 비디오 플랫폼에서 리뷰를 수집하여 수행됩니다. 이 분석은 귀하가 실제 고객의 기대와 문제점을 이해하고, 소비자 선호도의 변화 및 트렌드를 파악하며, 경쟁업체와 비교한 브랜드의 강점과 약점을 확인하는 데 도움이 됩니다.',
  employee_experience_22: '미스터리 직원',
  employee_experience_23:
    '미스터리 직원은 잠재적인 직원의 관점에서 회사를 평가하는 것입니다. 내부 프로세스가 얼마나 잘 조직되어 있는지, 기존 직원들이 후보자와 어떻게 상호작용하는지, 그리고 회사가 서비스 및 커뮤니케이션 표준을 얼마나 효과적으로 따르는지를 평가합니다.',
  employee_experience_24: '동기 부여 방문',
  employee_experience_25:
    '동기 부여 방문은 우수한 고객 상호작용 또는 성공적인 업셀링과 같은 서비스 기준을 충족한 직원에게 보상을 제공합니다. 미스터리 쇼퍼는 최고의 성과자를 식별하여 동기를 부여하고 다른 직원들이 상과 인정을 받기 위해 그들의 예를 따르도록 장려합니다.',
  employee_experience_26: '서비스 디자인',
  employee_experience_27:
    '우리는 서비스 디자인을 사용하여 비즈니스 문제를 식별하고 혁신적인 솔루션을 찾아 전략을 생성하여 서비스 제공을 개선하고 고객 또는 직원의 요구를 해결합니다.',
  employee_experience_28: '인사 연구',
  employee_experience_29:
    '인사 연구는 직원들이 회사의 미션과 가치에 얼마나 잘 부합하는지, 그리고 이를 고객에게 얼마나 효과적으로 전달하는지를 측정하는 데 도움이 됩니다.',
  employee_experience_30: '직원들과의 공동 창작 (포커스 그룹)',
  employee_experience_31:
    '직원들을 직접 참여시켜 공동 창작 포커스 그룹을 운영하여 피드백과 통찰을 수집합니다. 이 협력적 과정은 직원들이 작업 환경을 형성하는 데 기여하도록 하여 소유감과 참여감을 증진시킵니다.',
  employee_experience_32: '직원 경험에 투자하는 이유?',
  employee_experience_33: '직원 이직률 감소',
  employee_experience_34:
    '직원들이 머무르고 성장하고 싶어 하는 직장을 만들어 최고의 인재를 유지하세요.',
  employee_experience_35: '직원 충성도 증가',
  employee_experience_36:
    '직원들의 장기적인 헌신과 헌신을 구축하여 비싼 재고용 노력을 줄이세요.',
  employee_experience_37: '변화에 원활하게 적응',
  employee_experience_38:
    '새로운 규칙과 이니셔티브에 대한 저항을 줄여 회사 내에서 더 원활한 전환을 보장하세요.',
  employee_experience_39: '생산성 향상',
  employee_experience_40:
    '팀이 새로운 프로세스를 수용하고 역할에서 성공할 수 있도록 도와주세요.',
  employee_experience_41: '비즈니스 비용 절감',
  employee_experience_42:
    '프로세스를 간소화하여 비용 절감 및 수익 증가를 이끌어냅니다.',
  employee_experience_43: '훌륭한 EX는 비즈니스 성장을 이끕니다',
  employee_experience_44:
    '직원 경험(EX)은 직원들이 회사 내에서 겪고 느끼는 모든 것을 포함합니다.',
  employee_experience_45:
    '긍정적인 EX는 회사 목표와의 일치를 촉진하고, 동기를 부여하며, 참여를 이끌어냅니다.',
  employee_experience_46:
    '행복하고 참여하는 직원들은 뛰어난 서비스를 제공하여 만족한 고객과 지속 가능한 성장을 이끕니다.',
  employee_experience_47:
    'EX에 대한 투자로 파급 효과가 발생합니다 - 더 나은 유지율, 증가한 생산성, 그리고 더 강력한 비즈니스 성과.',
  employee_experience_48:
    '귀하의 EX + CX는 귀하의 비즈니스에 직접적인 영향을 미칩니다',
  employee_experience_49:
    '직원 경험(EX)과 고객 경험(CX)은 손에 손을 맞잡고 있습니다. 만족한 팀은 더 나은 고객 만족으로 이어지는 뛰어난 서비스를 제공할 가능성이 큽니다. 우리의 통합된 EX 및 CX 접근법을 통해 내부 문화를 외부 고객 서비스 우수성과 일치시킬 수 있습니다.',
  employee_experience_50:
    '직원 경험과 고객 경험 통찰을 통합하여 두 가지 모두를 향상시키는 포괄적인 접근법을 제공합니다. 그 결과는 비즈니스 성공을 촉진하는 더 강력하고 응집력 있는 회사 문화입니다.',
  employee_experience_51: '행복한 고용주',
  employee_experience_52: '우수한 서비스',
  employee_experience_53: '행복한 고객',
  cati_1: 'CATI',
  cati_2: '효율적인 컴퓨터 보조 전화 조사',
  cati_3: '문의하기',
  cati_4: '신뢰받는',
  cati_5:
    '<b>CATI (컴퓨터 보조 전화 인터뷰)</b>는 전화 조사를 이용한 데이터 수집 방법으로, 운영자가 특수 소프트웨어를 사용하여 응답을 기록하고, 질문 논리를 보장하며, 결과를 분석합니다.',
  cati_6: '4Service의 CATI 주요 장점:',
  cati_7: '<b>조사 속도</b>',
  cati_8: '<b>높은 데이터 품질</b>',
  cati_9: '<b>설문지 맞춤화</b>의 유연성',
  cati_10: '<b>프로세스 자동화</b>',
  cati_11: '품질 관리를 위한 <b>다양한 도구</b>',
  cati_12: '<b>접근하기 어려운 범주</b>의 응답자 조사 가능',
  cati_13: '모든 <b>대화</b>를 <b>기록</b>하여 추후 검토',
  cati_14: '큰 대상 청중을 <b>빠르게 도달</b>할 수 있는 능력',
  cati_15: '다른 데이터 수집 방법에 비해 <b>비용 효율적</b>',
  cati_16: '해결',
  cati_17: '전화 조사로 해결할 수 있는 과제:',
  cati_18:
    '<span>시장 세분화 조사.</span> 정확한 타겟팅과 효과적인 마케팅 전략을 위한 다양한 소비자 그룹 식별',
  cati_19:
    '<span>고객 만족도 평가.</span> SCI, NPS 지표를 사용하여 제품 및 서비스에 대한 소비자 충성도 측정',
  cati_20:
    '<span>NPS 관리 및 실행 계획.</span> 전화 조사를 사용하여 고객 경험을 적극적으로 개선',
  cati_21:
    '<span>수요 및 시장 동향 분석.</span> 제품 및 서비스의 인기 조사, 유망한 지역 및 성장 방향 식별',
  cati_22:
    '<span>경쟁 환경 분석.</span> 시장에서 브랜드 위치 평가, 경쟁업체와 비교 및 성장 기회 식별',
  cati_23: '대상',
  cati_24: 'CATI는 다음과 같은 대상에게 이상적입니다:',
  cati_25: '제품을 출시하는 회사',
  cati_26: '최신 시장 데이터 수집, 경쟁 환경 분석 및 소비자 선호도 연구',
  cati_27: '고객과 함께 일하는 브랜드와 회사',
  cati_28:
    '고객 만족도 수준 평가 (고객 만족도, NPS), 요구 사항 분석 및 피드백 수집',
  cati_29: '소매업 및 전자상거래',
  cati_30:
    '소비자 행동 이해, 신제품 테스트 및 구매 결정에 영향을 미치는 요소 식별',
  cati_31: '은행 및 금융 기관',
  cati_32: '서비스 평가, 회사 신뢰도 측정 및 서비스에 대한 피드백 수집',
  cati_33: '사회적 조직',
  cati_34: '사회학적 연구 수행 및 여론 분석',
  cati_35: '정부 기관 및 NGO',
  cati_36: '통계 데이터 수집, 사회 문제 연구 및 연구 프로그램 시행',
  cati_37: '품질',
  cati_38: '전화 품질 평가 기준',
  cati_39: '기본적인 의사소통 기술',
  cati_40:
    '인사 및 전화 종료 기준 준수, 응답자가 편리하게 사용할 수 있는 언어로 전환',
  cati_41: '의사소통 스타일',
  cati_42:
    '발음 정확성, 공손함, 친근한 톤, 응답자와 신뢰 관계를 구축할 수 있는 능력',
  cati_43: '대화 관리',
  cati_44:
    '적극적인 경청 기법 사용, 응답자가 참여하도록 유도하고 대화를 효과적으로 이끌어가는 능력',
  cati_45: '주제 지식',
  cati_46:
    '설문 주제에 대한 깊은 이해와 추가적인 응답자 질문에 정확히 답할 수 있는 능력',
  cati_47: '설문지 작성 정확성',
  cati_48:
    '왜곡 없이 정확하게 응답을 입력하고, 지침을 따르며 설문지 작성 오류를 방지',
  cati_49: '왜 4Service인가',
  cati_50: '4Service의 CATI를 선택하는 이유는 무엇인가요?',
  cati_51:
    'CATI는 전화 조사를 통해 정확하고 구조화된 데이터를 얻으려는 회사에 적합합니다.',
  cati_52: '자체 연락처 센터',
  cati_53:
    '우리는 70,000건 이상의 성공적인 전화를 걸었으며 고객 요청 100% 충족률을 자랑합니다.',
  cati_54: '품질 보증',
  cati_55: '각 전화에 대해 100% 검증 – 데이터 정확성을 보장합니다.',
  cati_56: '개별 접근',
  cati_57: '특정 고객의 요구에 맞는 독창적인 설문지 개발',
  cati_58: '고급 소프트웨어',
  cati_59: '모든 복잡도의 CATI를 실행할 수 있는 VolPtime',
  cati_60: 'B2B와의 협업 경험',
  cati_61:
    '우리는 다양한 비즈니스 및 산업 분야의 주요 전문가들과 협업하며 법인과 함께 일합니다.',
  cati_62: '요청을 제출하면 귀하에게 가장 적합한 해결책을 찾아 드리겠습니다!',
  cati_63: '기술',
  cati_64:
    '우리는 결과를 분석하고 귀하의 비즈니스를 개선하는 최신 기술을 사용합니다.',
  cati_65: '기능:',
  cati_66: '<span>VolPtime</span> - 전문 소프트웨어',
  cati_67: '인바운드(핫라인)/아웃바운드 자동 라인 조직',
  cati_68: '운영자별 통계, 각 유형의 문의, 상담 지속 시간',
  cati_69: '연락처 센터 운영 실시간 모니터링',
  cati_70: '모든 전화 상담 음성 기록',
  cati_71: '원격 및 손쉬운 소프트웨어 구성',
  cati_72: '<span>Survey Monkey</span> - 설문지 프로그래밍을 위한 전문 서비스',
  cati_73: '다양한 복잡도의 설문지 프로그래밍',
  cati_74: '모든 연구 요구 사항을 고려하여',
  cati_75: '응답자에게 간단하고 명확하며 편안한 환경 제공',
  cati_76: '품질',
  cati_77: '고객과의 대화 품질 평가',
  cati_78: '체크리스트 기반 평가 시스템',
  cati_79:
    '서비스 품질은 특별한 체크리스트를 사용하여 측정되며, 품질 평가 직원들이 보고 기간 동안 평균 점수를 부여합니다.',
  cati_80: '목표 준수 지표',
  cati_81:
    '표준 준수는 설정된 수준을 기준으로 평가되며, 이는 90% 이하일 수 없습니다. 이 지표는 직원 경험에 따라 조정될 수 있습니다.',
  cati_82: '녹음 및 실시간 전화 모니터링',
  cati_83:
    '전화의 약 40%는 녹음에서 검토되고 20%는 실시간으로 검토되어 잠재적인 표준 위반에 신속하게 대응할 수 있습니다.',
  cati_84: '전문가들',
  cati_85: '우리는 자체 연락처 센터를 운영합니다.',
  cati_86: '연락처 센터 관리자',
  cati_87: '채용 관리자',
  cati_88: '우크라이나 원격 사이트',
  cati_89: '카자흐스탄 원격 사이트',
  cati_90: '기술 조정자',
  cati_91: '프로젝트 관리자',
  cati_92: '프로젝트 관리자',
  cati_93: '훈련 및 품질 관리 부서',
  cati_94: '운영자 – 60명 (20%는 영어에 능통)',
  cati_95: '운영자 – 20명',
  cati_96: '품질 관리 부서장',
  cati_97: '품질 관리 전문가',
  cati_98: '훈련 코치',
};
